/* jshint -W100 */
/*jshint scripturl:true*/
/* jshint shadow:true */
var $window = $(window);
var $document = $(document);
var $html = $('html');
var $body = $('body');
var countryValueField = document.getElementById('country_value') || false;
const NONE_LOWERCASE = 'none';
const preorderItemErrorId = '#preorderItemerror';


if(countryValueField && countryValueField.value === 'us'){
    $('.wcs-notification-box.wcs-tax-calculate .wcs-four.wcs-columns').width('161px');
    $('.wcs-tax-calculate').width('165px');
    $('.wcs-custom-bag .wcs-notification-box.wcs-tax-calculate').css('left','-300px');
}

var $newsletterEmailField = $('#wcs-newsletter-footer-signup-email');
$newsletterEmailField.focus(function(){
    var $welcomPromoError = $('.welcome_promo_error');
    if(!$welcomPromoError.is('.permanently-hide')){
        $welcomPromoError.addClass('permanently-hide');
        $newsletterEmailField.removeClass('ui-state-error');
        $newsletterEmailField.addClass('ui-state-valid');
    }
});
var currencyFormats = {
        'EUR':{
            thousandsSeparator: '.',
            decimalSeparator: ','
        },
        'USD':{
            thousandsSeparator: ',',
            decimalSeparator: '.'
        }
    };
window.bindShowHideTootip = function() {
    var $roxNoteTooltipIcon = $(".rox-note-tooltip-icon");
    const $roxPrescriptionTooltip = $(".rox-prescription-tooltip-wcs");
    let tooltipVisible = false

    function showTooltip() {
        $roxPrescriptionTooltip.show()
        tooltipVisible = true;
    }

    function hideTooltip() {
        $roxPrescriptionTooltip.hide()
        tooltipVisible = false;
    }

    function toggleTooltip() {
        tooltipVisible ? hideTooltip() : showTooltip()
    }

    if(!WcsBrowser.isIpad){
        $roxNoteTooltipIcon.off("hover").hover(showTooltip, void 0);
        $roxPrescriptionTooltip.off("hover").hover(void 0, hideTooltip);
        $roxNoteTooltipIcon.off("keydown").on("keydown", e => {
            if (e.key === "Enter" || e.keyCode === 13) {
                e.preventDefault();
                toggleTooltip();
            }
        });
        $roxNoteTooltipIcon.off("blur").on("blur", function () {
            if (tooltipVisible) {
                hideTooltip();
            }
        });
    }
    
    if(WcsBrowser.isIpad){
        $roxNoteTooltipIcon.off("click").on("click", showHideTooltipTablet);
        $roxPrescriptionTooltip.off("click").on("click",function(e){e.stopPropagation();});
        $body.on("touchstart", function(e) {
            var $srcElement = $(e.srcElement);
            if(!$srcElement.closest(".rox-lenstype-note-wrapper").length && !$srcElement.closest(".rox-prescription-tooltip-wcs").length) {
                if($roxPrescriptionTooltip.is(":visible")) $roxPrescriptionTooltip.hide();
            }
        });
    }
};
function currencyFormat(country){
    var chosenCurrencyFormat;
    switch(country){
        case 'BR':
        case 'NO':
        case 'BE':
        case 'FI':
        case 'PT':
        case 'DK':
        case 'NL':
        case 'TR':
        case 'PL':
        case 'FR':
        case 'ES':
        case 'CH':
        case 'AT':
        case 'IE':
        case 'DE':
        case 'IT':
            chosenCurrencyFormat = currencyFormats.EUR;
            break;

        case 'US':
        case 'CA':
        case 'AU':
        case 'GB':
        case 'CN':
        case 'MX':
        case 'HK':
            chosenCurrencyFormat = currencyFormats.USD;
            break;
        default:
            chosenCurrencyFormat = currencyFormats.EUR;
    }

    return chosenCurrencyFormat;
}
Number.prototype.formatMoney = function(decimalPlaces, decimalSeparator, thousandsSeparator){
    var self = this,
        decimalPlaces = isNaN(decimalPlaces = Math.abs(decimalPlaces)) ? 2 : decimalPlaces,
        decimalSeparator = decimalSeparator === undefined ? "." : decimalSeparator,
        thousandsSeparator = thousandsSeparator === undefined ? "," : thousandsSeparator,
        sign = self < 0 ? "-" : "",
        i = String(parseInt(self = Math.abs(Number(self) || 0).toFixed(decimalPlaces))),
        j = (j = i.length) > 3 ? j % 3 : 0;
        return sign + (j ? i.substr(0, j) + thousandsSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandsSeparator) + (decimalPlaces ? decimalSeparator + Math.abs(self - i).toFixed(decimalPlaces).slice(2) : "");
};
function getElementValueById(id) {
    var element = document.getElementById(id) || false;
    return element ? element.value : '';
}
function standardShippingMode() {
    var params={},
    orderId = getElementValueById('orderId'),
    currFmt = getElementValueById('currency'),
    valFree = getElementValueById('valFree'),
    country = getElementValueById('countryCode'),
    chosenCurrencyFormat,
    shipModeId = getElementValueById('wcs-shipping-selector-std') || $('.wcs-shipping-mode-right input:checked').val() || $('.wcs-shipping-mode-br input:checked').val(),
    fromPageName = $('input[name="fromPageName"]').val();
    params.orderId = orderId;
    params.shipModeId = shipModeId;
    params.giftCardFlag = "true";

    chosenCurrencyFormat = currencyFormat(country);

    if(undefined !== fromPageName){
        params.fromPageName = fromPageName;
    }

    if($('#country').val() === 'BR') {
        params.brazilZipCode = $('#zipcode').val();
    }

    $.ajax({
        type: "POST",
        url: "AjaxShipChargeUpdate",
        data: params,
        async: true,
        success: function(data) {
            displayDeliveryMessage()
                if ("object" != typeof data){
                    data = jQuery.parseJSON(data);
                }
                var $wcsShoppingTryonText = $('.wcs-shopping-total-text .wcs-shopping-tryon-text');
                var shippingCharge = data.orderDetails.TotalShipping;
                shippingCharge = (shippingCharge === undefined || shippingCharge === "undefined")? '' : shippingCharge;

                if(0 === parseFloat(shippingCharge.replace(',','.'), 10)){
                    $wcsShoppingTryonText.html(valFree);
                }
                else {
                    var d = currFmt + data.orderDetails.TotalShipping;
                    $wcsShoppingTryonText.html(d);
                }
                var totalTax = currFmt + data.orderDetails.TotalTax.toFixed(2);
                $(".wcs-shopping-total-tax").html(totalTax);
                data.orderDetails.TotalAmount=data.orderDetails.TotalAmount-data.orderDetails.TotalTax;
                var e = currFmt + " " + data.orderDetails.TotalAmount.formatMoney(2, chosenCurrencyFormat.decimalSeparator, chosenCurrencyFormat.thousandsSeparator);
                $(".wcs-shopping-grandtotal-js").html(e);

                if (Rayban && Rayban.AfterPay) {
                    Rayban.AfterPay.updateAfterpayAmount(
                        data.orderDetails.TotalAmount,
                        2,
                        chosenCurrencyFormat.decimalSeparator,
                        chosenCurrencyFormat.thousandsSeparator,
                        currFmt,
                        country
                    );
                }

                var $checkoutnow = $('#checkoutnow');
                var checkoutnow = $checkoutnow.attr('href');

                $("#shipModeId").val(shipModeId);
                  if(checkoutnow.indexOf('&shipModeId=') != -1){
                      checkoutnow =checkoutnow.split('&shipModeId=');
                      checkoutnow[0] = checkoutnow[0]+'&shipModeId='+shipModeId;

                      checkoutnow[1] = checkoutnow[1].substr(checkoutnow[1].indexOf('&'),checkoutnow[1].length);
                      $checkoutnow.attr('href',checkoutnow[0]+checkoutnow[1]);
                      if($('#country_value')=="us"){
                        var link='&city='+city,
                        x=$checkoutnow.attr('href'),
                        y=x.search('&city');
                        if(y!=-1){
                           $checkoutnow.attr('href',x.slice(0,y));
                            var z=$checkoutnow.attr('href');
                            $checkoutnow.attr('href',z.concat(link));
                        }
                        else{
                            $checkoutnow.attr('href',x+link);
                        }
                      }
                  }
        }
    });
}
function giftCardCheck(){

    var items = $(".wcsitems"),
        flag = true,
        eGift=$("input[name='egift']").val(),
        pGift=$("input[name='pgift']").val();

    items.each(function (index, el) {
      var currElText = $.trim($(el).text());
      if(currElText.indexOf(eGift) !== -1 || currElText.indexOf(pGift) !== -1) {

      } else {
        flag = false;
      }
    });

    if(flag) {
      standardShippingMode();
      $('.wcs-shipping-mode').addClass('wcs-hide');
    }
}

$.subscribe("afterRemoveShoppingCartItem", giftCardCheck);

/* Overall binding event functions */

function bindEvents() {

    //align with for info titles according to maximal width item
    $('.cart-item-info-container').each(function() {
        var currItem = $(this);
        var strongTags = currItem.find('strong:not(.including-title)');
        var maxWith = 0;
        strongTags.each(function() {
            var itemWidth = $(this).width();
            if(itemWidth > maxWith) {
                maxWith = itemWidth;
            }
        });
        strongTags.css('width', (maxWith + 5) + 'px');
    });

    /*
     * Check the quantity count on page load to change the (-) icon
     * color
     */
    $('.wcs-shopping-item-qtyCount').each(function() {
        var $this = $(this);
        var getQcount = parseInt($this.html());
        if (getQcount >= 2) {
            $this.prev().css('color', '#000');
        }
        if($.cookie('isCSRSession')){
            $this.on('blur', function(){
                onBlurUpdateQty(this);
            });
        }
    });
    /* Adding and removing item quantity in shopping cart */
    var manageQtyIncrementSymbol = function(qtyObj, qty) {
        if (qty) {
            var linkEl = qtyObj.siblings('.wcs-shopping-item-qtyMinus');
            if (qty > 1) {
                linkEl.addClass('wcs-on').removeClass('disable');
            } else {
                linkEl.removeClass('wcs-on').addClass('disable');
            }
        } else {
            $.each(qtyObj, function() {
                var $this = $(this);
                var linkEl = $this.siblings('.wcs-shopping-item-qtyMinus');
                if ($this.text() > 1) {
                    linkEl.addClass('wcs-on').removeClass('disable');
                } else {
                    linkEl.removeClass('wcs-on').addClass('disable');
                }
            });
        }

    };
    manageQtyIncrementSymbol($('.wcs-shopping-item-qtyCount'), '');
    $('.wcs-shopping-item-qtyPlus').each(function () {
        $this = $(this);
        qtyObj = $this.prev();
        availqty = $this.attr('rel').split("_")[2];
        getValue = parseInt(qtyObj.html()) + 1.0;
        var isRemix = false;
        var itemContentBlock = $this.closest('.wcs-shopping-item-content');
        var catentryIdNumber = itemContentBlock.find('.wcs-itemPrice-bag').attr('catentryrel');
        if (itemContentBlock.find(".wcs-remixed-label").length) {
            isRemix = true;
        }
        var maxPreorderQty = parseInt($('#maxPreorderProductsInCart').val());
        let isPreorder = false;
        if (itemContentBlock.find('.js-is-item-preorder').length) {
            isPreorder = true;
        }
        if ((isPreorder && (getValue > maxPreorderQty)) || (getValue > availqty && !isRemix)) {
            $this.addClass('wcs-qtyPlus-disabled');
        }
        //checking for the same catentryId item
        var theSameCatentryIdElements = $('[catentryrel = '+ catentryIdNumber + ']');
        if(theSameCatentryIdElements.length > 1) {
            theSameCatentryIdElements.each(function(index, el) {
                $(el).closest('.wcs-shopping-item-content').find('.wcs-shopping-item-qtyPlus').addClass('wcs-qtyPlus-disabled');
            });
        }
    });
    var $wcsShoppingItemQtyPlus = $(".wcs-shopping-item-qtyPlus");
    $wcsShoppingItemQtyPlus.off('click').on('click', function (e) {
        console.log("-- el clicked")
        $this = $(this);
        e.preventDefault();
        if (!($this.hasClass("disable"))) {
            $body.overlay();
            //$wcsShoppingItemQtyPlus.addClass('disable');
            $this.addClass('disable');
            totalCount = parseInt($("#itemTotal").html()) + 1;
            qtyObj = $this.prev();
            str = $this.attr('rel').split("_");
            price = str[0];
            count = str[1];
            availqty = str[2];
            storeId = str[3];
            getValue = parseInt(qtyObj.html()) + 1.0;
            var isRemix = false;
            if ($this.closest(".wcs-shopping-item-content").find(".wcs-remixed-label").length) {
                isRemix = true;
            }
            var maxPreorderQty = parseInt($('#maxPreorderProductsInCart').val());
            let isPreorder = false;
            if ($this.closest('.wcs-shopping-item-content').find('.js-is-item-preorder').length) {
                isPreorder = true;
            }
            if ((isPreorder && (getValue > maxPreorderQty)) || (getValue > availqty && !isRemix)) {
                $this.closest('.wcs-shopping-item-content').addClass('error-msg-opened');
                $body.overlayout();
            } else {
                newPrice = parseFloat(price) * getValue;
                itemId = qtyObj.attr('rel');
                configurationId = qtyObj.attr('rel-configurationId');
                orderIdToUpdate = qtyObj.attr('rel-order');
                // Added for tax story
                state = $("#state").val();
                zipCode = $("#zip_code").val();
                var fromPageName = $('input[name="fromPageName"]').val();
                if (undefined === fromPageName) {
                    fromPageName = "";
                }
                storeCurrentFreeGiftState();
                // End
                if(getValue && itemId && orderIdToUpdate && storeId ){
                    $.ajax({
                        url: "AjaxOrderItemUpdate?isCalculateViewRequired=true&doInventory=N&quantity=" + getValue + "&orderItemId=" + itemId + "&orderId=" + orderIdToUpdate + "&storeId=" + storeId + "&fromPageName=" + fromPageName,
                        async: false
                    }).done(function (response) {
                        // Added for tax calculation
                        /*  if((zipCode!=null && state!=null)&&(zipCode!=="" && state!=="")){
                                    tax_button_fn(false);}*/
                        $('#orderSummary').html(response);
                        ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                        if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                            if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                                ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                            }
                        }
                        checkFreeGiftState();
                        $("#subTotal").html($("#subTotalCalc").html());
                        $('.wcs-shipping-selector:checked').click();
                        //$("#wcs-price" + count).html('$'+ newPrice.toFixed(2));
                        //pricestrike changes
                        updateOfferprice();
                        //end of ps
                        $('.wcs-shopping-item-content').children().find('.wcs-itemListPrice-bag').each(function () {
                            var catId = $(this).attr('catentryrel');
                            var configurationId = $(this).attr('configurationIdrel');
                            $(this).html($("#wcs-listPrice_" + catId + "_" + (configurationId ? configurationId : '')).val());
                        });
                        $("#itemTotal").html(totalCount);
                        $('#wcs-bag-qty-text').html($('#qtyText').val());
                        qtyObj.html(getValue);
                        if ((isPreorder && (getValue >= maxPreorderQty)) || (getValue >= availqty && !isRemix)) {
                            $this.closest('.wcs-shopping-item-content').addClass('error-msg-opened');
                            $this.addClass('wcs-qtyPlus-disabled');
                            $body.overlayout();
                        }
                        if($('#promoremove').is(':visible')) {
                            $('#promoremove').addClass('wcs-shopping-hide')
                        }
                        setUrlInSession();
                        calculate_tax_fn();
                        checkout_giftcard_validation();
                        select_dropbox_value();
                        expand_dropbox();
                        collapse_dropbox();
                        dropscrollerFn();
                        key_nav_dropdown();
                        $.publish('ShopbagItemUpdate');
                        tax_submit_fn();
                        apply_promo_link_click();
                        apply_promo_idme_link_click();
                        idme_links();
                        promo_textbox_focusBlur();
                        apply_promotion();
                        remove_promotion();
                        checkGiftCardErrors();
                        checkRoxErrors();
                        checkRoxRemixErrors();
                        checkZeroPowerError();
                        checkRoxRemixCaseItemerror();
                        checkSupernovaError();
                        checkMixAndMatchErrors();
                        checkRemixOosError();
                        triggerRedLabel();
                        showHideRoxTooltip();
                        openLinksInNewTab();
                        window.bindShowHideTootip();
                        /* WCS CODE STARTS: MINI CART IN SHOP CART */
                        $('#wcs-cart-container').load("MiniCartView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function () {
                            add_to_bag_onload();
                            openLinksInNewTab();
                        });
                        /* WCS CODE ENDS: MINI CART IN SHOP CART */


                        $wcsShoppingItemQtyPlus.removeClass('disable');
                        manageQtyIncrementSymbol(qtyObj, totalCount);

                    if (getValue > 1 && $this.parents(".wcs-shopping-item-content").find(".wcsGiftMessage").val() == "Y") {
                        $this.parents(".wcs-shopping-item-content").find(".wcs-gw-warning").removeClass("wcs-hidden");
                    }
                    if (Rayban.AfterPay) {
                        Rayban.AfterPay.initOverlay();
                    }
                    $body.overlayout();
                    giftcard_bindevents_fn();
                    //sfs checking message
                    sfsMessageChecking();
                    var updateCart = new CustomEvent('addToBag', {detail: {}});
                    document.dispatchEvent(updateCart);

                    if($('.wcs-shipping-mode-pick-up-in-store-shipping').hasClass('wcs-shipping-mode-item--selected')){
                        const payPalButton = $('#DCartPageCheckoutExpPaypal');
                        const applePayButton = $('#DCartPageCheckoutExpApple');
                        const giftCardLink = $('#D_CartPage_GiftCard_Open').parents('.wcs-three.wcs-columns.wcs-fill.wcs-alpha');
                        const afterPayExpress = $('#afterpayExpress');
                        payPalButton.hide();
                        applePayButton.hide();
                        giftCardLink.hide();
                        afterPayExpress.hide();
                        console.log("Clicking pick up in store shipping method")
                        $('#wcs-shipping-selector-puis').click()
                    }
                    $('body').trigger('changeItemsQuantity');
                    return false;
                });
            }
            }
        }
    });
   
    console.log("-- listener added")
    /* WCS Code */
    $(".wcs-shopping-item-qtyMinus").off('click').on('click',function(e) {
        $('.selenium-shopping-item-qtyPlus').removeClass('disable');
        $this = $(this);
        e.preventDefault();
        if(!($this.hasClass("disable"))){
        $body.overlay();
            $this.addClass('disable');
        qtyObj = $(this).next();
        totalCount = parseInt($("#itemTotal").html()) - 1;
        str = $(this).attr('rel').split("_");
        price = str[0];
        count = str[1];
        availqty = str[2];
        storeId = str[3];
        getCvalue = parseFloat(qtyObj.html());
        getValue = getCvalue - 1.0;
        if (getValue < availqty) {
            if(!$.cookie("EyeMedLogin") || $.cookie("EyeMedLogin") !== "true"){
            $(this).parent('.wcs-shopping-item-qty').find('.wcs-shopping-item-qtyPlus').removeClass('wcs-qtyPlus-disabled');
            }
            var parentObj = $(this).closest(".wcs-shopping-item-content");
            parentObj.removeClass('error-msg-opened');
        }
        newPrice = parseFloat(price) * getValue;
        itemId = qtyObj.attr('rel');
        orderIdToUpdate = qtyObj.attr('rel-order');
        configurationId = qtyObj.attr('rel-configurationId');
        // Added for tax story
        state = $("#state").val();
        zipCode = $("#zip_code").val();
        // End
        if (getValue <= 1) {
            $(this).removeClass('wcs-on');
            $(this).addClass('disable');
            $body.overlayout();
        }
        if (getCvalue >= 2) {
            storeCurrentFreeGiftState();
            var fromPageName = $('input[name="fromPageName"]').val();
            if(undefined === fromPageName){
                fromPageName = "";
            }
            if(getValue && itemId && orderIdToUpdate && storeId){
                $.ajax({
                    url: "AjaxOrderItemUpdate?isCalculateViewRequired=true&doInventory=N&quantity=" + getValue + "&orderItemId=" + itemId + "&orderId=" + orderIdToUpdate + "&storeId=" + storeId + "&fromPageName=" + fromPageName,
                    async:false
                }).done(function(response) {
                    // Added for tax calculation
                    /*if((zipCode!=null && state!=null)&&(zipCode!=="" && state!=="")){
                                        tax_button_fn(false);}*/
                    $('#orderSummary').html(response);
                    ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                    if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                        if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                            ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                        }
                    }
                    checkFreeGiftState();
                    $("#subTotal").html($("#subTotalCalc").html());
                    $('.wcs-shipping-selector:checked').click();
                    //pricestrike changes
                    updateOfferprice();
                    //end of ps
                    $('.wcs-shopping-item-content').children().find('.wcs-itemListPrice-bag').each(function() {
                        var catId = $(this).attr('catentryrel');
                        var configurationId = $(this).attr('configurationIdrel');
                        $(this).html($("#wcs-listPrice_" + catId + "_" + (configurationId ? configurationId : '')).val());
                    });
                    $("#itemTotal").html(totalCount);
                    $('#wcs-bag-qty-text').html($('#qtyText').val());
                    if($('#promoremove').is(':visible')) {
                        $('#promoremove').addClass('wcs-shopping-hide')
                    }
                    checkGiftCardErrors();
                    checkRoxErrors();
                    checkRoxRemixErrors();
                    checkZeroPowerError();
                    checkRoxRemixCaseItemerror();
                    checkSupernovaError();
                    checkMixAndMatchErrors();
                    checkRemixOosError();
                    checkPreorderErrors();
                    checkCountdownEnd();
                    triggerRedLabel();
                    showHideRoxTooltip();
                    qtyObj.html(getValue);
                    setUrlInSession();
                    calculate_tax_fn();
                    checkout_giftcard_validation();
                    giftcard_bindevents_fn();
                    select_dropbox_value();
                    expand_dropbox();
                    collapse_dropbox();
                    key_nav_dropdown();
                    dropscrollerFn();
                    tax_submit_fn();
                    $.publish('ShopbagItemUpdate');
                    apply_promo_link_click();
                    apply_promo_idme_link_click();
                    idme_links();
                    promo_textbox_focusBlur();
                    apply_promotion();
                    remove_promotion();
                    openLinksInNewTab();
                    window.bindShowHideTootip();
                    /* WCS CODE STARTS: MINI CART IN SHOP CART */
                    $('#wcs-cart-container').load("MiniCartView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                        add_to_bag_onload();
                        openLinksInNewTab();
                    });
                    /* WCS CODE ENDS: MINI CART IN SHOP CART */
                    if(getValue == 1){
                        $this.addClass('disable');
                    }else{
                        $this.removeClass('disable');
                    }


                    if(getValue == 1 && $this.parents(".wcs-shopping-item-content").find(".wcsGiftMessage").val() == "Y" ) {
                        $this.parents(".wcs-shopping-item-content").find(".wcs-gw-warning").addClass("wcs-hidden");
                    }

                    if(roxInsuranceOverlayObj.isRoxInsEnabled){
                        roxInsuranceOverlayObj.check4MultipleItemsInCart();
                    }

                    if (Rayban.AfterPay) {
                        Rayban.AfterPay.initOverlay();
                    }

                $body.overlayout();
                //sfs checking message
                sfsMessageChecking();
                var updateCart = new CustomEvent('addToBag', {detail: {}});
                document.dispatchEvent(updateCart);

                if($('.wcs-shipping-mode-pick-up-in-store-shipping').hasClass('wcs-shipping-mode-item--selected')){
                    const payPalButton = $('#DCartPageCheckoutExpPaypal');
                    const applePayButton = $('#DCartPageCheckoutExpApple');
                    const giftCardLink = $('#D_CartPage_GiftCard_Open').parents('.wcs-three.wcs-columns.wcs-fill.wcs-alpha');
                    const afterPayExpress = $('#afterpayExpress');
                    payPalButton.hide();
                    applePayButton.hide();
                    giftCardLink.hide();
                    afterPayExpress.hide();
                    console.log("Clicking pick up in store shipping method")
                    setTimeout(function(){
                        $('#wcs-shipping-selector-puis').click()
                    }, 500)
                }
                $('body').trigger('changeItemsQuantity');
                return false;
            });
        }
    }
        }
        return false;
    });

    window.onBlurUpdateQty = function(el){
        qtyObj = $(el);
        $body.overlay();
        if(qtyObj.html() === '' || $.trim(qtyObj.html()) === '0'){
            qtyObj.html('0');
            $("#wcs-price1").html($("#subTotalCalc").html());
            qtyObj.closest('.wcs-modified-table').find('.wcs-shopping-item-remove').click();
        }
        $wcsShoppingItemQtyPlus.addClass('disable');
        totalCount = parseInt(qtyObj.html());
        str = qtyObj.prev().attr('rel').split("_");
        price = str[0];
        count = str[1];
        availqty = str[2];
        storeId = str[3];
        getValue = parseInt(qtyObj.html()) + 0.0;
        var isRemix = false;
        if(qtyObj.closest(".wcs-shopping-item-content").find(".wcs-remixed-label") && qtyObj.closest(".wcs-shopping-item-content").find(".wcs-remixed-label").length > 0) {
            isRemix = true;
        }
        if(getValue < availqty) {
            qtyObj.parent('.wcs-shopping-item-qty').find('.wcs-shopping-item-qtyPlus').removeClass('wcs-qtyPlus-disabled');
            var parentObj = qtyObj.closest(".wcs-shopping-item-content");
            parentObj.removeClass('error-msg-opened');
            if(!$(parentObj).find(".qty-stock-msg").hasClass("wcs-hide")) $(parentObj).find(".qty-stock-msg").addClass("wcs-hide");
        }
        if(getValue <= 1){
         qtyObj.prev().removeClass('wcs-on');
            qtyObj.prev().addClass('disable');
            $body.overlayout();
       }
        if (getValue > availqty && !isRemix) {
            qtyObj.next().addClass('wcs-qtyPlus-disabled');
            qtyObj.parent().parent().find(".qty-stock-msg div:nth-child(3)").html($("input[name='noQtyIncrementMsg']").val());
            qtyObj.parent().parent().find(".qty-stock-msg").removeClass("wcs-hide");
            $body.overlayout();
        } else {
            newPrice = parseFloat(price) * getValue;
            itemId = qtyObj.attr('rel');
            configurationId = qtyObj.attr('rel-configurationId');
            orderIdToUpdate = qtyObj.attr('rel-order');
            // Added for tax story
            state = $("#state").val();
            zipCode = $("#zip_code").val();
            storeCurrentFreeGiftState();
            // End
            if( getValue && itemId && orderIdToUpdate && storeId){
                $.ajax({
                    url: "AjaxOrderItemUpdate?isCalculateViewRequired=true&doInventory=N&quantity=" + getValue + "&orderItemId=" + itemId + "&orderId=" + orderIdToUpdate + "&storeId=" + storeId,
                    async:false
                }).done(function(response) {
                    // Added for tax calculation
                    /*  if((zipCode!=null && state!=null)&&(zipCode!=="" && state!=="")){
                                tax_button_fn(false);}*/

                    $('#orderSummary').html(response);
                    ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                    if (window.wcs_config.klarnaExpress.enabled === 'true') {
                        ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                    }
                    if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                        if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                            ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                        }
                    }
                    checkFreeGiftState();
                    $("#subTotal").html($("#subTotalCalc").html());
                    $('.wcs-shipping-selector:checked').click();
                    //$("#wcs-price" + count).html('$'+ newPrice.toFixed(2));
                    //pricestrike changes
                    updateOfferprice();
                    //end of ps
                    $('.wcs-shopping-item-content').children().find('.wcs-itemListPrice-bag').each(function() {
                        var catId = $(this).attr('catentryrel');
                        var configurationId = $(this).attr('configurationIdrel');
                        $(this).html($("#wcs-listPrice_" + catId + "_" + (configurationId ? configurationId : '')).val());
                    });
                    $("#itemTotal").html(totalCount);
                    $('#wcs-bag-qty-text').html($('#qtyText').val());
                    qtyObj.html(getValue);
                    setUrlInSession();
                    calculate_tax_fn();
                    checkout_giftcard_validation();
                    giftcard_bindevents_fn();
                    select_dropbox_value();
                    expand_dropbox();
                    collapse_dropbox();
                    dropscrollerFn();
                    key_nav_dropdown();
                    tax_submit_fn();
                    $.publish('ShopbagItemUpdate');
                    apply_promo_link_click();
                    apply_promo_idme_link_click();
                    idme_links();
                    promo_textbox_focusBlur();
                    apply_promotion();
                    remove_promotion();
                    checkGiftCardErrors();
                    checkRoxErrors();
                    checkRoxRemixErrors();
                    checkZeroPowerError();
                    checkRoxRemixCaseItemerror();
                    checkSupernovaError();
                    checkMixAndMatchErrors();
                    checkRemixOosError();
                    triggerRedLabel();
                    showHideRoxTooltip();
                    openLinksInNewTab();
                    window.bindShowHideTootip();

                    /* WCS CODE STARTS: MINI CART IN SHOP CART */
                    $('#wcs-cart-container').load("MiniCartView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                        add_to_bag_onload();
                        openLinksInNewTab();
                    });
                    /* WCS CODE ENDS: MINI CART IN SHOP CART */


                    $wcsShoppingItemQtyPlus.removeClass('disable');
                    manageQtyIncrementSymbol(qtyObj, totalCount);

                    if(getValue > 1 && qtyObj.parents(".wcs-shopping-item-content").find(".wcsGiftMessage").val() == "Y" ) {
                        qtyObj.parents(".wcs-shopping-item-content").find(".wcs-gw-warning").removeClass("wcs-hidden");
                    }

                    if (Rayban.AfterPay) {
                        Rayban.AfterPay.initOverlay();
                    }

                    $body.overlayout();
                    return false;
                });
            }

            }

    };

    window.shopping_share_btn = function() {
        $(".wcs-shopping-item-share").off('click').on('click', function(e) {
            var $this = $(this);
            $this.next().toggle();
            var span = $this.children().first();
            if (span.hasClass('wcs-shareplus-icon')) {
                span.toggleClass('wcs-shareminus-icon');
            } else {
                if ($(span).html() == "+") {
                    $(span).html("-");
                } else {
                    $(span).html("+");
                }
            }
            e.preventDefault();
        });
    };


    shopping_share_btn();

    /*
     * Function to the payment confirmation page, right side
     * collapsible panel
     */
    $cached.you_shopping_cart.off("click").on("click", function(ev) {
        if (ev.target.tagName.toLowerCase() === "a" && ev.target !== undefined) {
            return;
        }
        var $wcsDeliveryShoppingCartAccordian = $('.wcs-delivery-shopping-cart-accordian');
        $wcsDeliveryShoppingCartAccordian.find('> div').slideToggle("slow");
        $wcsDeliveryShoppingCartAccordian.find('> h5').find(".wcs-icon").toggleClass("wcs-icon-down-arrow");
        shoppingBagScrollerFn();
    });
    /* iscroll initiation for checkout delivery and payment pages*/
    var myShoppingBagScroll = [];
    window.shoppingBagScrollerFn = function() {
        var myShoppingBagScrollLength = myShoppingBagScroll.length;
        if (myShoppingBagScrollLength) {
            for (var i = 0; i < myShoppingBagScrollLength; i++) {
                myShoppingBagScroll[i].destroy();
            }
        }
        $('.wcs-shopping-scroller').each(function() {
            var $this = $(this);
        	id = $this.attr('id');
            ht = $this.height();
            var totalContainerHeight = $('.wcs-shopping-total-container').outerHeight();
            var minHeight = 427 - totalContainerHeight - $('.wcs-delivery-shopping-cart-accordian .wcs-pos-relative').outerHeight();
            shoppingTotalContainerHeight = totalContainerHeight;
            scrollerHeight = 427 - shoppingTotalContainerHeight;
            if (ht < minHeight) {
                $this.parent().css('height', ht + 'px');
            } else {
                $this.css('height', scrollerHeight + 'px').parent().css('height', scrollerHeight + 'px');
                myShoppingBagScroll.push(new iScroll(id, {
                    hScrollbar: false,
                    draggableScrollbars: true
                }));
            }
        });
    };
    $window.load(function() {
        var $shoppingItems = $('.wcs_shopping_items');
        var $asianfitRadio = $('#productFilterAsianFitContainer').find('.asianfit-radio');

        if ($shoppingItems.length) {
            $('.wcs-shopping-scroller').find('.wcs-product-description').addClass('clearfix');
            $shoppingItems.removeClass('wcs-hide');
            shoppingBagScrollerFn();
            $shoppingItems.hide();
            $cached.you_shopping_cart.trigger('click');
        }

        if($asianfitRadio.length){
            $asianfitRadio.RBRadio();
        }
    });

    /* Removing product by clicking on close(x) icon */

    /*
     * Removing product from product detail try by clicking on
     * close(x) icon
     */
    $('.wcs-remove-product').off('click').on('click', function(e) {
        _self = $(this);
        var has_try_on_cart = _self.parents('#try_on_cart').attr('id');
        _self.parent('div').parent('div').remove();
        if (has_try_on_cart) {
            var $hasTryOnCart = $('#' + has_try_on_cart);
            if (!$hasTryOnCart.children('div.wcs-shopping-item-content').length) {
                $hasTryOnCart.hide('slow');
                $('.wcs-try-on-home-deposite').remove();
            }
        }
    });
    /* Displaying relevant information by clicking on info(i) icon */
    if($html.hasClass('no-touch')){
       $cached.info_button.hover(function(e) {
            var $this = $(this);
            var hideClass = 'wcs-hidden';
            var isCardTypeAmex = $('#WC_PaymentInfoForm_creditCardNumber_1').hasClass('amex');
            var $includedParagraphs = $this.children('p');
            if ($this.hasClass('wcs-card-verification-icon')) {
                if (isCardTypeAmex) {
                    $this.find('.amex-info').toggleClass(hideClass);
                } else {
                    $this.find('.not-amex-info').toggleClass(hideClass);
                }
            } else {
                $includedParagraphs.toggleClass(hideClass);
                var middle_height = $this.children("p:not('.wcs-hide')").height() / 2;
                var notification_box_top = -middle_height + 12;
                $includedParagraphs.css('top', notification_box_top);
                $includedParagraphs.children('span.wcs-notification-arrow').css('top', middle_height - 10);
            }

        });
    }

    $('#WC_PaymentInfoForm_creditCardType').change(function() {
        var card_info_area = $('.wcs-icon.wcs-card-verification-icon');
        var selectedOption = this.options[this.selectedIndex];
        if ($(selectedOption).data('optionvalue') == 'AMEX') {
            card_info_area.addClass('wcs-card-verification-dark-icon');
            card_info_area.find('.amex-info').removeClass('wcs-hide');
            card_info_area.find('.not-amex-info').addClass('wcs-hide');
        } else {
            card_info_area.removeClass('wcs-card-verification-dark-icon');
            card_info_area.find('.amex-info').addClass('wcs-hide');
            card_info_area.find('.not-amex-info').removeClass('wcs-hide');
        }
    });

    var $WCPaymentInfoFormCreditCardNumber = $('#WC_PaymentInfoForm_creditCardNumber_1');
    if($WCPaymentInfoFormCreditCardNumber.val() !== ""){
        $WCPaymentInfoFormCreditCardNumber.trigger("keyup");
    }

    /* Removing freedelviery message for E-GiftCard Only Order from basket */
    window.remove_freeMessage = function() {
        var egcmessage = $("#eGiftcard").val();
        if (egcmessage == 'true') {
            $('#wcs-sc-subtitle').hide();
        }
    };

    /* Removing promotions from basket */
    window.remove_promotion = function() {
        var storeIdValue = $('#storeId').val();
        var orderIdValue = $('#orderId').val();
        var catalogIdValue = $('#catalogId').val();
        var langIdValue = $('#langId').val();

        $('.wcs-remove-promotion').off('click').on('click', function(e) {
            var promoCodeVal = $(this).attr('rel');
            var InsuranceWCSPromoCode = $('#InsuranceWCSPromoCode').val();
            var InsuranceRIAPromoCode = $('#InsuranceRIAPromoCode').val();
            var params = {};
            params.promoCode = promoCodeVal;
            params.orderId = orderIdValue;
            params.taskType = 'R';
            params.URL = "ShopCartDisplayView";
            params.isCalculateViewRequired = "true";
            params.promoAjax = "true";
            params.storeId = storeIdValue;
            var fromPageName = $('input[name="fromPageName"]').val();
            if(undefined !== fromPageName){
                params.fromPageName = fromPageName;
               }
            $.ajax({
                type: "POST",
                url: "AjaxPromotionCodeManage",
                data: params,
                success: function(response) {
                    $('#orderSummary').html(response);
                    ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                    if (window.wcs_config.klarnaExpress.enabled === 'true') {
                        ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                    }
                    if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                        if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                            ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                        }
                    }
                    if ($("#promoCodeErrorMessage").val() === "") {
                        $("#subTotal").html($("#subTotalCalc").html());
                        $('#wcs-apply-promo').removeClass('wcs-promotion-added');
                        $('.wcs-note-green').hide();
                        var $promoremove = $('#promoremove');
                        if(promoCodeVal === InsuranceRIAPromoCode || promoCodeVal === InsuranceWCSPromoCode){
                            $promoremove.removeClass('wcs-hide').find('#wcs-note-green_eyemed').removeClass('wcs-hide').show();
                            document.cookie = 'insPromotionRemovedPageReload=true';
                        }else{
                            $promoremove.removeClass('wcs-hide').find('#wcs-note-green').removeClass('wcs-hide').show();
                        }
                        $('#wcs-cart-container').load("MiniCartView?storeId=" + storeIdValue + "&catalogId=" + catalogIdValue + "&langId=" + langIdValue, function() {
                            openLinksInNewTab();
                        });
                    }
                    calculate_tax_fn();
                    checkout_giftcard_validation();
                    giftcard_bindevents_fn();
                    dropscrollerFn();
                    select_dropbox_value();
                    expand_dropbox();
                    collapse_dropbox();
                    key_nav_dropdown();
                    tax_submit_fn();
                    apply_promo_link_click();
                    apply_promo_idme_link_click();
                    idme_links();
                    promo_textbox_focusBlur();
                    apply_promotion();
                    remove_promotion();
                    dropscroller_hover_fn();
                    clearSessionStorage();
                    document.cookie = 'promotionRemovedPageReload=promotionRemovedPageReload';
                    //for update cart data after promo delete
                    updatePromoCartData(true);
                }
            }).done(function(resp) {
                $('body').trigger('changeItemsQuantity');
            });
            return;
        });
    };
    remove_promotion();
    // WishList logic


    var piAmount = $("#piAmount").val();
    if (piAmount === 0) {
        $(".pay_rayBan_giftCard").removeAttr('href');
        remove_required();

    }
    var payreload = $("#wcs-page-reload").val();

    var showBtn = localStorage.getItem('showBtn');
    var remainingToPay = Number($("#wcs-remainingtopay").val())
    if(payreload == "true" && remainingToPay === 0){
        $("#payment_mode_creditCard").hide();
        $("#payment_mode_klarna").hide();
        $("#payment_mode").hide();
        $(".empty-block").hide();
        $("#payment_confirm_giftCard").show();
    }
    else if(remainingToPay != 0 && showBtn === 'false'){
        $("#payment_mode_creditCard").show();
        $("#payment_mode").show();
    }

    if (payreload == "true" && $("#pcode").val() !== "") {
        $(".promotion_form").hide();
        $(".promotion-applied-container").show();
        $("#pcodeText").text($("#pcode").val());
        var promo_label = $(".promo-label").text();
        $("#pnameText").text(promo_label.split(":")[1]);
    }

    if (payreload == "true" && piAmount > 0) {
        //$(".pay_rayBan_giftCard").hide();
        //show_add_gift_card();
        //$(".applied_gift_card_template").removeClass("wcs-hide");
        //$(".gift_card_div").addClass("wcs-hide");
        //$(".applied_gift_card").show();
        //$(".add_gift_card").addClass("wcs-hide");
        //$(".gift_card_form").parent().addClass("wcs-hide");
        $(".gift-card-payment-section").removeClass("wcs-hidden");
        $(".applied_gift_card").show();
        $('.pay_with_giftCard').removeClass('wcs-hidden');
        hide_gift_card_form();
        $(".pay_rayBan_giftCard").eq(0).click();

    }





    $cached.add_gift_card.off("click").on("click", function() {
        _self = $(this);
        $('.gift_card_div').removeClass('wcs-hidden');
        $('.gift_card_form').toggleClass('wcs-hidden');
        $('.pin_1').val('');
        $('.giftcard_pin_number').val('');
        //_self.addClass('wcs-hidden');
    });
    /*
     * WCS INTEGRATED CODE-Add new Address click
     * function-Delivery page
     */
    $('.newAdd').on('click', function(e) {
        var currForm = $('a.newAdd').closest('form');
        $(".chinise-character-error-msg").hide();
        var $billingCountry = $("#billing-country");
        var countryname = $billingCountry.val();
        clear_form(currForm);
        $billingCountry.val(countryname);
        $billingCountry.addClass("ui-state-valid");
        currForm.find('#shipAddId').val("");
        currForm.find("#WC_State_DropDown").val("");
        currForm.find("#city").val("");
        currForm.find("#address_line_two").val("");
        currForm.find(".stateLabel").addClass("wcs-dropdown-validation").text("Select State");
        currForm.find("#selectAdd").val('Please select');
        currForm.find('.ca-advice').remove();
        $( "input[name='isAddrValidationDone']" ).val('false');
        //formValidation_onBlur();
        /******Delete address local storage on click of new address********/
        $("#delivery_information_form input[type != hidden][type != submit],#delivery_information_form select").each(function(index){
            var $this = $(this);
            var elemName = $this.attr("name") !== undefined ? $this.attr("name") : $this.attr("id");
            var fieldName = elemName.split("-")[0];
            var isBill = elemName.split("-")[1];
            var storageLabel = isBill == "bill"? "billing":"delivery";
            if(fieldName == "sameAsDeliveryAddress") {
                sessionStorage.removeItem("rayban."+$("#store").val()+".address.billing.same");
                $("#sameAsDeliveryAddress").attr('checked', true);
                $("#same_as_checked").val("yes");
                $("#isSameAddress").val("true");
                $("#billing_address_section").addClass("wcs-hide");
            }
            else {
                sessionStorage.removeItem("rayban."+$("#store").val()+".address."+storageLabel+"."+fieldName);
            }
        });
        if($('#langId').val()==-50 || $('input[name="langId"]').val()==-50){
            var $addressLineTwo = currForm.find('#address_line_two');
            var $addressLineTwoParents = $addressLineTwo.parents('.wcs-row');
            var $WCPaymentInfoFormAddress = currForm.find('#WC_PaymentInfoForm_address2_1');
            var $WCPaymentInfoFormAddressParents = $WCPaymentInfoFormAddress.parents('.wcs-row');

            $addressLineTwoParents.find('.wcs-error-message').removeClass('wcs-show');
            $addressLineTwoParents.removeAttr('style');
            $addressLineTwoParents.find(".exclamatory").hide();
            $addressLineTwo.addClass("ui-state-valid").removeClass("ui-state-error");

            $WCPaymentInfoFormAddressParents.find('.wcs-error-message').removeClass('wcs-show');
            $WCPaymentInfoFormAddressParents.removeAttr('style');
            $WCPaymentInfoFormAddressParents.find(".exclamatory").hide();
            $WCPaymentInfoFormAddress.addClass("ui-state-valid").removeClass("ui-state-error");

            $('#addFields #address_line_two').parents('.wcs-four').next().removeAttr('style');
            $('#billing_address_section #WC_PaymentInfoForm_address2_1').parents('.wcs-four').next().removeAttr('style');
            //$('.delivery-information-note-red').addClass('wcs-hide');
        }
        //Delivery page data persistent on Address select
         $("#delivery_information_form input[type != hidden],#delivery_information_form select, #delivery_information_form textarea").on("blur change", function(){
           window.populateAddressToLocalStorage(this);
        });

        sessionStorage.setItem(["rayban."+$("#store").val()+".address.delivery.field3SelectBoxChange"],sessionStorage.getItem(["rayban."+$("#store").val()+".address.delivery.field3SelectBox"]));
        sessionStorage.removeItem(["rayban."+$("#store").val()+".address.delivery.field3SelectBox"]);
        $('#field3').removeAttr('selectBoxOptions');

        sessionStorage.setItem(["rayban."+$("#store").val()+".address.billing.field3SelectBoxChange"],sessionStorage.getItem(["rayban."+$("#store").val()+".address.billing.field3SelectBox"]));
        sessionStorage.removeItem(["rayban."+$("#store").val()+".address.billing.field3SelectBox"]);
        $('#WC_PaymentInfoForm_addressField3_1').removeAttr('selectBoxOptions');
        validateMXForm();
    });
    /*
     * WCS INTEGRATED CODE-Ajax call for pre populating
     * addresses on Delivery Page
     */
    $('#selectAdd').on('change', function(e) {
        e.preventDefault();
        var ca_warn_msg_1=$('#ca_warn_msg_1').val(),
            ca_warn_msg_2=$('#ca_warn_msg_2').val();
        var id = $(this).val();
        if (id == 'Please select') {
            $('.newAdd').trigger('click');
        } else {
            var params = {};
            params.shippingAddId = id;
            params.userId = $('#shp_userId').val();
            params.orderId = $('#shp_orderId').val();
            params.storeId = $('#shp_storeId').val();
            params.isLastname=$('#isLastname').val();

            $.ajax({
                type: "POST",
                url: "ShippingAddressDisplayView",
                data: params,
                cache: false,
                async: false,
                success: function(response) {
                    var countryValue = $('#country_value').val();
                    var storeValue = $('#store').val();
                    var $zipCode = $('#zip_code');
                    $('#addFields').html(response);
                    $('#shipAddId').val(id);
                    $('#next').removeClass("wcs-btn-disable");//.attr('disabled', false);
                    $( "input[name='isAddrValidationDone']" ).val('false');
                    expand_dropbox();
                    select_dropbox_value();
                    key_nav_dropdown();
                    //formValidation_onBlur();
                    dropscroller_hover_fn();
                    zipcode_pattern($zipCode, countryValue);
                    country_selection();
                    sessionStorage.setItem(["rayban."+ storeValue +".address.delivery.field3SelectBox"],sessionStorage.getItem(["rayban."+ storeValue +".address.delivery.field3SelectBoxChange"]));
                    sessionStorage.setItem(["rayban."+ storeValue +".address.billing.field3SelectBox"],sessionStorage.getItem(["rayban."+ storeValue +".address.billing.field3SelectBoxChange"]));
                    if(countryValue == 'MX'){
                    validateMXForm();
                    }
                    // Tax calculation only for US and CA as per RB-2802
                    if(countryValue == 'US' || countryValue == 'CA'){
                        var memberId = $('#shp_userId').val();
                        var orderId = $('#shp_orderId').val();
                        var catalogId = $('#catalogId').val();
                        var storeId = $('#shp_storeId').val();
                        var zipCode=$zipCode.val();
                        var state = $('#WC_State_DropDown').val();
                        var langId = $('#langId').val();
                        var ajaxUrl = "AjaxOrderCalculate?orderId=" + orderId + "&calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-3&calculationUsageId=-4&catalogId=" + catalogId + "&langId=" + langId + "&storeId=" + storeId + "&zipCode=" + zipCode + "&state=" + state + "&memberId=" + memberId + "&isDeliveryAddressAdded=true&updatePrices=0&addressFlag=" + true;
                        if (zipCode !== null && state !== null) {
                            var $wcsShoppingTotalContainer = $('.wcs-shopping-total-container .odr-body');
                        //rb-9422
                        if(countryValue == 'US'){
                            $wcsShoppingTotalContainer.overlay();
                            $('#jqueryOverlayLoad').css({'top':'45%','left':'45%'});
                        }
                        //end of rb-9422
                            $.ajax({
                                type: "POST",
                                url: ajaxUrl,
                                cache: false,
                                async: false,
                                success: function(response) {
                                $('#chk_summary').load("CheckoutSummaryView?catalogId=" + catalogId + "&langId=" + langId + "&storeId=" + storeId+"&orderId="+orderId,null,function() {
                                    if(countryValue == 'US'){
                                        $wcsShoppingTotalContainer.overlayout();
                                    }
                                    var $promoLabel = $('.promo-label');
                                    if($promoLabel.length){
                                        $(".promo-val").css("height",$promoLabel.height());
                                    }
                                });

                               }
                            });
                        }
                    }
                    //rb-11432
                    var $wcsStateDropdownValidation = $('.wcs-state-dropdown-validation');
                    $('.ca-advice').remove();
                    if($wcsStateDropdownValidation.val() == 'CA') {
                        $wcsStateDropdownValidation.parent().parent('.wcs-four.wcs-columns.wcs-alpha').after('<p style="position:absolute;left: 375px;top: 7px;font-size:13px;min-width: 280px;" class="ca-advice">'+ ca_warn_msg_1 +' <a style="text-decoration:underline;" href="#">'+ ca_warn_msg_2 +'</a></p>');
                    }
                     //end of rb-11432
                    var $deliveryInformationForm = $('#delivery_information_form');
                    $deliveryInformationForm.find('input[type != hidden][type != submit], select, textarea').each(function(index){
                        populateAddressToLocalStorage(this);
                    });
                }

            });
        }
    });
    /*
     * WCS INTEGRATED CODE-Ajax call for pre populating
     * states on country select in delivery and payment page
     */
    window.country_selection = function() {
        var $countryBill = $('#country-bill');
        var countryVal = $countryBill.val();
        var $stateBill = $('#state-bill');
        if($stateBill.val() === ''){
            $stateBill.val(countryVal);
        }
        $countryBill.off('change').on('change', function(e) {
            e.preventDefault();
            var countryCode = $(this).val();
            var $stateClass = $('#WC_State_DropDown-bill');
            var params = {};
            params.countryCode = countryCode;
            $.ajax({
                type: "POST",
                url: "StateDropDownView",
                data: params,
                cache: false,
                async: false,
                success: function(response) {
                    var prevOptions = $stateClass.data('loaded-options');
                    if(!prevOptions || prevOptions !== response) {
                        $stateClass.html(response);
                        $stateClass.data('loaded-options', response);
                    }

                    var storeValue = $("#store").val();
                    var $stateDiv = $('#stateDiv');

                    if(countryCode == 'GB' || countryCode == 'FR' || countryCode == 'DE' || countryCode == 'BE' || countryCode == 'AT' || countryCode == 'PT' || countryCode == 'NL' || countryCode == 'PL' || countryCode == 'SE' || countryCode == 'DK' || countryCode == 'NO' || countryCode == 'FI' || countryCode == 'CH' ) {
                        $stateBill.val(countryCode);
                        $stateDiv.hide();
                        sessionStorage.removeItem("rayban." + storeValue + ".address.billing.state");
                    }
                    else {
                        $stateDiv.show();
                        var addressBillingStateFromSession = sessionStorage.getItem("rayban." + storeValue + ".address.billing.state");
                        if(null !== addressBillingStateFromSession){
                            $stateBill.val(addressBillingStateFromSession);
                            var newval = $stateClass.find('option[value=' + $stateBill.val() + ']');
                            newval.attr("selected","selected");
                            $stateBill.val( $stateClass.find('option:selected').val());
                        }else{
                        sessionStorage.setItem("rayban." + storeValue + ".address.billing.state", $stateClass.find('option:first').val());
                        $stateBill.val($stateClass.find("option:first").val());
                        }
                    }
                    var billingStateVar=$(response).filter('#billingState').val();
                    if(billingStateVar !== undefined){
                        $stateDiv.hide();
                        $stateBill.val(billingStateVar);
                        //sessionStorage.removeItem("rayban."+$("#store").val()+".address.billing.state");
                    }
                    var $stateClassOption = $stateClass.find('option');
                    var isEmpty = $stateClassOption.text();
                    var stateCode = $stateClass.val();
                    if($stateClass.hasClass("no-show-select")) {
                        $stateClass.removeClass("no-show-select");
                    }
                    var hidInput = "<input type='hidden' value='" + stateCode + "' name='billingState'/>";
                    if ($.trim(isEmpty) === "") {
                        var $stateClassParents = $stateClass.parents('.wcs-states');
                        $stateClassOption.text($stateClassOption.val());
                        $stateClass.attr('disabled', 'disabled');
                        $stateClass.toggleClass("no-show-select");
                        $stateClassParents.find('input[type="hidden"]').remove();
                        $stateClassParents.append(hidInput);
                    } else {
                        $stateClass.removeAttr('disabled');
                    }
                    expand_dropbox();
                    select_dropbox_value();
                    key_nav_dropdown();
                    //formValidation_onBlur();
                    dropscroller_hover_fn();
                    var $zipCodeBill = $('#zip_code-bill');
                    zipcode_pattern($zipCodeBill, countryCode);
                    var pattern = $countryBill.find('option:selected').data('zipregex');
                    $zipCodeBill.attr('pattern',pattern);
                }
            });
        });

        updateStateBill();
    };

    window.updateStateBill = function(){
        var $countryBill = $('#country-bill');
        var countryCode = $countryBill.val();
        var $stateDiv = $('#stateDiv');
        var $stateBill = $('#state-bill');
        var $WCStateDropDownBill = $('#WC_State_DropDown-bill');
        if(countryCode == 'GB' || countryCode == 'FR' || countryCode == 'DE' || countryCode == 'BE' || countryCode == 'AT' || countryCode == 'PT' || countryCode == 'NL' || countryCode == 'PL' || countryCode == 'SE' || countryCode == 'DK' || countryCode == 'NO' || countryCode == 'FI' || countryCode == 'CH' ) {
            $stateDiv.hide();
        }else{
            $stateDiv.show();
            if($stateDiv.is(':visible')){
                $stateBill.val($WCStateDropDownBill.find('option:selected').val());
            }else {
                var countryBillValue = $countryBill.val();
                $stateBill.attr('value', countryBillValue);
            }
        }
        $countryBill.trigger('change');
    };

    country_selection();

    /**
     * Observer pattern where the click of the selection will be
     * passed to the functions Publishing set
     */

    /* WCS CODE */
    $("#WC_State_DropDown-bill").off('click').on('click', function(){
        $('#state-bill').val($(this).val());
    });

    //added additional event "removeBagItemEvent" because "click.bag" event didn't work . 28-05-2020 by Ivakhnenko Denis
    $(".wcs-shopping-item-remove , .save-for-later").off('click.bag removeBagItemEvent').on('click.bag removeBagItemEvent',function() {
        const thisDataId=$(this).attr('data-element-id');
        tealium_data2track.push({
            id: 'Click',
            Tracking_Type: 'hiddenaction',
            Click_FocusElement: this,
            data_element_id: thisDataId,
        });
        var $this = $(this);
        var storeId = $("#storeId").val();
        var langId = $("#langId").val();
        sessionStorage.removeItem("rayban." + storeId + "." + langId + ".sidebar_refreshLS");
        sessionStorage.removeItem("rayban." + storeId + "." + langId + ".headerprofile_refreshLS");
        shopping_item_remove($this);
    });

    window.shopping_item_remove = function(obj) {
        // variables to handle error conditions
        $body.overlay();
        var count = $("#itemcount").val();
        fff = $("#check1").val();
        count = parseInt(count) - 1;
        qtyObj = obj;
        var getAttrId = obj.attr("data-element-id");
        itemId = qtyObj.attr('rel');
        orderIdToDelete = qtyObj.attr('rel-order');
        configurationId = qtyObj.attr('rel-configurationId');
        roxSet = qtyObj.attr('rel-roxSet');
        var uniqueId= qtyObj.attr('rel');
        var partNumber = $('input#wcs_remove_UPC_'+uniqueId).val();
        var categoryItem = $('input#wcs_remove_Category_'+uniqueId).val();
        var textForMessage = obj.closest('.wcs-shopping-item-content').find('.wcs-product-title').text();
        // Wishlist
        catEntryId = qtyObj.attr('catEntryId');
        // end Wishlist
        storeCurrentFreeGiftState();
        //analytics prods delete track
        function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
        if (getAttrId !== 'X_X_Prods_SaveForLater') {
            tealium_data2track.push({
                id: 'Prods-Delete',
                Products: _defineProperty({}, partNumber, {
                    Category: categoryItem
                })
            });
        }
        var fromPageName = $('input[name="fromPageName"]').val();
        if(undefined === fromPageName){
            fromPageName = "";
        }

        if(itemId && orderIdToDelete){
            $('.save-for-later.no-wish-list').css("pointer-events","none");
            $.ajax({
                url: "AjaxOrderItemUpdate?isCalculateViewRequired=true&doInventory=N&quantity=0&orderItemId=" + itemId + "&orderId=" + orderIdToDelete + "&isDeleteFromCart=true" + "&fromPageName=" + fromPageName,
                async:true
            }).done(function(response) {
                $('.save-for-later.no-wish-list').css("pointer-events","");

                $.publish("removeItemFromCart", {
                    objectId: itemId
                });
                $('#orderSummary').html(response);
                ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                if (window.wcs_config.klarnaExpress.enabled === 'true') {
                    ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                }
                if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                    if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                        ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                    }
                }
                var removedItemFromCartEvent = new CustomEvent('removeFromCart', {'detail':{'catentryId': catEntryId, 'orderItemId': itemId}});
                document.dispatchEvent(removedItemFromCartEvent);
                $('.wcs-shipping-selector:checked').click();
                //pricestrike changes
                updateOfferprice();
                //end of ps
                updateShippingMessages();
                checkFreeGiftState();
                if ($('#inputLineIDForDMP').length > 0 && itemId == $('#inputLineIDForDMP').val()) {
                    window.refresh_DMP_LineId('');
                }
                calculate_tax_fn();
                checkout_giftcard_validation();
                giftcard_bindevents_fn();
                dropscrollerFn();
                select_dropbox_value();
                expand_dropbox();
                collapse_dropbox();
                key_nav_dropdown();
                tax_submit_fn();
                $.publish('ShopbagItemUpdate');
                apply_promo_link_click();
                apply_promo_idme_link_click();
                idme_links();
                promo_textbox_focusBlur();
                apply_promotion();
                remove_promotion();
                remove_freeMessage();
                dropscroller_hover_fn();
                $("#subTotal").html($("#subTotalCalc").html());
                checkGiftCardErrors();
                checkRoxErrors();
                checkRoxRemixErrors();
                checkZeroPowerError();
                checkRoxRemixCaseItemerror();
                checkSupernovaError();
                checkMixAndMatchErrors();
                checkRemixOosError();
                checkPreorderErrors();
                checkCountdownEnd();
                triggerRedLabel();
                showHideRoxTooltip();
                $("#itemcount").val(count);
                openLinksInNewTab();
                window.bindShowHideTootip();
                if (Rayban.AfterPay) {
                    Rayban.AfterPay.initOverlay();
                }
                var promosu = $('#pcode').val();
                var storeIdValue = $('#storeId').val();
                var catalogIdValue = $('#catalogId').val();
                var langIdValue = $('#langId').val();
                var isWcsCustomBagExist = $('div.wcs-custom-bag').length;
                var $wcsFadeoutRightNav = $('div.wcs-fadeout-right-nav');
                var $wcsCartContainer = $('#wcs-cart-container');
                if (count === 0) {
                    $('.noItemClass').addClass('wcs-hide');
                    $("#sttitle").html(fff);
                    $('.empty-cart-header').removeClass('wcs-hide');
                    $('#shopping_cart_title, #orderSummary').hide();
                    $('.shipmentOptionsContainer').hide();
                    $('#noSummary').show();
                    // To hide the error message
                    $('.wcs-note-red').hide();
                    $('#wcs-sc-subtitle').hide();
                    setUrlInSession();
                    shoprunnerUpdateContent();
                    if (promosu !== '') {
                        var orderIdValue = $('#orderId').val();
                        var params = {};
                        params.promoCode = promosu;
                        params.orderId = orderIdValue;
                        params.taskType = 'R';
                        params.storeId = storeIdValue;
                        params.URL = "ShopCartDisplayView";
                        var fromPage = $('input[name="fromPageName"]').val();
                        if(undefined !== fromPage){
                            params.fromPage = fromPage;
                        }
                        $.ajax({
                            type: "POST",
                            url: "AjaxPromotionCodeManage",
                            data: params,
                            success: function(data) {
                                if (!data.hasOwnProperty('errorMessage') || data.errorMessage === null || data.errorMessage === "") {
                                    var newparams;
                                    newparams = "orderId=" + orderIdValue;
                                    newparams = newparams + "&calculationUsageId=-1";
                                    newparams = newparams + "&calculationUsageId=-3";
                                    newparams = newparams + "&updatePrices=1";
                                    newparams = newparams + "&URL=ShopCartDisplayView";

                                    $.ajax({
                                        type: 'POST',
                                        url: "OrderCalculate",
                                        data: newparams,
                                        success: function(result) {

                                            setUrlInSession();
                                            $wcsCartContainer.load("MiniCartView?storeId=" + storeIdValue + "&catalogId=" + catalogIdValue + "&langId=" + langIdValue, function() {
                                                add_to_bag_onload();
                                                openLinksInNewTab();
                                                if(isWcsCustomBagExist){
                                                    $wcsFadeoutRightNav.height($body.height() - 10);
                                                }
                                            });
                                            add_product_tostar_remove_from_basket(catEntryId, configurationId, roxSet, textForMessage);
                                            $body.overlayout();
                                        },
                                        error: function(xhr, ajaxOptions, thrownError) {
                                            Genericcallbackerror();
                                        }
                                    });

                                } else {}
                            },
                            error: function(xhr, ajaxOptions, thrownError) {

                            }
                        }).done(function(resp) {
                            $('body').trigger('changeItemsQuantity');
                        });

                        return;
                    }
                }
                setUrlInSession();
                $wcsCartContainer.load("MiniCartView?storeId=" + storeIdValue + "&catalogId=" + catalogIdValue + "&langId=" + langIdValue, function() {
                    add_to_bag_onload();
                    if(isWcsCustomBagExist){
                        $wcsFadeoutRightNav.height($body.height() - 10);
                    }
                    openLinksInNewTab();
                });
                var noToWishList = false;
                if(obj.hasClass('no-wish-list')) {
                    noToWishList = true;
                }
                add_product_tostar_remove_from_basket(catEntryId, configurationId, roxSet, textForMessage, noToWishList);
                tax_submit_fn();
                if (typeof displayDeliveryMessage === "function"){
                    displayDeliveryMessage();
                }
                dropscrollerFn();
                select_dropbox_value();
                expand_dropbox();
                collapse_dropbox();
                key_nav_dropdown();
                dropscroller_hover_fn();
                if(isWcsCustomBagExist){
                    $wcsFadeoutRightNav.height($body.height() - 10);
                }
                if(noToWishList) {
                    location.reload();
                }
                // $body.overlayout() is called in the rb.roxInsuranceOverlay.js

                return false;
            });
        }
    };



    /*
     * function to calculate count
     */
    window.getTotalItemCount = function() {
        totalCount = 0;
        $(".wcs-shopping-item-qtyCount").each(function() {
            totalCount = totalCount + parseInt($(this).html());
        });
        return totalCount;
    };

    /* Basket Page - Apply promo code, calculate tax publishing id */


    apply_promo_link_click();
    apply_promo_idme_link_click();
    idme_links();
    subscribeMessages();


    window.promotion_onload = function() {
        var $currEl = $(".promotion_code");
        if($currEl.length) {
            var $this = $(this);
            var ref = $currEl.attr("ref");
            var $giftCardForm = $('.gift-card');
            var $promotionCard = $(".promotion-card");
            if(ref.indexOf('giftcard') != -1 ){
                if ($('#piAmount').val() > 0) {
                    $promotionCard.addClass('wcs-hidden');
                    $giftCardForm.toggleClass('wcs-hidden');
                    if(!$giftCardForm.hasClass('wcs-hidden')){
                        $this.addClass('wcs-text-decoration-none');
                    }else {
                        $this.removeClass('wcs-text-decoration-none');
                    }

                    $('.gift_card_form input').val('');
                }
            }else {
                $giftCardForm.addClass('wcs-hidden');
                $promotionCard.toggleClass('wcs-hidden');
                if(!$promotionCard.hasClass('wcs-hidden')){
                    $this.addClass('wcs-text-decoration-none');
                }else {
                    $this.removeClass('wcs-text-decoration-none');
                }
            }
            //formValidation_onBlur();
        }
    };

    // If promotion code is applied
    var applied_promo_val = $("#promo-val").val();
    var promoCodePresent = $("#promoCodePresent").val();
    if(applied_promo_val !== "" && applied_promo_val !== undefined ){
        //$(".pay_rayBan_giftCard").eq(1).click();
        promotion_onload();
        $(".promotion_form").hide();
        $(".promotion-applied-container").show();

        //Upadte the promotion success container values
        $("#pcodeText").text($("#pcode").val());
        $("#pnameText").text($("input[name='pname']").val());
        $(".promo-val").css("height",$(".promo-label").height());

    }

    calculate_tax_fn();
    giftcard_bindevents_fn();
    $('#wcs-calculate-tax-disabled').off('click').on('click', function(e) {
        e.preventDefault();
    });
    $('#wcs-recalculate-tax-disabled').off('click').on('click', function(e) {
        e.preventDefault();
    });





    /* This sets the facet parameters to the cookie so that it can be used to reload the page */
    window.updateReloadFacetCookie = function(params) {


        /* Create a cookie with page id and all parameters plus page id
         * Do only if there is a page id available  as it needs to be done only for PLV /CLV pages and not for search
         *  */
        var $pageIdentifier = $('#pageIdentifier');
        if ($pageIdentifier.length) {

            /* Delete existing cookie */
            SetCookie("ReloadFacetCookie", "", -1);

            /* The cookie format will be as below
             * pageIdentifier--facet=xf_mopsp_ntk:"value",facet=xf_mopsp_ntk:"value",totalPageSize=24
             *
             * pageIdentifier is preceded with a separator $$ and all parameters succeed
             * If a a pagination is to be applied we will maintain a  totalPageSize as the total page size rendered.
             * that is if pagesize is
             * */
            if (params !== undefined && params.indexOf('facet') != -1) {
                var pageID = $pageIdentifier.val();
                SetCookie("ReloadFacetCookie",
                    pageID + "#" + params, 1);
            }


        }

    };

    /* Ajax load to replace the div content */
    window.loadPanels = function(url, params, srcDivs, destDivs, type, append, isApplyFilter) {

        //console.log('params '+ params);
        /* To update reload facet cookie
         * PN: This function call needs to be plcaed before the params.replace code below  */
        var pageIdentifier = $('#pageIdentifier').val();
        if (pageIdentifier !== undefined && pageIdentifier.indexOf('clearance') == -1) {
            //avoiding saving the clearance plp selected filter in cookie.
            updateReloadFacetCookie(params);
        }

        var orderbyValue = '';

        if (params !== undefined && params.length > 0) {
            if(params.indexOf(",")!=-1)
                params = params.replace(/,/g, '&');
            else
                params = '&' + params;
        }

        var paramsVar = params.replace(/facet=/g, '|');

        paramsVar = paramsVar.replace(/&/g, '');

        if(paramsVar !== "" ){
        url = url + '&facetsInOrder=' + paramsVar;
        }
        else{
            url = url + '&facetsInOrder=' + "empty";
        }
        var activePanel = $('a.wcs-filter-link.wcs-active').attr('id');
        /* Add loading icon */
        var filterTypeText = "";
        if(isApplyFilter == "1") filterTypeText = $("#applyFilterText").val();
        else filterTypeText = $("#removeFilterText").val();
         var filterSelectedTemplate = Rayban.templates.filter_selected_template;
         if(!$('.wcs-filter-type').length && !$('.wcs-filter-link').hasClass('wcs-active')){
            $('#wcs-filter-bar-container').append(filterSelectedTemplate({}));
         }
        var loading_icon_black = '<div class="wcs-loading-icon-wrapper" id="wcs-facet-loading"><img class="wcs-loading-icon" src="/wcsstore/RayBanStorefrontAssetStore//images/loading-black.gif"></div>';
        var loading_search_grey = $('<div class="wcs-loading-search" id="wcs-loading-search"><div class="applying-filter-text">'+filterTypeText+'</div></div>');
        var loading_search_black = $('<div class="wcs-loading-search-black" id="wcs-loading-search-black"></div>');
        var filter_ht = 0;
        var $categoryListingMain = $('#categoryListingMain');
        var $wcsLoadingSearch = $("#wcs-loading-search");
        var $wcsFacetLoading = $('#wcs-facet-loading');
        var pageTypeValue = $("#pageType").val();
        if ($('div.wcs-filter-type').length < 1) {
            loading_search_grey.css({
                'top': '0'
            });
        } else {
            filter_ht = $('div.wcs-filter-type').height();
            loading_search_grey.css({
                'top': -filter_ht + 'px'
            });
        }
        if (destDivs) {
            var $facetDivArea = $('#facetDivArea');
            var facetDivAreaHeight = $facetDivArea.height();
            loading_search_grey.height(facetDivAreaHeight + filter_ht);
            loading_search_black.height($categoryListingMain.height());
            if (facetDivAreaHeight + filter_ht < 100) {
                loading_search_grey.addClass('wcs-loading-search-35');
            } else {
                loading_search_grey.addClass('wcs-loading-search-50');
            }
            $facetDivArea.append(loading_search_grey);
            $categoryListingMain.append(loading_search_black);
            var filterLoadingMessageWidth = ($("#wcs-loading-search .applying-filter-text").width() + 17) / 2;
            $("#wcs-loading-search .applying-filter-text").css("transform", "translate(-" + filterLoadingMessageWidth + "px, 0)");
            $(".wcs-loading-search-35").css("background-position-x", "calc(50% - " + filterLoadingMessageWidth + "px)");
            if ($("#wcs-loading-search").height() > 10){
                var filterLoadingMessageWidth = ($("#wcs-loading-search .applying-filter-text").width() + 34) / 2;
                $("#wcs-loading-search .applying-filter-text").css("top", (($("#wcs-loading-search").height())/2)-12);
                $(".wcs-loading-search-50").css("background-position-x", "calc(50% - " + filterLoadingMessageWidth + "px)");
            }
        }
        if($("#FrameShape").hasClass("filter-container-position-top")){
            $wcsLoadingSearch.addClass("filter-overlay-position-top");
            $wcsLoadingSearch.height($(".wcs-filter-container").height());
        }else{
            $wcsLoadingSearch.removeClass("filter-overlay-position-top");
        }
        $wcsFacetLoading.remove();
        $categoryListingMain.append(loading_icon_black);

        if(pageTypeValue == 'SearchResults'){
            params += '&searchTerm='+ getUrlParameter('searchTerm');
            params += '&pageSize='+ parseInt($("#pageSize").val());
        }
        var applyingTextElement = $wcsLoadingSearch.find('.applying-filter-text');
        if($('.wcs-filter-link').hasClass('wcs-active')){
            applyingTextElement.show();
        }else{
            applyingTextElement.hide();
        }
        $.ajaxq("FacetAjax", {
            url: url,
            type: type,
            data: params,
            dataType: 'html',
            success: function(data) {
                $("#wcs-loading-search-black").remove();
                var anyContainerVisible = false;
                //remove next page hidden value as new value comes
                var $nextPagePLV = $('#nextPagePLV');
                if ($nextPagePLV.length) {
                    $nextPagePLV.remove();
                }

                // put totalCountFacets in input hidden for analitycs
                var JsonResp = JSON.parse(data);
                var totalProducts = JsonResp.totalCount;
                var $totalCountFacets = $('#totalCountFacets');
                if ($totalCountFacets.length) {
                  $totalCountFacets.remove();
                }
                $('input[type=hidden]').last().after('<input type="hidden" id="totalCountFacets" value="' + totalProducts + '" />');

                //Remove loading icon
                $wcsFacetLoading.remove();
                $wcsLoadingSearch.removeClass("filter-overlay-position-top");
                $wcsLoadingSearch.height(0);
                applyingTextElement.hide();
                // if destination div is empty
                var $hbsEnabled = $('#hbsEnabled');
                var isHbsEnabled = $hbsEnabled.length && $hbsEnabled.val() == 'true';
                if (destDivs === undefined) {
                    loadOrAppendHTML(srcDivs[0], data, append);

                } else if(isHbsEnabled){
                    data = data.replace(/&amp;/g, '&');
                    var jsonData = $.parseJSON(data);
                    var facets = $.parseJSON(jsonData.facets);
                    var productData = new Array($.parseJSON(jsonData.products));
                    if(jsonData.facets === undefined){
                        $wcsLoadingSearch.remove();
                        return;
                    }

                    //Find the selction section of the div, before updating each filter section
                    var selectedSection = "";
                    $(".wcs-filter-inner-container").children("div").each(function(indx, child){
                        if($(child).is(":visible")){
                            selectedSection = $(child).attr("class");
                            selectedSection = selectedSection.replace(" clearfix", "");
                        }
                    });


                    window.plpView.render(productData);
                    window.facetView.render(facets);

                    if(jsonData.totalCount){
                        $("#shownProductCount .totalCount").text(" "+jsonData.totalCount);
                        $(".product-count").text(" "+jsonData.totalCount+" ");
                    }

                    $('div.wcs-loading-search').remove();
                    if(selectedSection !== "")
                        $("."+selectedSection).show();

                    var newURL;

                    if(pageTypeValue === "SearchResults"){
                        var allParams = params.split('&');
                        params = '';
                        $.each( allParams, function( key, value ) {
                            if(allParams[key].indexOf('facet')!=-1){
                                if(params === ''){
                                    params = allParams[key];
                                }else{
                                    params = params +'&'+ allParams[key];
                                }

                            }
                        });

                        if(params !== "") {
                            params = "&" + params;
                        }
                    }


                    var loactionParams = location.search;
                    if (loactionParams.indexOf("orderBy=") != -1){
                      var orderString = 'orderBy=';
                      orderbyValue = location.href.substring(location.href.indexOf('orderBy') + orderString.length, location.href.indexOf('orderBy') + orderString.length + 1);
                    }
                    if(loactionParams.length === 0){
                        newURL = location.origin + location.pathname + "?" + params.replace("&", "");
                    }else {

                        if(params.length > 0 && params.charAt(0) != "&")
                            params = "&" + params;

                        if(loactionParams.indexOf("?facet=")!=-1){
                            if(params=== ""){
                                loactionParams = "";
                            }else{
                                loactionParams = loactionParams.replace(/facet=[^ ]+/, params.substring(1));
                            }

                        }else {
                            if(loactionParams.length > 0 && loactionParams.indexOf("&facet=")==-1){
                                loactionParams += params;
                            }else{
                                loactionParams = loactionParams.replace(/&facet=[^ ]+/, params);
                            }


                        }
                        if(pageTypeValue !== "SearchResults"){
                            if(loactionParams.indexOf("?orderBy=")!=-1){
                                if(params=== ""){
                                    loactionParams = "";
                                }else{
                                    loactionParams = loactionParams.replace(/orderBy=[^ ]+/, params.substring(1));
                                }
                            }else {
                                if(loactionParams.length > 0 && loactionParams.indexOf("&orderBy=")!=-1){
                                    loactionParams = loactionParams.replace(/&orderBy=[^ ]+/, params);
                                }
                            }
                        }
                        newURL = location.origin + location.pathname + loactionParams;
                    }

                    history.pushState(null, null, newURL);

                    var loadMoreURL=jsonData.nextPageURL || "";
                    var $searchResultsLoadMoreContainer = $('#searchResultsLoadMoreContainer');

                    if(loadMoreURL!==""){
                        loadMoreURL = loadMoreURL.split("amp;").join("");
                        $('#nextPageSearch').val(loadMoreURL);
                        searchResultsLoadMoreContainer();

                        $searchResultsLoadMoreContainer.show();
                    }else {
                        $searchResultsLoadMoreContainer.hide();
                    }

                }else{
                    for (i = 0; i < srcDivs.length; i++) {
                        var getDataAttr = $(data).filter("div[id=" + destDivs[i] + "]");
                        if ("facetDivArea" == destDivs[i]) {
                            var containerDivs = $('div#facetDivArea>div#FrameShape>div.wcs-filter-inner-container').children();
                            for (j = 0; j < containerDivs.length; j++) {
                                if ($(containerDivs[j]).is(':visible')) {
                                    anyContainerVisible = true;
                                    var className = $(containerDivs[j]).attr('class').split(' ')[0];
                                    $(getDataAttr).find('.' + className).show();
                                }
                            }
                        }
                        var getHTMLtoDiv = getDataAttr.html();
                        loadOrAppendHTML(srcDivs[i], getHTMLtoDiv, append);
                    }
                    if (checkedFiltersArray !== undefined) {
                        var checkboxNo = $('.wcs-filter-check.wcs-f-on').length;
                        var checkedFiltersArrayLength = checkedFiltersArray.length;
                        for (l = 0; l < checkboxNo; l++) {
                            var $checkBox = $($('.wcs-filter-check.wcs-f-on')[0]);
                            var checkBoxAttr = $checkBox.parent().parent().attr('data_facet-id');
                            if ((checkBoxAttr === undefined) || (checkBoxAttr != 'wcs-frame-color')) {
                                $checkBox.removeClass('wcs-f-on');
                            }
                        }
                        for (k = 0; k < checkedFiltersArrayLength; k++) {
                            (function (k) {
                                var $inputParent = $('input[value="' + checkedFiltersArray[k] + '"]').parent();
                                if($inputParent.find('span').eq(1).html() === '0') {
                                    $inputParent.addClass('wcs-f-on-disabled');
                                } else {
                                    $inputParent.addClass('wcs-f-on');
                                }
                            })(k);
                        }
                    }
                    if (checkedDivs !== undefined) {
                        var checkboxNo = $('.wcs-filter-frame.wcs-check').length;
                        for (l = 0; l < checkboxNo; l++) {
                            var checkBox = $('.wcs-filter-frame.wcs-check')[0];
                            $(checkBox).removeClass('wcs-check');
                        }
                        for (k = 0; k < checkedDivs.length; k++) {
                            $('span.' + checkedDivs[k]).parent().addClass('wcs-check');
                        }
                    }
                }
                open_filter();
                close_filter();
                initialize_products_over();
                initialize_products_out();
                /*- Fix for RB-8001-*/
                $(".wcs-quick-buy-full-click").off('click').on('click', function(e) {
                    var $this = $(this);
                    if(!window.newTabEnabled){
                        window.location.href = $this.data("url");
                        e.preventDefault();
                    }else if(e.target===this){
                        window.open($this.data('url'));
                    }
                });
                openLinksInNewTab();
                if (false === anyContainerVisible) {
                    var $activePanel = $("#" + activePanel);
                    $activePanel.addClass('wcs-active');
                    $activePanel.children('span').attr('style', 'display: block; top: 8px;');
                    anyContainerVisible = false;
                }
                resize_panel();
                resize_panel_header_footer();
                scroller();
                filter_frame();
                filterbar();
                sortBy_fn();
                openLinksInNewTab();
            },
            complete: function() {
                colorswatchsFn();
                position_filterpannel();
                scollInitiated = false;
                if (orderbyValue != ""){
                  updateUrlParameter("orderBy", orderbyValue);
                  updateUrlParameter("pageSize", $('#facetPageSize').val());
                }
            },
            error: function(data) {

            }
        });
    };

    $("#delivery_information .wcs-label-check:not(.group-input)").click(function () {
        setTimeout(function () {
            var $sameAsChecked = $("#same_as_checked");
            var $pickUpAddress = $('.pickUpAddress');
            var $deliveryAddress = $('.deliveryAddress');
            var $sameAsDeliveryAddress = $("#sameAsDeliveryAddress");
            if (wcs_config.storeId === '34153') {
                var $isRfcNeeded = $("#isRfcNeeded");
                if ($isRfcNeeded.is(":not(:checked)")) {
                    $sameAsChecked.val("yes");
                    $pickUpAddress.val("true");
                    $deliveryAddress.val("true");
                    $sameAsDeliveryAddress.val("yes");
                    updateStateBill();
                }
                else {
                    $sameAsChecked.val("no");
                    $pickUpAddress.val("false");
                    $deliveryAddress.val("false");
                    $sameAsDeliveryAddress.val("no");
                    updateStateBill();
                }
            } else {
                if ($sameAsDeliveryAddress.is(":checked")) {
                    $sameAsChecked.val("yes");
                    $pickUpAddress.val("true");
                    $deliveryAddress.val("true");
                    updateStateBill();
                }
                else {
                    $sameAsChecked.val("no");
                    $pickUpAddress.val("false");
                    $deliveryAddress.val("false");
                    updateStateBill();
                }
            }

        }, 500);
    });

 // Gift Wrap desktop Changes - START
    var isGiftwrapEnabled = $("#isgiftwrapItemEnabledDesktop").val() == "true";
    if(isGiftwrapEnabled) {
        var isExpressgiftwrapEnabled = $("#isExpressgiftwrapEnabled").val() == "true";
    if(isExpressgiftwrapEnabled) {
        var $wcsGiftwrapMessageConfirm = $('#wcs-giftwrap-message-confirm');
        var storeIdValue = $('#storeId').val();
        var orderIdValue = $('#orderId').val();
        var $personalMessage = $("#wcs-personalmessage-textarea");

        $wcsGiftwrapMessageConfirm.off("click").on("click", function (e){

            if($(this).hasClass("wcs-confirm-gray-button")){
                return;
            }
            var counter  =      $("#index").val();
            var giftwrap =      $("#giftWrap_" + counter).is(':checked');
            var giftmessage =   $personalMessage.val();
            var catentryId =    $("#giftWrapCatentryId_" + counter).val();
            var orderItemId=    $("#giftWrapOrderItemId_" + counter).val();
            var isCalculateViewRequired = $("#isCalculateViewRequired_" + counter).val();

            var params = "";
                params = params + "&orderId=" + orderIdValue;
                params = params + "&storeId=" +  storeIdValue;
                params = params + "&catEntryId=" +  catentryId;
                params = params + "&orderItemId=" + orderItemId;
                params = params + "&giftwrap=" + giftwrap;
                params = params + "&giftmessage=" + encodeURIComponent(giftmessage);
                params = params + "&isCalculateViewRequired=" + isCalculateViewRequired;
                params = params + "&doInventory=N";
                params = params + "&calculateOrder=1";
                params = params + "&calculationUsage=-1,-3,-2,-4";
            $.ajax({
                type: "POST",
                url: "AjaxGiftWrapCmd",
                data: params,
                success: function(response) {
                    $("#giftMessage_" + counter).val(giftmessage);
                    if(isCalculateViewRequired) {
                        $('#orderSummary').html(response);
                        ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                        if (window.wcs_config.klarnaExpress.enabled === 'true') {
                            ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                        }
                        if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                            if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                                ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                            }
                        }
                        $('#wcs-cart-container').load("MiniCartView?storeId=" + storeIdValue + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                            openLinksInNewTab();
                        });
                        calculate_tax_fn();
                        checkout_giftcard_validation();
                        giftcard_bindevents_fn();
                        dropscrollerFn();
                        select_dropbox_value();
                        expand_dropbox();
                        collapse_dropbox();
                        key_nav_dropdown();
                        tax_submit_fn();
                        apply_promo_link_click();
                        apply_promo_idme_link_click();
                        idme_links();
                        promo_textbox_focusBlur();
                        apply_promotion();
                        remove_promotion();
                        dropscroller_hover_fn();
                        $("#subTotal").html($("#subTotalCalc").html());
                        updateOfferprice();
                    }

                    $("#wcs_gw_personalmsg_pcp").removeClass("wcs-hidden").hide();
                    $(".wcs-fadeout-full").removeAttr("style");

                    $("#personalMessage_"+counter).hide();
                    $("#editPersonalMessage_"+counter).removeClass("wcs-hide");
                    //$("#editPersonalMessage_"+counter).parents(".wcs-tablerow").height(285);
                }
            });
        });


        $(".wcs-gw-exapandable-item-checkbox").each(function(count, chkBxObj){
            disaplyGiftWrap(count, chkBxObj);
        });

        //click
        $(".wcs-checkbox.wcs-giftwrap-checkbox").off().on("click", function(e){
            var el = e.currentTarget;
            var clickedChkBoxId = $(el).attr("refId");
            var $clickedChkBox = $("#"+clickedChkBoxId);
            var countArr = clickedChkBoxId.split("_");
            var count = countArr[1];
            var $modifiedMsg = $("#editPersonalMessage_" + count);
            var $defaultMsg  = $("#personalMessage_" + count);
            var giftwrap = false;

            if($clickedChkBox.val()== "on"){
                $clickedChkBox.val("off");
                giftwrap = false;
            }else {
                $clickedChkBox.val("on");
                giftwrap = true;
            }

            if($clickedChkBox.val()== "off"){
                $modifiedMsg.addClass("wcs-hide");
                $defaultMsg.addClass("wcs-hide");
                //$defaultMsg.parents(".wcs-tablerow").height(245-21);
            }else {
                disaplyGiftWrap(count, $clickedChkBox);
            }

            var giftmessage = $("#giftMessage_" + count).val();
            var catentryId = $("#giftWrapCatentryId_" + count).val();
            var orderItemId= $("#giftWrapOrderItemId_" + count).val();
            var isCalculateViewRequired = $("#isCalculateViewRequired_" + count).val();


            var params = "";
                params = params + "&orderId=" + orderIdValue;
                params = params + "&storeId=" +  storeIdValue;
                params = params + "&catEntryId=" +  catentryId;
                params = params + "&orderItemId=" + orderItemId;
                params = params + "&giftwrap=" + giftwrap;
                params = params + "&giftmessage=" + giftmessage;
                params = params + "&isCalculateViewRequired=" + isCalculateViewRequired;
                params = params + "&doInventory=N";
                params = params + "&calculateOrder=1";
                params = params + "&calculationUsage=-1,-3,-2,-4";

            $.ajax({
                type: "POST",
                url: "AjaxGiftWrapCmd",
                data: params,
                success: function(response) {
                    if(isCalculateViewRequired) {
                          $('#orderSummary').html(response);
                          ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                        if (window.wcs_config.klarnaExpress.enabled === 'true') {
                            ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                        }
                        if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                            if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                                ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                            }
                        }
                          $('#wcs-cart-container').load("MiniCartView?storeId=" + storeIdValue + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                          openLinksInNewTab();
                      });
                     calculate_tax_fn();
                     checkout_giftcard_validation();
                     giftcard_bindevents_fn();
                     dropscrollerFn();
                     select_dropbox_value();
                     expand_dropbox();
                     collapse_dropbox();
                     key_nav_dropdown();
                     tax_submit_fn();
                     apply_promo_link_click();
                     apply_promo_idme_link_click();
                     idme_links();
                     promo_textbox_focusBlur();
                     apply_promotion();
                     remove_promotion();
                     dropscroller_hover_fn();
                     $("#subTotal").html($("#subTotalCalc").html());
                     var updatedcounter = Number(count)+1;

                     $("#wcs-price"+ updatedcounter).html($("#orderItemPrice").val());
                     updateOfferprice();
                    }
              }
            });

        });


        var $wcsRemainingCharacters = $(".wcs-remaining-characters");
        $personalMessage.off("keyup").on("keyup", function () {
            var maxCharacters = $personalMessage.attr("maxlength");
            var numberOfRemainingCharacters = maxCharacters;
            var len = $(".wcs-personalmessage-textarea").val().length;
            numberOfRemainingCharacters = numberOfRemainingCharacters - len;
            if(numberOfRemainingCharacters < maxCharacters) {
                $wcsGiftwrapMessageConfirm.removeClass("wcs-confirm-gray-button").addClass("wcs-confirm-black-button");
                $wcsRemainingCharacters.css("color", "black");
            }
            else {
                $wcsGiftwrapMessageConfirm.removeClass("wcs-confirm-black-button").addClass("wcs-confirm-gray-button");
                $wcsRemainingCharacters.css("color", "#666");
            }

            $("#noOfCharLeft").text(numberOfRemainingCharacters);
        });
    }
    }
    // Gift Wrap desktop Changes END
    $(".wcs-shopping-item-content .email-me").off("click").on("click", function(){
         var $parentObj = $(this).closest(".wcs-shopping-item-content");
         var catEntryId = $parentObj.find("#oosCatentryId").val();
         var productTitle = $parentObj.find(".wcs-product-title").text();
         var storeID = $("#storeId").val();
         var catalogID = $("#catalogId").val();
         var langId = $("#langId").val();
         var emailSRC = "EmailTest";
         var metaTitle = $.trim(productTitle);
         var sku = $.trim($parentObj.find("strong.wcs-product-blurb").text());
         var partNumber = $parentObj.find("#oosPartNo").val();
         var productId = catEntryId;
         var $mainImage = $parentObj.find(".wcs-main-image");
         var altText = $mainImage.attr("alt");
         var title = $.trim($mainImage.attr("title"));
         var categoryTypeForEmail = $parentObj.find("#oosProdCatType").val();
         var prodCatType = categoryTypeForEmail;
         var name = $.trim(productTitle);
         var price = $parentObj.find(".wcs-clear-sp-price").text();
         var data = {"storeId": storeID, "catalogId": catalogID, "catEntryId": catEntryId, "langId": langId, "emailSRC": emailSRC,"metaTitle": metaTitle, "sku": sku, "productId": productId, "partNumber": partNumber, "altText": altText, "title": title, "categoryTypeForEmail": categoryTypeForEmail,"prodCatType": prodCatType, "price": price, "name": name};
         sendAjaxRequest('PreOrderRemindMeEmailView', appendNotificationData, data);

    });

    tax_submit_fn();
    cancel_link();

    $(".wcs-quick-buy-full-click").off('click').on('click', function(e) {
        var url = $(this).data("url");
        if(!window.newTabEnabled){
            window.location.href = url;
            e.preventDefault();
        }else if(e.target===this){
            window.open(url);
        }
    });
    window.bindShowHideTootip();
    showHideRoxTooltip();

    /****Push error message to analytics if forter declines payment****/
    var $ForterDecline = $("#ForterDecline");
    if($ForterDecline.length){
        Rayban.analytics.forterPaymentFailed($ForterDecline.val());
    }
}
//Render the preset value of gift wrap chk box
function disaplyGiftWrap(count, chkBxObj){
    var $modifiedMsg = $("#editPersonalMessage_" + count);
    var $defaultMsg  = $("#personalMessage_" + count);

    $modifiedMsg.addClass("wcs-hide");
    $defaultMsg.addClass("wcs-hide");

    if($(chkBxObj).val()== "on"){
        if($("#giftMessage_" + count).val()!==""){
            $modifiedMsg.removeClass("wcs-hide");
            //$modifiedMsg.parents(".wcs-tablerow").height(285);
        }else {
            $defaultMsg.removeClass("wcs-hide");
            //var offsetHeight = Number($defaultMsg.height());
            //var ht = Number($defaultMsg.parents(".wcs-tablerow").height());
            //$defaultMsg.parents(".wcs-tablerow").height(245);
        }
    }

    if($(".personalMessage").height() > 25)
        $(".wcs-right-arrow-giftWrap").addClass("wcs-giftwrap-arrow");
    return;
}

window.sortBy_fn = function() {
    $('.wcs-dropdown-arrow').unbind('click', sortBy_dropdownClick).bind('click', sortBy_dropdownClick);
    $('.wcs-sortbyDropdown span').unbind('click', sortBy_dropdownSpanClick).bind('click', sortBy_dropdownSpanClick);
    if ($("div.wcs-sortby-plp").length) {
        $("#wcs-sortby-selected-title").text($('span.wcs-sortby-selectedvalue').text());
    }
};

window.sortBy_dropdownClick = function() {
    var $this = $(this);
    $this.parent('.wcs-dropdown-container').find('.wcs-sortbyDropdown').toggleClass('wcs-hide').hide().slideToggle();
    if($this.hasClass('wcs-arrowDown')) {
        $this.removeClass('wcs-arrowDown').addClass('wcs-arrowUp');
    }
    else {
        $this.addClass('wcs-arrowDown').removeClass('wcs-arrowUp');
    }
};
window.sortBy_dropdownSpanClick = function() {
    var $this = $(this);
    var labelVal = $this.text();
    $('.wcs-sortbyDropdown span').removeClass('wcs-sortby-selectedvalue');
    $this.addClass('wcs-sortby-selectedvalue');
    $('.wcs-sortbyLabel').text(labelVal);
    $this.parents('.wcs-dropdown-container').find('.wcs-sortbyDropdown').toggleClass('wcs-hide');
    $('.wcs-dropdown-arrow').addClass('wcs-arrowDown').removeClass('wcs-arrowUp');
};
window.assign_frame_lense_ht = function() {
    var $frame_filter = $('.wcs-filter-frame-wrapper'),
        $lense_filter = $('.wcs-filter-lenses-wrapper'),
        frame_ht = $frame_filter.outerHeight(),
        lenses_ht = $lense_filter.outerHeight();
    if (frame_ht > lenses_ht) {
        $.merge($frame_filter, $lense_filter).css('height', frame_ht + 'px');
    } else {
        $.merge($frame_filter, $lense_filter).css('height', lenses_ht + 'px');
    }
};
/* Loads or appends the div area */
window.loadOrAppendHTML = function(divId, data, append) {
    var $target = $("#" + divId);
    if (append === true) {
        $target.append(data);
    } else {
        $target.html(data);
    }
};

// Set the current URL in sessions for all the product pages

function setShoppingCartCookie(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays === null || nDays === 0) nDays = 1;
    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + "=" + encodeURIComponent(cookieValue.href) + ";expires=" + expire.toGMTString() + ";path=/;";
}

function setUrlInSession() {
    if ($("#UrlInSession").val() == "true") {
        setShoppingCartCookie("shoppingURL", window.location, 30);
    }
    var $wcsShoppingHistoryOn = $('.wcs_shopping_historyOn');
    var $wcsShoppingHistoryOff = $('.wcs_shopping_historyOff');
    if(getCookie("lc-remix") !== null){
        var getURLRemix = getCookie("lc-remix");
        var decodedURLRemix = decodeURIComponent(getURLRemix);

        $wcsShoppingHistoryOn.addClass('wcs-hide');
        $wcsShoppingHistoryOff.removeClass('wcs-hide');
        $wcsShoppingHistoryOff.attr('href', decodedURLRemix);

    } else if (getCookie("shoppingURL") !== null) {
        var getURL = getCookie("shoppingURL");
        var decodedURL = decodeURIComponent(getURL);

        $wcsShoppingHistoryOn.addClass('wcs-hide');
        $wcsShoppingHistoryOff.removeClass('wcs-hide');
        $wcsShoppingHistoryOff.attr('href', decodedURL);
    } else {
        $wcsShoppingHistoryOn.removeClass('wcs-hide');
        $wcsShoppingHistoryOff.addClass('wcs-hide');
    }
}

//--------------sorting

$("#filterByDivArea").on("click", '.wcs-sortbyDropdown > span', function() {
    var sortControl = $(this);
    var url = sortControl.data("baseurl");

    /* params , which contains all facets */
    var params = "";

    var srcDivs = ["categoryListingMain"];
    srcDivs[1] = "filterByDivArea";
    srcDivs[2] = "facetDivArea";

    /* Ajax response page divs */
    var destDivs = ["categoryListingMain"];
    destDivs[1] = "filterByDivArea";
    destDivs[2] = "facetDivArea";

    loadPanels(url, params, srcDivs, destDivs, 'POST', false);
    sortBy_fn();
});



//----------------------------------------------------
// Email Friend overlay -------------------
//------------------------------------------------------
$(".email-friend").click(function(e) {
    e.preventDefault();
    placeholderfn();
    var greyoutHeight = $document.height(),
        wHeight = $window.height() / 2;
    var offset;
    if (self.pageYOffset) {
        offset = self.pageYOffset;
    } else if (document.documentElement && document.documentElement.scrollTop) {
        offset = document.documentElement.scrollTop;
    } else if (document.body) { // all other Explorers
        offset = document.body.scrollTop;
    }
    var $modalGreyout = $('#modal-greyout');
    var $emailFriendModal = $('#email-friend-modal');
    $('.form-error-message.visible').removeClass('visible');
    $modalGreyout.removeClass('hide');
    $emailFriendModal.removeClass('hide');
    $modalGreyout.css('height', greyoutHeight + 70 + 'px');
    var mHeight = $emailFriendModal.find('.modal-container').height();
    $emailFriendModal.css("top", offset + wHeight - (mHeight / 2) + 'px');
});

window.processCookieCartItemsForWCS = function() {
    var wcsOriginRef = "";
    var wcsOriginRefObj = $('#wcs_origin_ref');
    if (wcsOriginRefObj !== null && wcsOriginRefObj !== undefined) {
        wcsOriginRef = wcsOriginRefObj.val();
    }
    if (wcsOriginRef != 'D') {
        var cookieCartContent = getCookie('cookie_cart');
        if (cookieCartContent !== null && cookieCartContent != "undefined" && cookieCartContent !== "") {
            cookieCartContent = decodeURIComponent(cookieCartContent);
            var cookieCartContentJson = $.parseJSON(cookieCartContent);
            if (cookieCartContentJson !== null && cookieCartContentJson != "undefined" && cookieCartContentJson.cartSkus != "undefined" && cookieCartContentJson.cartSkus.length > 0) {
                var params = {};
                var storeIdObj = $('#storeId');
                var langIdObj = $('#langId');
                var storeIdVal = "";
                var langIdVal = "";
                if (storeIdObj !== null && storeIdObj !== undefined) {
                    storeIdVal = storeIdObj.val();
                }
                if (langIdObj !== null && langIdObj !== undefined) {
                    langIdVal = langIdObj.val();
                }
                if (storeIdVal !== null && storeIdVal !== "" && langIdVal !== null && langIdVal !== "") {
                    params.storeId = storeIdVal;
                    params.langId = langIdVal;
                    $.ajax({
                        type: "POST",
                        dataType: "json",
                        url: "/webapp/wcs/stores/servlet/MigrateCookie",
                        data: params
                    })
                        .done(function(data) {
                            deleteCookieCart('cookie_cart', '/', '.ray-ban.com');
                            if (data !== null && data !== "" && data != "undefined" && data.status !== null) {
                                if (data.status == "ADDED") {
                                    if (params !== null && params != 'undefined' && params.pageName == 'ShopCart') {
                                        location.reload();
                                    } else {
                                        window.add_product_tobag();
                                    }
                                }
                            }
                        })
                        .fail(function() {
                            return false;
                        });
                }
            }
        }
    }
};

window.processCookieCartItemsForDMP = function(storeId, langId) {
    var cookieCartContent = getCookie('cookie_cart');
    if (cookieCartContent !== null && cookieCartContent != "undefined" && cookieCartContent !== "") {
        cookieCartContent = decodeURIComponent(cookieCartContent);
        var cookieCartContentJson = $.parseJSON(cookieCartContent);
        if (cookieCartContentJson !== null && cookieCartContentJson != "undefined" && cookieCartContentJson.cartSkus != "undefined" && cookieCartContentJson.cartSkus.length > 0) {
            var params = {};
            params.storeId = storeId;
            params.langId = langId;
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "/webapp/wcs/stores/servlet/MigrateCookie",
                async: false,
                data: params
            })
                .done(function(data) {
                    deleteCookieCart('cookie_cart', '/', '.ray-ban.com');
                })
                .fail(function() {});
        }
    }
    return true;
};

function deleteCookieCart(name, path, domain) {
    document.cookie = name + "=" +
        ((path) ? ";path=" + path : "") +
        ((domain) ? ";domain=" + domain : "") +
        ";expires=Thu, 01-Jan-1970 00:00:01 GMT";
}

/*for the loading of the social email friend icon*/
window.sharePlus_emailToFriend_bind = function() {
    $('a.wcs-mail-ext10').off('click').on('click', function() {
        var params = {};
        var $this = $(this);
        var $wcsEmailToFriend = $('#wcs_email_to_friend');
        var $catEntryIdForShare = $('#catEntryIdForShare');
        if (!$wcsEmailToFriend.length) {

            var emailSRC = $this.attr('templateView');
            var count = $this.attr('count');
            if (count === undefined) {
                count = "";
            }
            if (emailSRC !== undefined && (emailSRC == "CollectionView" || emailSRC == "FavView") && $catEntryIdForShare.length) {
                params.catEntryId = $catEntryIdForShare.val();
            } else if (emailSRC == "GiftView") {
                params.catEntryId = "";
            } else {
                params.catEntryId = $('#catIdSocial' + count).val();
            }

            var aGiftCardSku = $this.attr('giftSku');
            var shareURL = $this.attr('ShareURL');
            params.shareURL = shareURL;
            params.emailSRC = emailSRC;
            //params.metaTitle = $('#metaTitle' + count).val();
            params.metaTitle = $('#wcs-productdescval').text();
            params.storeId = $('#storeId').val();
            params.catalogId = $('#catalogId').val();
            params.productId = $('#productId' + count).val();
            params.langId = $('#langId').val();


            params.configurationId = $('#configurationIdSocial' + count).val();
            params.sku = $('span#wcs-resolvedskuvalForEmailShare').text();
            params.partNumber = $('#partNumber' + count).val();
            params.altText = $('#altText' + count).val();
            params.title = $('#title' + count).val();
            params.categoryTypeForEmail = $('#categoryTypeForEmail').val();
            if (aGiftCardSku !== undefined) {
                params.giftCardSku = aGiftCardSku;
            }
            var $clearancePrice = $('input#clearancePrice_' + params.catEntryId);
            if (params.emailSRC == "OrderView") {
                var $wcsItemDisplay = $('.wcs-item-display-' + count);
                params.prodCatType = $('#prodCatTypeOrder').val();
                params.metaTitle = $('#wcs-productdescval' + count).html();
                params.price = $('span#wcs-price' + count).html();
                params.sku = $('#wcs-resolvedskuvalSocial_' + count).val();
                params.categoryTypeForEmailOthers = $('#categoryTypeForEmailOthers' + count).val();
                params.roxSet = $wcsItemDisplay.find('#roxSetSocial' + count).val();
                params.roxLensCatentryId = $wcsItemDisplay.find('#roxLensCatentryIdSocial' + count).val();
                params.roxLensPartNumber = $wcsItemDisplay.find('#roxLensPartNumberSocial' + count).val();
                params.catEntryId = $wcsItemDisplay.find('#catIdSocial' + count).val();
                params.configurationId = $wcsItemDisplay.find('#configurationIdSocial' + count).val();
            } else if (params.emailSRC == "CollectionView") {
                params.prodCatType = $('#prodCatTypeCollection').val();
                params.metaTitle = $('#titleSocial_' + params.catEntryId).val();
                if ($('#isClearance_' + params.catEntryId).length > 0 && $('#isClearance_' + params.catEntryId).val() == "true" && $clearancePrice.length && $clearancePrice.val().indexOf(',') != -1) {
                    var splitIndex = $clearancePrice.val().indexOf(',');
                    params.price = $clearancePrice.val().substr(0, splitIndex);
                    params.clearancePrice = $clearancePrice.val().substr(splitIndex + 1, $clearancePrice.val().length);
                } else {
                    params.price = $('span#offerPrice_' + params.catEntryId).html();
                }
                if($('#roxSet_' + params.catEntryId) && $('#roxSet_' + params.catEntryId).length > 0 && $('#roxSet_' + params.catEntryId).val() !== undefined) {
                    params.roxSet = $('#roxSet_' + params.catEntryId).val();
                    params.roxLensCatentryId = $('#roxLensCatentryId_' + params.catEntryId).val();
                    params.roxLensPartNumber = $('#roxLensPartNumber_' + params.catEntryId).val();
               }
                params.sku = $('#partSocialMySelection_' + params.catEntryId).val();
                params.partNumber = $('#partNumberFavSocial_' + params.catEntryId).val();
            } else if (params.emailSRC == "EmailTest") {
                params.prodCatType = $('#prodCatTypePDP').val();
                if ($('#isClearance').length > 0 && $('#isClearance').val() == "true") {
                    params.price = $.trim($('div.wcs-price-clearance>div.wcs-clear-sp-price').html());
                    params.clearancePrice = $.trim($('div.wcs-price-clearance>div.wcs-clear-strike-price>strike').html());
                } else {
                    params.price = $('span#wcs-productprice').html();
                }
            } else if (params.emailSRC == "FavView") {
                if ($('#isClearance_' + params.catEntryId).length > 0 && $('#isClearance_' + params.catEntryId).val() == "true" && $clearancePrice.length && $clearancePrice.val().indexOf(',') != -1) {
                    var splitIndex = $clearancePrice.val().indexOf(',');
                    params.price = $clearancePrice.val().substr(0, splitIndex);
                    params.clearancePrice = $clearancePrice.val().substr(splitIndex + 1, $clearancePrice.val().length);
                } else {
                    params.price = $('span#offerPrice_' + params.catEntryId).html();
                }
                if($('#roxSet_' + params.catEntryId) && $('#roxSet_' + params.catEntryId).length > 0 && $('#roxSet_' + params.catEntryId).val() !== undefined) {
                    params.roxSet = $('#roxSet_' + params.catEntryId).val();
                    params.roxLensCatentryId = $('#roxLensCatentryId_' + params.catEntryId).val();
                    params.roxLensPartNumber = $('#roxLensPartNumber_' + params.catEntryId).val();
               }
                params.metaTitle = $('#metaTitle' + params.catEntryId).val();
                params.sku = $('#sku_' + params.catEntryId).val();
                params.partNumber = $('#partNumberFavSocial_' + params.catEntryId).val();
                params.prodCatType = $('#prodCatTypeFav').val();
            } else if (params.emailSRC == "GiftView") {
                params.metaTitle = $("#wcs-GiftShare").find(".wcs-left").text();
                params.sku = $('span#Gift_share_mfNo').html();
                params.price = $('#Gift_Price').val();
                params.catEntryId = $('#catEntryId').val();
            }
            params.name = $('span#wcs-productdescval').html();
            if(params.price === null) {
                params.price = "";
            }
            var partNum = $('#partNumber').val();
            if (undefined !== $('div.wcs-pdp-product-description').find('span#wcs-productprice>span') &&
                $('div.wcs-pdp-product-description').find('span#wcs-productprice>span').length > 0) {
                params.price = $.trim($('div.wcs-pdp-product-description').find('span#wcs-productprice>span').html());
            }
            $.ajax({
                type: "POST",
                url: "SocialEmailFriend",
                data: params,
                success: function(result) {
                    var $wcsEmailToFriend = $('#wcs_email_to_friend' + params.emailSRC);
                    var $wcsEmailToFriendConfirmation = $('#wcs_email_to_friend_confirmation');
                    var $priceVal = $('#priceVal');
                    if (wcsEmailToFriend.length) {
                        wcsEmailToFriend.remove();
                    }
                    if ($wcsEmailToFriendConfirmation.length) {
                        $wcsEmailToFriendConfirmation.remove();
                    }
                    $(result).insertAfter('footer.wcs-footer');
                    display_Modal_1('wcs_email_to_friend' + params.emailSRC);
                    $wcsEmailToFriend.show();
                    if($priceVal.length){
                        $priceVal.val($priceVal.val().replace('�','&#165;'));
                    }
                    close_lightbox();
                    cancel_link();
                    validateForms($("#wcs_email_to_friend_form"));
                    validateEmail();

                }
            });
        } else {
            display_Modal_1('wcs_email_to_friend' + params.emailSRC);
            $wcsEmailToFriend.show();
        }
    });
};

//For GiftCard Error Messages - Basket related
function checkGiftCardErrors() {
    var gcitem = $("#gcItemerror").val();
    var gcqty = $("#gcQtyerror").val();
    var errmsg=$(".wcs-marBt15").text();
    var gcerr=$(".gcerr").text();
    var $gcItemerrorId = $("#gcItemerrorId");
    if (gcitem || gcqty) {
        $gcItemerrorId.removeClass('wcs-hide');
    } else {
        $gcItemerrorId.addClass('wcs-hide');
    }
    errmsg=errmsg.replace(/^\s+|\s+$/g, '');
    gcerr=gcerr.replace(/^\s+|\s+$/g, '');
    if(errmsg.indexOf(gcerr) !== -1) /* using indexOf as IE doesn't support includes */
    {
        $(".wcs-marBt15").hide();
    }
}

function checkRoxErrors() {
    var roxItem = $("#roxItemerror").val();
    var roxRemixItem = $("#roxRemixItemerror").val();
    var errmsg=$(".wcs-marBt15").text();
    var roxerr=$(".roxerr").text();
    var $roxItemerrorId = $("#roxItemerrorId");
    var zeroPowerInCart = $('#zero-power-flag').val();
    var isSupernova = $('.js-is-item-electronics').val() === 'true';
    if (roxItem && !roxRemixItem && !zeroPowerInCart && !isSupernova) {
        $roxItemerrorId.removeClass('wcs-hide');
        tealium_data2track.push({
            id: 'Error',
            Error_Source: 'User',
            Error_Code: 'Prescription - only one',
            Error_Message: $('#roxItemerrorId .wcs-uppercase').html().replaceAll('\n','').trim(),
        });
    } else {
        $roxItemerrorId.addClass('wcs-hide');
    }
    errmsg=errmsg.replace(/^\s+|\s+$/g, '');
    roxerr=roxerr.replace(/^\s+|\s+$/g, '');
    if(errmsg.indexOf(roxerr) !== -1) /* using indexOf as IE doesn't support includes */
    {
        $(".wcs-marBt15").hide();
    }
}

function checkRoxRemixCaseItemerror() {
    var errorFlag = $('#roxRemixCaseItemerror').val();
    var messageContainer = $('#roxRemixCaseItemerrorId');
    if(errorFlag) {
        messageContainer.removeClass('wcs-hide');
    }else {
        messageContainer.addClass('wcs-hide');
    }

}

function checkRoxRemixErrors() {
    var roxItem = $("#roxRemixItemerror").val();
    var errmsg=$(".wcs-marBt15").text();
    var roxerr=$(".roxremerr").text();
    var $roxRemixItemerrorId = $("#roxRemixItemerrorId");
    var zeroPowerInCart = $('#zero-power-flag').val();
    if (roxItem && !zeroPowerInCart) {
        $roxRemixItemerrorId.removeClass('wcs-hide');
    } else {
        $roxRemixItemerrorId.addClass('wcs-hide');
    }
    errmsg=errmsg.replace(/^\s+|\s+$/g, '');
    roxerr=roxerr.replace(/^\s+|\s+$/g, '');
    if(errmsg.indexOf(roxerr) !== -1) /* using indexOf as IE doesn't support includes */
    {
        $(".wcs-marBt15").hide();
    }
}

function checkZeroPowerError() {
    var zeroPowerInCart = $('#zero-power-flag').val();
    var errorMessageItem = $('#zero-power-error');
    const isSupernova = $('.js-is-item-electronics').val() === 'true';
    if (zeroPowerInCart && !isSupernova) {
        errorMessageItem.removeClass('wcs-hide');
    } else {
        errorMessageItem.addClass('wcs-hide');
    }
}

function checkSupernovaError() {
  const zeroPowerInCart = $('#zero-power-flag').val();
  const isSupernova = $('.js-is-item-electronics').val() === 'true';
  const roxItem = $("#roxItemerror").val();
  var errorMessageItem = $('#multipleSupernovaMixAndMatchErrMsg');
  if ( isSupernova && (zeroPowerInCart || roxItem)) {
      const isAPrescriptionNonElectronicsProductInCart = $('#isAPrescriptionNonElectronicsProductInCart').val() === 'true';
      const isAMixAndMatchWithoutPrescriptionInCart = $('#isAMixAndMatchWithoutPrescriptionInCart').val() === 'true';
      const isAMixAndMatchWithPrescriptionInCart = $('#isAMixAndMatchWithPrescriptionInCart').val() === 'true';
      
      if(isAPrescriptionNonElectronicsProductInCart && (isAMixAndMatchWithoutPrescriptionInCart || isAMixAndMatchWithPrescriptionInCart)) {
        errorMessageItem.addClass('wcs-hide');
        return;
      }

      errorMessageItem.removeClass('wcs-hide');
  } else {
      errorMessageItem.addClass('wcs-hide');
  }
}

function checkMixAndMatchErrors() {
    const isAMixAndMatchWithoutPrescriptionInCart = $('#isAMixAndMatchWithoutPrescriptionInCart').val() === 'true';
    const isAMixAndMatchWithPrescriptionInCart = $('#isAMixAndMatchWithPrescriptionInCart').val() === 'true';

    const isElectronics = $('.js-is-item-electronics').val() === 'true';
    const roxItem = $("#roxItemerror").val() === 'true';

    const isAPrescriptionNonElectronicsProductInCart = $('#isAPrescriptionNonElectronicsProductInCart').val() === 'true';

    const wcsHideClass = 'wcs-hide';

    const mixAndMatchWithoutPrescriptionErrorMessage = $('#mixAndMatchWithoutPrescriptionErrMsg');
    mixAndMatchWithoutPrescriptionErrorMessage.addClass(wcsHideClass);

    const mixAndMatchWithPrescriptionErrorMessage = $('#mixAndMatchWithPrescriptionErrMsg');
    mixAndMatchWithPrescriptionErrorMessage.addClass(wcsHideClass);

    if(!isElectronics || !roxItem || !isAPrescriptionNonElectronicsProductInCart) {
        return;
    }
    
    
    if(isAMixAndMatchWithPrescriptionInCart) {
        mixAndMatchWithPrescriptionErrorMessage.removeClass(wcsHideClass);
        return;
    }

    if(isAMixAndMatchWithoutPrescriptionInCart) {
        mixAndMatchWithoutPrescriptionErrorMessage.removeClass(wcsHideClass);
    }
}

function checkRemixOosError() {
    const isRemixOosErrorPresent = $('#remixOosError').val() === 'true';
    const remixOosErrorMessage = $('#remixOosErrMsg');
    if (isRemixOosErrorPresent) {
        remixOosErrorMessage.removeClass('wcs-hide');
    }
}

function triggerRedLabel() {
    const roxItemError = $('#roxItemerror').val();
    const roxRemixItemError = $('#roxRemixItemerror').val();
    const preorderError = $(preorderItemErrorId).val();
    const gcitemError = $('#gcItemerror').val();
    const gcqtyError = $('#gcQtyerror').val();


    const labels = $('.in-holder');
    const RED_LABEL_CLASS = 'label--red';

    if (!roxItemError && !roxRemixItemError && !preorderError && !gcitemError && !gcqtyError) {
        labels.removeClass(RED_LABEL_CLASS);
        return;
    }

    const roxItems = $('.rox-item');
    const preorderItems = $('.preorder-item');
    const giftItems = $('.gift-item');

    function triggerElemClass(nodeList, specialElem) {
        nodeList.addClass(RED_LABEL_CLASS);
        if (specialElem) {
          specialElem.classList.remove(RED_LABEL_CLASS);
        }
    }

    function checkRoxWithGiftItems() {
        if (roxItemError || roxRemixItemError) {
            triggerElemClass(roxItems);
        }
        if (gcitemError || gcqtyError) {
            giftItems.addClass(RED_LABEL_CLASS);
        }
    }

    if (preorderError && preorderError !== 'none') {
        if (labels[0].classList.contains('preorder-item')) {
            triggerElemClass(labels, preorderItems[0]);
        } else {
            checkRoxWithGiftItems();
            preorderItems.addClass(RED_LABEL_CLASS);
        }
    } else {
        checkRoxWithGiftItems();
    }
}

function showHideRoxTooltip () {
    const plusBtn = $('.rox-plus-btn, .zero-power-plus-btn');
    plusBtn.off();
    plusBtn.css('pointer-events', 'auto');
    plusBtn.hover(function() {
        if ($(this).next().hasClass('tooltip-item')) {
            $(this).next().removeClass('wcs-hide');
        }
    }, function() {
        if ($(this).next().hasClass('tooltip-item')) {
            $(this).next().addClass('wcs-hide');
        }
    });
}

function checkPreorderErrors() {
    $('.js-preorder-message').hide();
    const preorderItemError = $(preorderItemErrorId).val();
    const isCartContainsPreorder = preorderItemError !== undefined;
    const isCartNotContainsElectronics = !$('.js-is-item-electronics').length;

    if (isCartContainsPreorder) {
        if (preorderItemError === NONE_LOWERCASE && isCartNotContainsElectronics) {
            $('#preorder-info-banner').show();
        } else if (preorderItemError !== NONE_LOWERCASE) {
            $('#preorder-' + preorderItemError + '-error').show();
        }
    }
}


function checkCountdownEnd() {
    const anchor = '#countdown_end';
    if (window.location.href.search(anchor) !== -1) {
        $('#flash-sale-counter-end').removeClass('wcs-hide');
    }
}

function checkBOPSCartMergeErrors() {
    const isCartMixedWithCnC = sessionStorage.getItem('isCartMixedWithCnC');
    const bopsMergedCartErrorMessage = $('#bops-merged-cart-order-error');
    if (isCartMixedWithCnC === 'true') {
        bopsMergedCartErrorMessage.show();
    }
    sessionStorage.setItem('isCartMixedWithCnC', '');
}

function checkSFSLoginRedirectErrors() {
    const isSfsLoginRedirect = sessionStorage.getItem('isSfsLoginRedirect');
    const sfsLoginRedirectErrorMessage = $('#sfs-login-redirect-error');
    if (isSfsLoginRedirect === 'true') {
        sfsLoginRedirectErrorMessage.show();
    }
    sessionStorage.setItem('isSfsLoginRedirect', '');
}

function triggerPaymentGatewayDetailPopup(gatewayId) {
    var gatewayDetailContainerId = '#' + gatewayId.replace('link', 'div');
    $(gatewayDetailContainerId).show();
    display_center_1($(gatewayDetailContainerId));
    show_full_fadeout_1();
}
function initNavigation() {
    if (!$body.is('.ipad')) {
        var inWidth = $body.innerWidth();
        inWidth = (inWidth - 1024) / 2;
        inWidth = (inWidth < 0) ? 0 : inWidth;
        // $('.wcs-drop_panel, .wcs-drop_panel_container').css('left', inWidth + 'px');
        $('.wcs-drop_panel, .wcs-drop_panel_container').css('left', '0px');
    }
}

function initCheckoutButton() {
    var buttons=$("#wcs-payment-confirm-buttons");
    if (buttons.length > 0) {
        var agreeTip=$("#wcs-agree-tooltip");
        if ($html.hasClass('no-touch')) {
            buttons.mousemove(function(e) {
                //RB-6829
                //if(buttons.find('input:submit:visible').hasClass('wcs-btn-disable')){
                    agreeTip.removeClass("wcs-hide");
                //}
                e.stopPropagation();
            });
            $body.mousemove(function() {
                agreeTip.addClass("wcs-hide");
            });
        } else {
            buttons.bind('touchstart', function(e) {
                 if(buttons.find('input:submit:visible').hasClass('wcs-btn-disable')){
                    agreeTip.removeClass("wcs-hide");
                }
                e.stopPropagation();
            });
            $body.bind('touchstart', function() {
                agreeTip.addClass("wcs-hide");
            });
        }

    }
}

/* PDP read more/read less implementation - START */
var $wcsReadMoreLink = $('.wcs-read-more-link');
var $wcsReadLessLink = $('.wcs-read-less-link');
$wcsReadMoreLink.on({
    click: function() {
        var $this = $(this);
        $this.parent().find('.wcs-read-more-text').removeClass("wcs-hide");
        $this.addClass('wcs-hide');
        $wcsReadLessLink.removeClass("wcs-hide");
    }
});
$wcsReadLessLink.on({
    click: function() {
        var $this = $(this);
        $this.parent().find('.wcs-read-more-text').addClass("wcs-hide");
        $this.addClass('wcs-hide');
        $wcsReadMoreLink.removeClass("wcs-hide");
    }
});
/* PDP read more/read less implementation - END */

var amendEspotContent = function() {
    var $wcs_espot_popular = $("#wcs-espot-popular");

    if ($wcs_espot_popular.length) {
        var $wcs_espot_popular_parent = $wcs_espot_popular.parent();
        $wcs_espot_popular_parent.addClass("wcs-height-305");
        $wcs_espot_popular_parent.removeClass("wcs-rows-1");
        $wcs_espot_popular.fadeIn("fast");
    }
};

/*place holder fix for IE8 search*/
function initIe8Search() {
    var searchInput = $("#search-text-box");
    if ($html.hasClass('ie8') && searchInput.length > 0) {
        window.setTimeout(function() {
            var placeholder = searchInput.attr('placeholder');
            if (searchInput.val() === "" || searchInput.val() == placeholder) {
                searchInput.val(placeholder).css({
                    color: "#ccc"
                });
            }
            searchInput.unbind("focus.search").bind("focus.search", function() {
                if (this.value == placeholder || this.value === '') {
                    this.value = "";
                }
                searchInput.css({
                    color: ""
                });
            }).unbind("blur.search").bind("blur.search", function() {
                if (this.value == placeholder || this.value === '') {
                    this.value = placeholder;
                    searchInput.css({
                        color: "#ccc"
                    });
                }
            });
            $(searchInput).parent().find('[type="submit"]').unbind("click.search").bind("click.search", function(e) {
                if (searchInput.val() == placeholder) {
                    e.preventDefault();
                }
            });
        }, 200);
    }
}

function sidebarHideFavEmptyDiv() {
    $('#wcs-star-container a.wcs-addtobag.wcs-hide').each(function() {
        $(this).parents('form').addClass('wcs-hide');
    });
}

$('.wcs-return-pop').click(function(e) {
    var checkout_returns_scroll = new iScroll('checkout_returns_content', {
        hScrollbar: false,
        vScrollbar: true,
        draggableScrollbars: true
    });
    setTimeout(function() {
        $('.wcs-fadeout-full').height($document.height());
    }, 800);
    $('.wcs-helpClass').hide();
    e.preventDefault();
});

window.openLinksInNewTab=function(){
     if(window.newTabEnabled){
         $('a[wcs-link-new-tab="true"]').each(function(){
            $(this).attr('target','_blank');
         });
     }
};

window.storeCurrentFreeGiftState=function(){
    window.isFreeGiftPresentInOrder =$('#isFreeGiftPresentInOrder').val();
};

window.checkFreeGiftState=function(){
    if(window.isFreeGiftPresentInOrder != $('#isFreeGiftPresentInOrder').val()){
        $("#basket_promo_form .wcs-button-checkout a").attr("href","javascript:void(0);");
        window.location.reload();
    }
};
window.initQuickviewOffersTooltip=function(){
    var $wcsQuickviewOffersTooltip = $(".wcs-quickview-offers-tooltip");
    $("#wcs_qv_tooltip_link").on("hover",function(){
        $wcsQuickviewOffersTooltip.show();
    });
    $("#D_QuickView").on("click",function(){
        $wcsQuickviewOffersTooltip.hide();
    });
    $("#D_QuickView_Prod").on("click",function(){
        $wcsQuickviewOffersTooltip.hide();
    });
    $wcsQuickviewOffersTooltip.on("click",function(e){
        e.stopPropagation();
    });
};

    function focusTrap($modal) {
        const focusableSelectors = 'input:not([disabled]), button:not([disabled])'
        const $focusableElements = $modal.find(focusableSelectors).filter(':visible')
        const firstElement = $focusableElements.first()[0]
        const lastElement = $focusableElements.last()[0]

        $modal.on('keydown.focusTrap', function(e) {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        e.preventDefault()
                        lastElement.focus()
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        e.preventDefault()
                        firstElement.focus()
                    }
                }
            } else if (e.key === 'Escape') {
                $modal.hide();
                releaseFocusTrap($modal)
            }
        });
    }

    function releaseFocusTrap($modal) {
        $modal.off('keydown.focusTrap')
    }


window.calculate_tax_fn = function() {
    $('#wcs-calculate-tax,#wcs-recalculate-tax').off('click').on('click', function(e) {
        var thisId = $(this).attr('id');
        var $wcsCalTaxNotification = $('#wcs_calTax_notification');
        if (thisId == 'wcs-recalculate-tax' || thisId =='wcs-calculate-tax') {
            if($('#country_value').val()== 'us'){
                $wcsCalTaxNotification.css('left', '-363px');
                $('.wcs-notification-box.wcs-tax-calculate .wcs-four.wcs-columns').width('161px');
                $('.wcs-tax-calculate').width('165px');
            }
            else{
               $wcsCalTaxNotification.css('left', '-546px');
            }
            tealium_data2track.push({
                id: 'Click',
                data_element_id: 'X_CartPage_Prods_TaxCalcOpen',
            });
        }
        $wcsCalTaxNotification.show()
        $wcsCalTaxNotification.find('#zip_code').focus()
        focusTrap($wcsCalTaxNotification)
        $('.wcs-close').off('click').on('click', function() {
            $wcsCalTaxNotification.hide()
            releaseFocusTrap($wcsCalTaxNotification)
        });

        //overAllFormValidation();

        var $CartPagePromoCodeInput = $('#D_CartPage_PromoCode_Input');
        var dval = $CartPagePromoCodeInput.attr('dvalue');
        if ($CartPagePromoCodeInput.val() === dval) {
            $('#D_CartPage_PromoCode_Apply').removeClass('wcs-color3');
        }
    });
};
/* Add giftcard Display on click the apply button */
window.giftcard_bindevents_fn = function() {
     // End of wish list logic
    /* Toggle gift card panel */
    /* Shopping page gift card */
    $('.gift-card-link').off().on('click', function(e){
        e.preventDefault();
        $('#wcs-apply-promo-code-div:visible').addClass('wcs-shopping-hide');
        $('#wcs-apply-promo-code-div-idme:visible').addClass('wcs-shopping-hide');
        $('.pay_with_giftCard').toggleClass('wcs-hidden');
    });
    /* Shopping page gift card */
    $(".pay_rayBan_giftCard").off("click").on("click", function(ev) {
        var currEl = ev.currentTarget;
        var ref = $(currEl).attr("ref") || $(currEl).attr("data-ref");
        var $giftCardForm = $('.gift-card');
        var $promotionCard = $(".promotion-card");
        var $rbArrow = $('.gift-card-arrow-toggle');
        if(ref.indexOf('giftcard') != -1 ){
            if ($('#piAmount').val() > 0) {
                $promotionCard.addClass('wcs-hidden');
                $giftCardForm.toggleClass('wcs-hidden');
                $rbArrow.toggleClass('rb-arrow-up');
                /*if(!$giftCardForm.hasClass('wcs-hidden')){
                    $(this).addClass('wcs-text-decoration-none');
                }else {
                    $(this).removeClass('wcs-text-decoration-none');
                }*/

                $(currEl).attr('aria-expanded', $rbArrow.hasClass('rb-arrow-up') ? 'true' : 'false');
                $('.gift_card_form input').val('');

            }
        }else {
            $giftCardForm.addClass('wcs-hidden');
            $promotionCard.toggleClass('wcs-hidden');
            /*if(!$promotionCard.hasClass('wcs-hidden')){
                $(this).addClass('wcs-text-decoration-none');
            }else {
                $(this).removeClass('wcs-text-decoration-none');
            }*/
        }
        //formValidation_onBlur();
        $("form").find("input[type=submit]").removeClass("wcs-btn-disable").attr("disabled", false);
    });

    function updatePromoAriaExpanded() {
        var $trigger = $('#wcs-apply-promo');
        var $content = $('#wcs-apply-promo-code-div');
        
        if ($trigger.length && $content.length) {
            var isHidden = $content.hasClass('wcs-shopping-hide');
            $trigger.attr('aria-expanded', !isHidden);
        }
    }
    
    function updateGiftCardAriaExpanded() {
        var $trigger = $('#D_CartPage_GiftCard_Open');
        var $content = $('.pay_with_giftCard');
        
        if ($trigger.length && $content.length) {
            var isHidden = $content.hasClass('wcs-hidden');
            $trigger.attr('aria-expanded', !isHidden);
        }
    }
    
    function updateIdmeAriaExpanded() {
        var $trigger = $('#X_CartPage_IDme_Open');
        var $content = $('#wcs-apply-promo-code-div-idme');
        
        if ($trigger.length && $content.length) {
            var isHidden = $content.hasClass('wcs-shopping-hide');
            $trigger.attr('aria-expanded', !isHidden);
        }
    }
    
    function updateAllAriaExpanded() {
        updatePromoAriaExpanded();
        updateGiftCardAriaExpanded();
        updateIdmeAriaExpanded();
    }
    
    updateAllAriaExpanded();
    
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                updateAllAriaExpanded();
            }
        });
    });
    
    var promoElement = document.getElementById('wcs-apply-promo-code-div');
    var giftCardElement = document.querySelector('.pay_with_giftCard');
    var idmeElement = document.getElementById('wcs-apply-promo-code-div-idme');
    
    if (promoElement) {
        observer.observe(promoElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    
    if (giftCardElement) {
        observer.observe(giftCardElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    
    if (idmeElement) {
        observer.observe(idmeElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    };

    /***CSR webId validation****/
    function luhnCheck ( webId ) {
    	var sum = 0 ;
    	var mul = 1 ;
    	var len = webId.length;
    	while (len--) {
	    	var ca = parseInt (webId.charAt(len), 10 ) * mul;
	    	sum += ca - (ca > 9 ) * 9 ;
	    	mul = 3 - mul;
    	}
    	return (sum % 10 === 0 ) && (sum > 0 );
    }

    $("#Customer_WebID").off("blur").on("blur", function(){
        var thisValue = $(this).val();
        var thisValueLength = thisValue.length;
        var $errorMessage = $(".csr-webId-wrapper .wcs-error-message");
        var $CustomerWebID = $("#CustomerWebID");
        var isValidWebId = luhnCheck(thisValue);
        if(thisValueLength && ( thisValueLength !== 9 || !isValidWebId)){
            $errorMessage.removeClass("wcs-hide");
            $CustomerWebID.val();
        }
        else{
            $errorMessage.addClass("wcs-hide");
            $CustomerWebID.val(thisValue);
        }
    });

    /***CSR webId validation ends here**/

    // get and check variable from localStprage
    var showBtn = localStorage.getItem('showBtn');

    var remainingToPay = Number($("#wcs-remainingtopay").val())

    var $beError = $('.js-beError');
    var $paymentMode = $('.payment-mode');
    var $giftCardForm = $('.gift_card_form');
    var $paymentInformationAjaxRed = $('.payment-information-ajax-red');
    var $gcQtyerrorId = $('#gcQtyerrorId');
    var $gcError = $('#gcQtyerrorId').find('.wcs-note-red');

    var $creditCardRadioLabel = $('#credit-card-radio');
    var $creditCardRadioInput = $('#credit_card_radio');
    var $paymentTypeField = $('input#payment_type');
    var $paymentModeCreditCard = $('#payment_mode_creditCard');
    var $paymentModeKlarna = $('#payment_mode_klarna');
    var $payment_mode = $('#payment_mode');
    var $emptyBlock = $('.empty-block');
    var $paymentModeForm = $('#payment_mode_form');
    var $creditcardBtn = $('input.creditcard-btn');
    var $paymentConfirmInputs = $('.wcs-payment-confirm-buttons-div').find('input');

    if(showBtn === 'false' && remainingToPay == 0) {
        $paymentMode.find('label').removeClass('wcs-r-on');
        $paymentMode.find('input').attr('checked', false);
        $creditCardRadioLabel.addClass('wcs-r-on');
        $creditCardRadioInput.attr('checked', true);
        $paymentTypeField.val('');
        $paymentModeCreditCard.hide();
        $paymentModeKlarna.hide();
        $payment_mode.hide();
        $emptyBlock.hide();
        $paymentModeForm.attr('action', 'OrderProcess');
        $paymentConfirmInputs.hide();
        $creditcardBtn.show();
    }

    $(".gift_apply").off("click").on("click", function(e) {
        e.preventDefault();
        _self = $(this).parents('div.gift_card_form');
        if (validate_gift_card(_self)) {
            var params = {};
            params.account = _self.find('.gift-card-number').val();
            params.check_routing_number = _self.find('.gift-card-pin').val();
            params.orderId = $("#orderId").val();
            params.piAmount = $("#piAmount").val();
            params.pimCurrency = $("#pimCurrency").val();
            //var currency1 = $("#wcs-env_currency").val();
            var country = $('#countryCode').val();
            var currFmt = $("#wcs-env_currency").val();
            var chosenCurrencyFormat = currencyFormat(country);
            $.ajax({
               type: "POST",
               url: "ApplyGiftCard",
               data: params,
               success: function(data) {
                   var json = $.parseJSON(data);
                   var balance = null;
                   var outstanding = null;
                   var error = null;
                   var payinst = null;
                   var pi = null;
                   var totalAmount;
                   var decimalSeparator = '.';
                   var thousandsSeparator = ',';
                   $(json).each(function(i, val) {
                       $.each(val, function(k, v) {
                           if (k === "ErrorMessage" || k === "errorMessage") {
                                error = v;
                                try{
                                	v=decodeURIComponent(escape(v));
                                }catch(e){
                                    // do nothing
                                }
                                $giftCardForm.show();
                                $paymentInformationAjaxRed.find('.number').val('1');
                                $paymentInformationAjaxRed.show().find('.wcs-note-red-gift p').html(v);
                                $gcError.html(v);
                                $beError.addClass('wcs-hide');
                                $gcQtyerrorId.removeClass('wcs-hide');
                                $window.scrollTop(0);
                                Rayban.analytics.giftCardApplyError("Wrong code", _self.find('.gift-card-number').val());
                           }
                           if (k === "value") {
                               balance = v;
                           }
                           if (k === "balanceAmount") {
                            outstanding = v;
                           }
                           if (k === "payInstId") {
                               payinst = v;
                           }
                           if (k === "piAmount") {
                               $('#piAmount').val(parseFloat(v).toFixed(2));
                               pi = v;
                               if (v === 0) {
                                   $('.pay_rayBan_giftCard').removeAttr('href');
                                   hide_add_gift_card();
                                   remove_required();
                               }
                           }
                           if (k === "giftcardresponseval") {
                                Rayban.analytics.giftCardApplySuccess(_self.find('.pin_1').val());
                                $.each(v, function(key, value) {
                                    if(key === "remainingBalanceToPay") {
                                        totalAmount = value;
                                        currFmtRemainingBalanceToPay = country === 'PL' ? value + " " + currFmt : currFmt + " " + value;
                                    }
                                    if(key === "totalgiftbalpaid") {
                                        currFmtTotalgiftbalpaid = country === 'PL' ? value + " " + currFmt : currFmt + " " + value;
                                    }
                                    if(key === "balanceAmount") {
                                        currFmtBalanceAmount = country === 'PL' ? value + " " + currFmt : currFmt + " " + value;
                                    }
                                    if(key === "value") {
                                        currFmtValue = country === 'PL' ? value + " " + currFmt : currFmt + " " + value;
                                    }
                                });
                           }
                       });
                   });
                   if (error === null ) {
                        $paymentInformationAjaxRed.hide();
                        var $wcsGiftCount = $('#wcs-gift-count');
                        var $wcsGiftbalpaid = $('#wcs-giftbalpaid');
                        var $wcsOneAndHalf = $('.wcs-one-and-half');
                       var giftamt = $wcsGiftbalpaid.val();
                       var decimalPlaces = $('#wcs-env_decimal_places').val();
                       var amtInCard = parseFloat(balance - outstanding).toFixed(decimalPlaces);
                       var counter = $wcsGiftCount.val();
                       counter = counter + '1';
                       $wcsGiftCount.val(counter);
                       var currency = $('#wcs-env_currency').val();
                       giftamt = (parseFloat(giftamt) + parseFloat(amtInCard)).toFixed(decimalPlaces);
                       $wcsOneAndHalf.find('.wcs-payment-cost').text(currency + giftamt);
                       $wcsOneAndHalf.find('.wcs-color0').text(currency + parseFloat(pi).toFixed(decimalPlaces));
                       $wcsGiftbalpaid.val(giftamt);
                       $('#wcs-remainingtopay').val(pi.toFixed(decimalPlaces));
                       $('#gift-bal-paid').text(currFmtTotalgiftbalpaid);
                       $('#remaining-bal-paid').text(currFmtRemainingBalanceToPay);
                       $('.shoping-items').removeClass('wcs-hidden');
                       show_applied_gift_card(_self, currFmtValue, currFmtBalanceAmount, payinst);
                       $giftCardForm.addClass('wcs-hidden');
                        checkout_giftcard_validation();
                       if(pi === 0){
                        // TODO: quick dirty solution
                        if (showBtn !== 'false') {
                            $paymentMode.find('label').removeClass('wcs-r-on');
                            $paymentMode.find('input').attr('checked', false);
                            $creditCardRadioLabel.addClass('wcs-r-on');
                            $creditCardRadioInput.attr('checked', true);
                            $paymentTypeField.val('');
                            $paymentModeCreditCard.hide();
                            $paymentModeKlarna.hide();
                            $payment_mode.hide();
                            $emptyBlock.hide();
                            $paymentModeForm.attr('action', 'OrderProcess');
                            $paymentConfirmInputs.hide();
                            $creditcardBtn.show();
                            localStorage.setItem('showBtn', 'false');
                        }
                       }
                       var $cartGcAmount = $('#cart_gc_Amount');
                       $cartGcAmount.removeClass('wcs-hidden');
                       $cartGcAmount.find('.wcs-shopping-tryon-text').text("-" + currFmtTotalgiftbalpaid);
                    $("#cart_gc_paid_label").removeClass("wcs-hidden");
                    $(".wcs-shopping-grandtotal-js").html(currFmtRemainingBalanceToPay);

                    if (Rayban && Rayban.AfterPay) {
                        Rayban.AfterPay.updateAfterpayAmount(totalAmount, 2, decimalSeparator, thousandsSeparator, currFmt, country);
                    }

                    $gcQtyerrorId.addClass('wcs-hide');
                    document.location.reload(true);
                   }
               },
               error: function(errorResponse) {
                   var json = $.parseJSON(errorResponse);
                   $(json).each(function(i, val) {
                       $.each(val, function(k, v) {
                           if (k == "errorMessage") {
                               error = v;
                               $giftCardForm.show();

                               $paymentInformationAjaxRed.find('.number').val('1');
                               $paymentInformationAjaxRed.show().find('.wcs-note-red-gift p').html(v);
                               $window.scrollTop(0);
                           }
                       });
                   });
               }
           });
       }
   });
};

window.apply_promo_link_click = function() {
    $('#wcs-apply-promo').off('click').on('click', function(e) {
        e.preventDefault();
        $('#wcs-apply-promo-code-div-idme:visible').addClass('wcs-shopping-hide');
        $('.pay_with_giftCard').addClass('wcs-hidden');
        $($(this).data("show")).toggleClass('wcs-shopping-hide');
    });
    apply_multi_promo_link_click();
    nw_valid_promo_link();
};

window.apply_multi_promo_link_click = function() {
    $('#rb-add-another').off('click').on('click', function(e) {
        e.preventDefault();
        var $rbAddAnother = $('#rb-add-another11');
        $rbAddAnother.removeClass('rb-display-none');
        $('.rb-add-another').css("display", "none");
        $('.rb-valid-promo').addClass('wcs-shopping-hide');
        $rbAddAnother.css("margin-top", "24px");
        $('.rb-sucesspromo h4').css("margin-top", "0px");

    });
};
window.nw_valid_promo_link = function() {
    var promoAppliedMsg = $('.rb-valid-promo');
    var $wcsApplyPromoCodeDiv = $('#wcs-apply-promo-code-div');

    if($('#promoremove').is(':visible')) {
        $wcsApplyPromoCodeDiv.removeClass('wcs-shopping-hide');
    }

    if($('#promosuccess').is(':visible')) {
        var $firstPromoAppliedMsg = promoAppliedMsg.eq(0);
        var $secondPromoAppliedMsg = promoAppliedMsg.eq(1);
        $wcsApplyPromoCodeDiv.removeClass('wcs-shopping-hide');
        if($firstPromoAppliedMsg.length && $firstPromoAppliedMsg.hasClass('wcs-shopping-hide') && $secondPromoAppliedMsg.length === 0) {
            $firstPromoAppliedMsg.removeClass('wcs-shopping-hide');
        }else if($firstPromoAppliedMsg.length && $firstPromoAppliedMsg.hasClass('wcs-shopping-hide') && $secondPromoAppliedMsg.length) {
            $secondPromoAppliedMsg.removeClass('wcs-shopping-hide');
            $('.rb-add-another').addClass('wcs-shopping-hide');
        }
    }
};

window.callAnaytics = function(){
	tealium_data2track = tealium_data2track || [];
	var thankuData = {};

	try{
		var pageCode     = $("#PageCode").val();
		var userId       = $("#wcsUserId").val();
		var currency     = $("#currency").val();
		var orderId      = $("#wcsOrderId").val();
		var paymentType  = $("#PaymentType").val();
        var Revenue      = $("#Revenue").val();
        var Discount     = $("#Discount").val();
        var DiscountCode = $("#DiscountCode").val();
        var ShippingCost = $("#ShippingCost").val();
        var ShippingMode = $("#ShippingMode").val();
        var ShippingTax  = $("#ShippingTaxRate").val();
        var TaxRate      = $("#TaxRate").val();
        var Products     = window.analyticsData.Products;
        var TaxAmount    = $("#TaxAmount").val();
        var ProductUnits = $("#ProductUnits").val();

		currency = currency == "R$" ? "BRL" : currency;
		var paymentTypeReplacements = {
            "Apple Pay": "ApplePay",
            "Cash On Delivery": "Cash-On-Delivery",
            "KlarnaCheckout": "KlarnaExpressCheckout",
            "KlarnaREST": "Klarna"
        };
        if (paymentTypeReplacements.hasOwnProperty(paymentType)) {
            paymentType = paymentTypeReplacements[paymentType];
        }

		thankuData.id = 'WCS-X-Checkout-Step-ThankYouPage';
		thankuData.Page_Code = pageCode; // <country>:<language>:<device>:<pageName>
		thankuData.User_IdWcs = userId;
		thankuData.Order_Currency = currency; // the currency
		thankuData.Order_Id = orderId;
		thankuData.Order_PaymentType = paymentType; // the payment type
		thankuData.Order_DiscountAmount = Discount; // if applied
		thankuData.Order_DiscountCode = DiscountCode; // if there's one
		thankuData.Order_ShippingAmount = ShippingCost;
		thankuData.Order_ShippingMode = ShippingMode; // standard - express ecc..
		thankuData.Order_ShippingTaxRate = ShippingTax;
		thankuData.Order_TaxRate = TaxRate;
		thankuData.Products = Products;
		thankuData.Order_TaxAmount = TaxAmount;
		thankuData.Order_ProductUnits = ProductUnits;

		tealium_data2track.push(thankuData);


        } catch(e) {
        	var errcode = "";
        	if (orderId!=undefined) {
        		errcode = 'utag_data syntax error in orderId '+orderId+' - '+e.message;
        	} else {
        		errcode = 'utag_data syntax error in orderId empty - '+e.message;
        	}
            thankuData = {
                id:'X-X-Error',
                Error_Code: errcode,
                Error_Source: 'Server'
            };
            tealium_data2track.push(thankuData);
        }
        finally{
            //thankuData.id = 'WCS-X-Checkout-Step-ThankYouPage';
            //tealium_data2track.push(thankuData);
        }
    };

window.idme_links = function(){

    $(".idme-btn").off("click").on("click", function() {
          var top   = ($document.height() - 780) / 4;
          var left  = ($document.width() - 750) / 2;
          var scope = $(this).data('scope');

          var $idmeRedirectURL = $("#idmeRedirectURL");
          if($idmeRedirectURL.length) {
              var idmeRedirectURL = $idmeRedirectURL.val();
              var idmeUrl = idmeRedirectURL+'&scope='+scope;
              //document.cookie = "user_group_scope" + "=" + scope + ";expires=" + "365" + ";";
              $.cookie("user_group_scope",scope, { path: '/'});
              window.open(idmeUrl, "", "scrollbars=yes,menubar=no,status=no,location=no,toolbar=no,width=750,height=780,top=" + top + ",left=" + left);
          }
          return false;
    });
    if($("#shopCartPage").val() == 'ShopCart' && $('#wcsCoutryAndLangId').val() === 'en_US'){
        whatis_idme_links();
    }
};

window.apply_promo_idme_link_click = function() {
    $('#X_CartPage_IDme_Open').off('click').on('click', function(e) {
        e.preventDefault();
        $('#wcs-apply-promo-code-div:visible').addClass('wcs-shopping-hide');
        $('.pay_with_giftCard').addClass('wcs-hidden');
        $('.idme-btn-container').find('img').each(function(){
          const button = $(this)
          const dataSrc = button.data('src')
          button.attr('src', dataSrc)
        })
        $($(this).data("show")).toggleClass('wcs-shopping-hide');
    });
    var $idMePromoExists = $('#idMePromoExists');
    var $normalPromoExists = $('#normalPromoExists');
    if($idMePromoExists.length && $idMePromoExists.val() === 'true'){
        //$('#wcs-apply-promo').css('color','#ccc');
        $('#wcs-apply-promo-code-div-idme').removeClass('wcs-shopping-hide');
        setTimeout(function(){
            $('html,body').animate({scrollTop: $('#orderSummary').offset().top},'slow');
        }, 1000);
    }
    if($normalPromoExists.length && $normalPromoExists.val() === 'true'){
        $('.normalPromoAppliedMsg').removeClass('wcs-hide');
    }
};

window.sortBy_dropdown = function() {
    var $this = $(this);
    $this.parent(".wcs-dropdown-container").find(".wcs-sortbyDropdown").toggleClass("wcs-hide").hide().slideToggle();

    if ($this.hasClass("wcs-arrowDown")){
        $this.removeClass("wcs-arrowDown").addClass("wcs-arrowUp");
    }else{
        $this.addClass("wcs-arrowDown").removeClass("wcs-arrowUp");
    }
};

window.sortBy_dropdownSpan = function() {
    var $this = $(this);
    var e = $this.text();
    $(".wcs-sortbyDropdown span").removeClass("wcs-sortby-selectedvalue");
    $this.addClass("wcs-sortby-selectedvalue");
    $(".wcs-sortbyLabel").text(e);
    $this.parents(".wcs-dropdown-container").find(".wcs-sortbyDropdown").toggleClass("wcs-hide");
    $(".wcs-dropdown-arrow").addClass("wcs-arrowDown").removeClass("wcs-arrowUp");
};


window.getCookie = function(CookieName) {
    var Cookies = document.cookie;
    var CookieValue = null;
    var Offset = -1;
    var End = -1;
    CookieName += "=";
    Offset = Cookies.indexOf(CookieName);
    if (Offset >= 0) {
        End = Cookies.indexOf(";", Offset);
        if (End < 0) {
            End = Cookies.length;
        }
        CookieValue = Cookies.substring(Offset + CookieName.length, End);
    }
    return (CookieValue);
};

window.SetCookie = function(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays === null || nDays === 0) nDays = 1;
    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString() + ";path=/;";
};


window.display_center_1 = function(divObject) {
    var scrollTop = $document.scrollTop();
    var windowheight = $window.height();
    var boxheight = divObject.height();
    var divObjectId = divObject.attr('id');
    if(boxheight+40 > windowheight){
        scrollTop= scrollTop - (boxheight+40-windowheight);
        if(scrollTop<1) scrollTop=0;
        $document.scrollTop(scrollTop);
    }
    var left = ($window.width() - divObject.width()) / 2;
    var top = ($window.height() - divObject.height()) / 2 + scrollTop;
    if (windowheight > boxheight) {
        top = (windowheight - boxheight) / 2 + scrollTop;
    } else {
        top = scrollTop + 40;
    }
    if(divObjectId === "wcs_compare_quickview1"){
        top = 158;
    }
    if(divObjectId === "D_X_SignUpOverlay_main"){
        top = (windowheight / 2) - (boxheight / 2);
        divObject.css("position", "fixed");
    }
    if(divObject.hasClass('wcs-fixed')){
        var fixedTop = boxheight / 2;
        top = '50%';
        divObject.css('margin-top', "-"+fixedTop+"px");
    }
    if(divObjectId === 'wcs-find-giftCard'){
        const modal = $('#wcs-find-giftCard');
        const focusReturnTarget = document.activeElement;
        setTimeout(() => {
            if (modal) {
                setupModalFocus(modal, focusReturnTarget);
            }
        }, 10);
        top = calcTopForModalWindowFindGiftCard();
        left = '50%';
        divObject.css({
            'transform': 'translate3d(-50%, 0, 0)',
        });

        $('.wcs-find-giftcard-container img').each(function(){
          const dataSrc = $(this).data('src')
          $(this).attr('src', dataSrc)
        })

        $(window).on('resize', function() {
            setTimeout(function() {
                top = calcTopForModalWindowFindGiftCard();
                divObject.css({
                    'top': top,
                });
            }, 200);
        });
    }
    divObject.css({
        'left': left,
        'top': top
    });

    function calcTopForModalWindowFindGiftCard () {
        var headerHeight = $('#rb-header').outerHeight() || 0;
        var shippingbarHeight = $('.wcs-shipping-bar').outerHeight() || 0;
        var topMessageHeight = $('.wcs-top-message-container').outerHeight() || 0;
        var topBottomIndent = 30;
        var fullHeaderHeight = headerHeight + shippingbarHeight + topMessageHeight + topBottomIndent;
        return fullHeaderHeight;
    }
};


/*
 * function for hiding the error message notification of the
 * field
 */

window.hide_error_message = function(fieldObj) {
    fieldObj.parents('.wcs-row').find('.wcs-error-message').removeClass('wcs-show');
};

/*function to show error message on drop down*/
window.show_dropDown_error_message = function(fieldObj) {
    var $fieldObjParents = fieldObj.parents('.wcs-row');
    fieldObj.parents('.wcs-custom-dropdown-container').addClass('ui-state-error');
    $fieldObjParents.find('.wcs-error-message').addClass('wcs-show');
    $fieldObjParents.css('color', '#EC1E24');
};
/*function to hide error message on drop down*/
window.hide_dropDown_error_message = function(fieldObj) {
    var $fieldObjParents = fieldObj.parents('.wcs-row');
    fieldObj.parents('.wcs-custom-dropdown-container').removeClass('ui-state-error');
    $fieldObjParents.find('.wcs-error-message').removeClass('wcs-show');
    $fieldObjParents.removeAttr('style');
};
/* gift card panel code starts */
window.validate_gift_card_number = function(parentObj) {
    var giftCardPinNumber = parentObj.find($('.pin_1'));
    if (giftCardPinNumber.val() !== '') {
        return true;
    } else {
        show_error(giftCardPinNumber);
        return false;
    }
};
window.validate_gift_card_pin = function(parentObj) {
    var pinNumber = parentObj.find($('.giftcard_pin_number'));
    if ($.trim(pinNumber.val()) === "") {
        show_error(pinNumber);
        return false;
    } else {
        hide_error(pinNumber);
        hide_error_message(pinNumber);
        return true;
    }
};
window.validate_gift_card = function(parentObj) {
    var valiadteCreditCardNumber = validate_gift_card_number(parentObj);
    var validateGiftCardPin = validate_gift_card_pin(parentObj);
    return (valiadteCreditCardNumber && validateGiftCardPin);
};

window.show_applied_gift_card = function(parentObj, amount, outstanding, payinst) {
    var decimalPlaces = $("#wcs-env_decimal_places").val();
    var currency = $("#wcs-env_currency").val();
    var parentGiftCardDiv = parentObj.parents('div.gift-card');
    var gift_card_number_text = parentGiftCardDiv.find('.pin_1').val();
    var clonedObj = parentGiftCardDiv.find('.applied_gift_card_template').children('.wcs-row').clone(true, true);
    //var clonedObj = parentGiftCardDiv.find('.applied_gift_card_template').childrenclone(true, true);
    var $appliedGiftCard = parentGiftCardDiv.find('.applied_gift_card');
    clonedObj.find('.wcs-gift-card-number').val(gift_card_number_text).attr('payInstId', payinst);
    clonedObj.find('#gift-val').text(amount.toFixed(decimalPlaces));
    clonedObj.find('#gift-bal').text(outstanding.toFixed(decimalPlaces));
    clonedObj.appendTo($appliedGiftCard);
    $appliedGiftCard.show();
};

window.cancel_link = function() {
    var $wcsQuickBuyLightbox = $('.wcs-quick-buy-lightbox');
    $wcsQuickBuyLightbox.find('a.wcs-myOrder-status-link, .wcs_close_lightBox').off('click').on('click', function() {
        var $thisParent = $(this).closest('.wcs-quick-buy-lightbox');
        $thisParent.children('div.wcs-close-btn-2').trigger('click');
        $thisParent.find('.wcs-row').find('input').removeClass('ui-state-error');
    });
};

$document.ready(function() {
    checkRemixOosError();

    for (i=0; i<$('.left-side').length; i++) {
      var leftSide = $('.left-side').eq(i).html().trim()
      if(leftSide===""){
        if($('.left-side').eq(i).siblings('.right-side').html().trim()==="") {
          $('.left-side').eq(i).parents('.order-summary-row').remove()
        }
      }
    }

    var $wcsTitleLogoLinks = $('.wcs-title_logo').find('a');
    var $wcsGwStaticBar = $('.wcs-gw-static-bar');
    var $wcsGwExapandableItem = $('.wcs-gw-exapandable-item');
    var $wcsGwExapandable = $(".wcs-gw-exapandable");
    if ($wcsTitleLogoLinks.length) {
        var hurl = $wcsTitleLogoLinks.attr('href').replace(/\/$/, "");
        $wcsTitleLogoLinks.attr('href', hurl);
    }
    ////Commented because "exclusive offeres" page sort by fn was not working
    //$(".wcs-dropdown-arrow").unbind("click", sortBy_dropdown).bind("click", sortBy_dropdown);
    //$(".wcs-sortbyDropdown span").unbind("click", sortBy_dropdownSpan).bind("click", sortBy_dropdownSpan);
    // Fix to stop click event triggering twice
    $(".wcs-label-check").find(":checkbox").on("click",function(e){
        e.stopPropagation();
    });

    $wcsGwStaticBar.find(".wcs-uparrow").on("click",function(){
        $wcsGwExapandable.slideToggle(function(){
            $wcsGwStaticBar.toggleClass("wcs-gw-collapsed");
        });
    });

    if ($("#giftWrap").is(":checked")) {
        $wcsGwExapandableItem.each(function(){
            $(this).find(".wcs-label-check").removeClass("wcs-inactive").find(":checkbox").attr("disabled", false);
        });
    } else {
        $wcsGwExapandableItem.each(function(){
            $(this).find(".wcs-label-check").addClass("wcs-inactive").find(":checkbox").attr("disabled", true);
        });
    }

    $wcsGwStaticBar.find(".wcs-label-check").on("click",function(){
        var $wcsGwExapandableItemSubmitConfirm = $(".wcs-gw-exapandable-item-submit").find(".wcs-gw-confirm");
        if(!$(this).find(":checkbox").is(":checked")) {
            $wcsGwExapandable.slideDown(function(){
                $wcsGwStaticBar.removeClass("wcs-gw-collapsed");
                $wcsGwExapandableItem.each(function(){
                    $(this).find(".wcs-label-check").removeClass("wcs-inactive").find(":checkbox").attr("disabled", false);
                });
                if($wcsGwExapandable.find(":checkbox:checked").length) {
                    $wcsGwExapandableItemSubmitConfirm.attr("disabled", false).removeClass("wcs-gw-confirm-disabled");
                }
            });
        } else {
            $wcsGwExapandable.slideUp(function(){
                $wcsGwStaticBar.addClass("wcs-gw-collapsed");
                $wcsGwExapandableItem.each(function(){
                    $(this).find(".wcs-label-check").addClass("wcs-inactive").find(":checkbox").attr("disabled", true);
                });
                $wcsGwExapandableItemSubmitConfirm.attr("disabled", true).addClass("wcs-gw-confirm-disabled");
            });
        }
    });


    $(".wcs-gw-exapandable,#wcs-contactus-form").find("textarea").each(function() {
        var $this = $(this);
        if ($this.attr('maxlength')) {
            $this.unbind('change.max keyup.max keydown.max paste.max mouseup.max');
            $this.bind('change.max keyup.max keydown.max paste.max mouseup.max', updateMaxlengthInfo);
        }
    });

    $wcsGwExapandable.find("textarea").on("keyup", function(){
        var $this = $(this);
        var $previewLink = $this.parents(".wcs-gw-exapandable-item").find(".wcs-preview-link");

        if($this.val() !== "") {
            $previewLink.removeClass("wcs-preview-link-disabled").addClass("wcs-modal-box");
        } else {
            $previewLink.addClass("wcs-preview-link-disabled").removClass("wcs-modal-box");
        }
    });

    // Restricts right click menu on images
    $body.on('contextmenu','img,canvas',function(e) {
        return false;
    });

    var $wcsQtyContainer = $(".wcs-qty-container");
    var $wcsCustomDropdownContainer = $(".wcs-custom-dropdown-container");
    var $wcsDropdownIcon = $(".wcs-dropdown-icon");
    var $wcsShippingInfoWrapper = $(".wcs-shipping-info-wrapper");
    var $pdpOutOfStockEmailMe = $(".wcs-email-preorder a[pdp-outOfStock-emailMe]");
    var $wcsPdpCarousalItems = $('#wcs-pdp-carousal').find('ul.wcs-h-slider li');
    if ($("form.add-prod-item .add-bag-bg").hasClass("wcs-hide")) {
            if($wcsDropdownIcon.hasClass("wcs-hide")) {
                $wcsQtyContainer.removeClass("wcs-hide");
                $wcsCustomDropdownContainer.addClass("wcs-hide");
            }

            //$(".wcs-shipping-info-wrapper").addClass("wcs-hide");
            $wcsShippingInfoWrapper.addClass("border-top0px");
            $wcsQtyContainer.css("border-bottom", "2px solid #d6d6d6");
            /*When "Email me when available" link is present, show the "Available soon" message */
            if($pdpOutOfStockEmailMe.val()){
                $wcsShippingInfoWrapper.removeClass("wcs-hide");
                $wcsQtyContainer.addClass("border-bottom1px");
            }
    }

    $wcsPdpCarousalItems.off("click").on("click", function() {
        if($(".add-bag-bg").hasClass("wcs-hide"))
        {
            if($wcsDropdownIcon.hasClass("wcs-hide")) {
                $wcsCustomDropdownContainer.addClass("wcs-hide");
                $wcsQtyContainer.removeClass("wcs-hide");
            }

            $wcsShippingInfoWrapper.addClass("wcs-hide").addClass("border-top0px");
            $wcsQtyContainer.addClass("border-bottom1px");

        }
    });

    if($body.hasClass("wcs-zh_CN") && $(".wcs-shipping-info-wrapper .wcs-delivery-date #CustomizeAndBuy").hasClass("wcs-hide"))
    {
        $wcsQtyContainer.addClass("wcs-hide");
        $wcsShippingInfoWrapper.addClass("wcs-hide").css("border-bottom", "0px");
        /*When "Email me when available" link is present, show the "Available soon" message - CHINA */
        if($pdpOutOfStockEmailMe.length){
            $wcsShippingInfoWrapper.removeClass("wcs-hide").addClass("border-bottom2px");
        }
    }

    if($body.hasClass("wcs-zh_CN") && !($(".add-bag-bg").hasClass("wcs-hide")))
        {
            $wcsShippingInfoWrapper.removeClass("wcs-hide");
            $(".wcs-zh_CN .wcs-qty-container").css("padding-bottom", "24px");
            $("h6.wcs-half-top.wcs-color-666 a").addClass("wcs-left");
        }
    $wcsPdpCarousalItems.off('click').on('click', function() {
     //$(".wcs-shipping-info-wrapper").removeClass("wcs-hide");
        if($body.hasClass("wcs-zh_CN") && $(".wcs-shipping-info-wrapper .wcs-delivery-date #CustomizeAndBuy").hasClass("wcs-hide"))
        {
            $wcsQtyContainer.addClass("wcs-hide");
            $wcsShippingInfoWrapper.addClass("wcs-hide").addClass("border-bottom0px");
            /*When "Email me when available" link is present, show the "Available soon" message - CHINA */
            if($pdpOutOfStockEmailMe.length){
                $wcsShippingInfoWrapper.removeClass("wcs-hide").addClass("border-bottom2px");
            }
        }

        if($body.hasClass("wcs-zh_CN") && !($(".add-bag-bg").hasClass("wcs-hide")))
        {
            $wcsShippingInfoWrapper.removeClass("wcs-hide");
            $(".wcs-zh_CN .wcs-qty-container").css("padding-bottom", "24px");
            $("h6.wcs-half-top.wcs-color-666 a").addClass("wcs-left");
        }

    });
    var $shoppingTotalContainer = $('#form-wrapper').find('.wcs-shopping-total-container');
    var $shoppingPromoLabels = $shoppingTotalContainer.find('.wcs-delivery-subtotal .promo-label');
    $shoppingTotalContainer.find('.wcs-delivery-subtotal-price .promo-val').each(function(index, promoVal) {
        $(promoVal).css('height', $shoppingPromoLabels.eq(index).height());
    });

    var $pgTemplate = $("#pgTemplate");
    var $labelCheckAgreeConcent = $(".wcs-label-check[for=agreeConcent]");
    var $agreeConcent = $labelCheckAgreeConcent.find("#agreeConcent");
    var $agreeConcentErrorMessage = $labelCheckAgreeConcent.parents(".wcs-row").find(".wcs-error-message");
    if($pgTemplate.length && $pgTemplate.val() == "PaymentPage"){
        $labelCheckAgreeConcent.click(function(){
            setTimeout(function(){
                if($labelCheckAgreeConcent.hasClass("wcs-c-on")){
                    $agreeConcent.removeClass("ui-state-error");
                    $agreeConcentErrorMessage.removeClass("wcs-show");
                }
            },500);
        });
        var $labelCheckConsentBoxInput1 = $(".wcs-label-check[for=consent_box_1_input]");
        $labelCheckConsentBoxInput1.click(function(){
            setTimeout(function(){
                if($labelCheckConsentBoxInput1.hasClass("wcs-c-on")){
                    $('#consent_box_1_input').next().removeClass('checkbox_red');
                    $labelCheckConsentBoxInput1.find("#consent_box_1_input").removeClass("ui-state-error");
                    $labelCheckConsentBoxInput1.parents(".wcs-row").find(".wcs-error-message").removeClass("wcs-show");
                    $labelCheckConsentBoxInput1.next().hide();
                }
            },500);
        });
        var $labelCheckConsentBoxInput2 = $(".wcs-label-check[for=consent_box_2_input]");
        $labelCheckConsentBoxInput2.click(function(){
            setTimeout(function(){
                if($labelCheckConsentBoxInput2.hasClass("wcs-c-on")){
                    $('#consent_box_2_input').prev().removeClass('checkbox_red');
                    $labelCheckConsentBoxInput2.find("#consent_box_2_input").removeClass("ui-state-error");
                    $labelCheckConsentBoxInput2.parents(".wcs-row").find(".wcs-error-message").removeClass("wcs-show");
                    $labelCheckConsentBoxInput2.next().hide();
                }
            },500);
        });
    }

    //support CallBack Form
    var formid = $('#wcs_support_callback_form').attr('id');
    var chatForm = $('#wcs_support_chat_form').attr('id');
    var delivery = $('#delivery_information_form').attr('id');
    if((formid == "wcs_support_callback_form") || (chatForm == 'wcs_support_chat_form') || (delivery == 'delivery_information_form')) {
        $agreeConcentErrorMessage.css({"margin-left":"0px","width":"350px"});
        $labelCheckAgreeConcent.click(function(){
            setTimeout(function(){
                if($labelCheckAgreeConcent.hasClass("wcs-c-on")){
                $agreeConcent.removeClass("ui-state-error");
                $agreeConcentErrorMessage.removeClass("wcs-show");
                }
            },500);
        });
    }
    var newsletter = $('#clp_campaign').attr('id');
    if ((newsletter == "clp_campaign")) {
        $labelCheckAgreeConcent.click(function() {
            $agreeConcentErrorMessage.css({"margin-left":"0px","width":"350px"});
            setTimeout(function() {
                if ($labelCheckAgreeConcent.hasClass("wcs-c-on")) {
                    $agreeConcent.removeClass("ui-state-error");
                    $agreeConcentErrorMessage.removeClass("wcs-show");
                }
            }, 500);
        });
    }
    var payment_mode_form = $('#payment_mode_form').attr('id');
    if ((payment_mode_form == "payment_mode_form")) {
        var $labelCheckConsent = $(".wcs-label-check[for=consent]");
        $labelCheckConsent.click(function() {
            setTimeout(function() {
                if ($labelCheckConsent.hasClass("wcs-c-on")) {
                    $labelCheckConsent.find("#consent").removeClass("ui-state-error");
                    $labelCheckConsent.parents(".wcs-row").find(".wcs-error-message").removeClass("wcs-show");
                }
            }, 500);
        });
    }

    var unified_chat_form = $('#unified_chat_form').attr('id');
    if ((unified_chat_form == "unified_chat_form")) {
        $labelCheckAgreeConcent.click(function() {
            setTimeout(function() {
                if ($labelCheckAgreeConcent.hasClass("wcs-c-on")) {
                    $agreeConcent.removeClass("ui-state-error");
                    $labelCheckAgreeConcent.find(".wcs-checkbox").removeClass("ui-state-error");
                    $agreeConcentErrorMessage.removeClass("wcs-inline-block");
                }
            }, 300);
        });
    }

    var unified_call_form = $('#unified_call_form').attr('id');
    if ((unified_call_form == "unified_call_form")) {
        $labelCheckAgreeConcent.click(function() {
            setTimeout(function() {
                if ($labelCheckAgreeConcent.hasClass("wcs-c-on")) {
                    $agreeConcent.removeClass("ui-state-error");
                    $labelCheckAgreeConcent.find(".wcs-checkbox").removeClass("ui-state-error");
                    $agreeConcentErrorMessage.removeClass("wcs-inline-block");
                }
            }, 300);
        });
    }

    if ($('#same_as_checked').val() === 'no') {
        var storeId = $('#storeId').val();
        $('#billing_address_section').removeClass('wcs-hide');
        if (storeId === 10151) {
          $('.afterpay__block').addClass('wcs-hidden');
        }
    }

    //footer issue fix RB-7350
    $body.css("padding-bottom", 0);

    var loggedUserType = $('#userType').val();
    if(loggedUserType){
        $.cookie("rbuser_status", loggedUserType,{ path: '/'});
    }else{
        if($.cookie("rbuser_status") === null)
            $.cookie("rbuser_status", "G",{ path: '/'});
    }
    $(".wcs-shopping-item-content").each(function(){
        var $shoppingItemPrice = $(this).find(".wcs-shopping-item-price");
        $shoppingItemPrice.find(".cart-linethrough").width($shoppingItemPrice.find(".wcs-price").width() + 10);
    });
    //if($("#page").val()=="OrderOK"){
    //    //this function pushes the data to the tealium_data2track if the page is order confirmation
    //    callAnaytics();
    //}
    //vto code to hide virtual mirror link
    var $cachedVtoFlag = $("#cached_vtoFlag");
    if($cachedVtoFlag.val() == 'true' || $cachedVtoFlag.val() == 'TRUE'){
        $("#a_Virtual_Mirror").parent().hide();
    }

    var countryValue = $("#country").val() || $("#country_value").val();
    var $zips = $('#zip_code,#zip-bill,#zip');

    if(countryValue === 'SE'){
        if($('#zip_code').length > 0 || $('#zip-bill').length > 0 || $('#zip').length > 0){
            $zips.on('keypress change', function () {
              $(this).val(function (index, value) {
                return value.replace(/\W/gi, '').replace(/(.{3})/g, '$1 ');
              });
            });
        }
    }


    $(".wcs-details-delivery-address a.wcs-modal-box").on("click",function(e){
        e.preventDefault();
        if(($(e.currentTarget).attr("data-attr") === "wcs_myDetails_editHomeAddress") &&
            (countryValue === 'SE')){
            setTimeout(function(){
                $zips.on('keypress change', function () {
                  $(this).val(function (index, value) {
                    return value.replace(/\W/gi, '').replace(/(.{3})/g, '$1 ');
                  });
                });
            },500);
        } else if (($(e.currentTarget).attr("data-attr") === "wcs_myDetails_editHomeAddress") &&
            (countryValue === 'KR')) {
            setTimeout(function () {
                new privacyPolicyCheckbox('.delivery-information-form-details').init();
            }, 500);
        }
    });


    if ($('#page').val() === 'ShopCartDisplay') {
        if(countryValue && countryValue !== 'KR' && countryValue !== 'JP' && countryValue !== 'CN') {
            displayDeliveryMessage();
        }
    }

    if ($('#WC_PaymentInfoForm_fax1_1')) {
            $('#WC_PaymentInfoForm_fax1_1').keyup(function(){
              $(this).val($(this).val().toUpperCase());
            })
        }
});

$window.load(function () {
    var $zoomSlider = $("#zoom_slider");
    if ($zoomSlider.length) {
        $zoomSlider.find('img:not([alt])').attr("alt", "image zoomed");
    }

    // plp sorting
    if ($('#pageIdentifier').val() === "plp") {
        if (location.href.indexOf('orderBy') != -1) {
            var orderString = 'orderBy=';
            var orderBy = location.href.substring(location.href.indexOf('orderBy') + orderString.length, location.href.indexOf('orderBy') + orderString.length + 1);
        }
        if (orderBy) {
            $('li[data-entry-value = ' + orderBy + ']').click();
        }
    }

    if (wcs_config.viewTaskName === 'ShopCartDisplayView') {
       if (!$('input.wcs-shipping-selector').toArray().some(el => el.checked)) {
          if(document.referrer.indexOf('DeliveryDetailsView') !== -1){
            $('#wcs-shipping-selector-sfs').click(function (e) {
              e.preventDefault();
           });
          }
       }
    }
});

window.get_installments = function() {
    var isYKBEnabled = $('#isYKBEnabled').length > 0;
    var isGarantiEnabled = $('#isGarantiEnabled').length > 0;

    var noOfDigits;     //Counter for number of digits of the credit card number entered
    if (isYKBEnabled || isGarantiEnabled) {
        var $WCPaymentInfoFormCreditCardNumber = $('#WC_PaymentInfoForm_creditCardNumber_1');
        var $paymentInstalmentsWrapper = $('.paymentInstalments-wrapper');
        var $paymentInstalmentsYKB = $('.paymentInstalments-YKB');
        var $paymentInstalmentsGarnt = $('.paymentInstalments-Garnt');
        var $paymentInstalmentsBanksListItems = $('ul.paymentInstalments-banks-list li');
        var $YKBList = $('.YKB-list');
        var $GarntList = $('.Garnt-list');

        function hideInfo() {
            $YKBList.remove();
            $GarntList.remove();
            $paymentInstalmentsBanksListItems.removeClass('active');
            $paymentInstalmentsWrapper.hide();
        }

        $WCPaymentInfoFormCreditCardNumber.unbind('focusout').bind('focusout', function (key, storeId, bankBinCode, orderTotal) {
            //if (key.charCode > 48 || key.charCode < 57 || key.charCode === 8) {
                var accountNo = $WCPaymentInfoFormCreditCardNumber.val().trim().replace(/ +/g, "");
                noOfDigits = accountNo.length;
                //var bank_programs = ["YKB", "Garnt"];
                if (noOfDigits >= 6) {
                    var bankBinCode = accountNo.substring(0, 6);
                    var orderTotal = $('#piAmount').val();
                    var storeId = $('#storeId').val();
                    if(storeId === undefined) {
                        storeId = $('#shp_storeId').val();
                    }

                    $.ajax({
                        url: 'GetInstallments?storeId='+storeId+'&bankBinCode='+bankBinCode+'&orderTotal='+orderTotal,
                        cache: true,
                        dataType: "json",
                        type: 'GET',
                        success: function (data) {
                            if(data !== null){
                                var installmentsEnabled = data.InstallmentsEnabled;
                                var bank_program = data.PaymentGateway;
                                if(installmentsEnabled == "true")
                                {
                                    if((bank_program == "YKB" && isYKBEnabled) || (bank_program == "Garnt" && isGarantiEnabled))
                                    {
                                        $paymentInstalmentsWrapper.show();

                                        if(isYKBEnabled) {
                                            $paymentInstalmentsYKB.show();
                                        } else {
                                            $paymentInstalmentsYKB.hide();
                                        }

                                        if(isGarantiEnabled) {
                                            $paymentInstalmentsGarnt.show();
                                        } else {
                                            $paymentInstalmentsGarnt.hide();
                                        }

                                        $paymentInstalmentsBanksListItems.removeClass('active');
                                        $('#' + bank_program).css('display', 'block');
                                        $('.paymentInstalments-' + bank_program).addClass('active');


                                        var i = 0;

                                        $('.'+ bank_program+ '-list').remove();
                                        $.each(data.Installments, function () {
                                            $('#' + bank_program).append('<ul class="' + bank_program + '-list">' +
                                                    '<li> <input type="radio" name="noOfInstallments" value="' + data.Installments[i].Count + '">' +
                                                    data.Installments[i].Count + '</li>'+
                                                    '<li>' + data.Installments[i].InstallmentAmount +
                                                    '</li>'+
                                                    '<li>' +
                                                    data.Installments[i++].SumAmount + '</li>').append('</ul>');
                                        });

                                        $('.paymentInstalments-block input[type=radio]:first').each(function(){
                                            $(this).attr('checked', true);
                                        });
                                    } else{
                                        hideInfo();
                                    }
                                }
                                else{
                                    hideInfo();
                                }
                            } else{
                                hideInfo();
                            }

                        }
                    });
                }

                else if(noOfDigits < 6)
                {
                    hideInfo();
                }
            }
        );
    }
};

function enableGiftWrapTextarea(obj) {
    var $obj = $(obj);
    var $objParent = $obj.parent();
    var $textarea = $objParent.find("textarea");
    var $previewLink = $objParent.find(".wcs-preview-link");
    var $deliveryHintText = $objParent.find(".wcs-delivery-hint-text");
    var $exapandable = $obj.parents(".wcs-gw-exapandable");
    var $confirm = $exapandable.find(".wcs-gw-confirm");
    if($obj.find(":checkbox").is(":checked")) {
        $textarea.attr("disabled", false).removeClass("wcs-gw-exapandable-item-msg-disabled");

        if($textarea.val() !== "") {
            $previewLink.removeClass("wcs-preview-link-disabled").addClass("wcs-modal-box");
        }

        $deliveryHintText.removeClass("wcs-delivery-hint-text-disabled");

        if($exapandable.find(":checkbox:checked").length > 0) {
            $confirm.attr("disabled", false).removeClass("wcs-gw-confirm-disabled");
        }

    } else {
        $textarea.attr("disabled", true).addClass("wcs-gw-exapandable-item-msg-disabled");
        $previewLink.addClass("wcs-preview-link-disabled").removeClass("wcs-modal-box");
        $deliveryHintText.addClass("wcs-delivery-hint-text-disabled");

        if($exapandable.find(":checkbox:checked").length === 0 && $("#giftMessageSelected").val() == "false") {
            $confirm.attr("disabled", true).addClass("wcs-gw-confirm-disabled");
        }
    }
}

function filterFacetParams(param){
   var newparam=param.replace(/,/g,'RCOMMAR');
   newparam=decodeURIComponent(newparam);
   //newparam=newparam.replace(/\+/g,' ');
   newparam=encodeURIComponent(newparam).replace(/RCOMMAR/g,',');
   //console.log("new param"+ newparam);
   return newparam;
   //return param;
}





function unescapeHtml(safe) {
    return safe && safe.replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&#034;/g, '"')
        .replace(/&#039;/g, "'");
}


window.clearCreditCardDetailsFromLocalStorage = function() {
    var storeIdValue = $("#storeId").val();
    var langIdValue = $("#langId").val();
    localStorage.removeItem("rayban." + storeIdValue + "." + langIdValue +".card_details.cardnumber");
    localStorage.removeItem("rayban." + storeIdValue + "." + langIdValue +".card_details.cardtype");
    localStorage.removeItem("rayban." + storeIdValue + "." + langIdValue +".card_details.nameoncard");
    localStorage.removeItem("rayban." + storeIdValue + "." + langIdValue +".card_details.expiremonth");
    localStorage.removeItem("rayban." + storeIdValue + "." + langIdValue +".card_details.expireyear");
    //localStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() +".card_details.ccv");
};
window.populateCreditCardDetailsToLocalStorage = function() {
    var storeIdValue = $("#storeId").val();
    var langIdValue = $("#langId").val();
    localStorage.setItem("rayban." + storeIdValue + "." + langIdValue +".card_details.cardnumber", $('#WC_PaymentInfoForm_creditCardNumber_1').val());
    localStorage.setItem("rayban." + storeIdValue + "." + langIdValue +".card_details.cardtype", $('#WC_PaymentInfoForm_creditCardType').val());
    localStorage.setItem("rayban." + storeIdValue + "." + langIdValue +".card_details.nameoncard", $('#name_on_card').val());
    localStorage.setItem("rayban." + storeIdValue + "." + langIdValue +".card_details.expiremonth", $('#WC_PaymentInfoForm_expireMonth_1').val());
    localStorage.setItem("rayban." + storeIdValue + "." + langIdValue +".card_details.expireyear", $('#WC_PaymentInfoForm_expireYear_1').val());
    //localStorage.setItem("rayban." + $("#storeId").val() + "." + $("#langId").val() +".card_details.ccv", $('#WC_PaymentInfoForm_cardVerificationNumber_1').val());
};

window.display_Modal_1 = function(getDataAttr) {
    var storeIdValue = $("#storeId").val();
    var langIdValue = $("#langId").val();
    var country = $("#county").val();
    var pageName = $("#page").val();
    var currency = $("#currency").val();
    var userType = $("#userType").val();
    var $item = $('#' + getDataAttr);
    var $isRoxEnabled = $("#isRoxEnabled");
    var isRoxEnabled = $isRoxEnabled.length && $isRoxEnabled.val() === "true";

    var docht = $document.height();
    $(".wcs-fadeout-full").removeClass('wcs-hide').css({
        'height': docht + 'px'
    });
    $item.show();

    display_center_1($item);
    if(window.isROX == "true" || isRoxEnabled) { $("#D_QuickView_Prod").css("display", "none"); }
    else { $("#D_QuickView").css("display", "none"); }

    $("#wcs-compare-view .wcs-addtobag").off("click").on("click",function(){
        sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".sidebar_refreshLS");
        sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".headerprofile_refreshLS");
    });
};


window.getByValue4= function(arr, value) {
    var o;
    for (var i=0, iLen=arr.length; i<iLen; i++) {
        o = arr[i];

        for (var p in o) {
            if (o.hasOwnProperty(p) && o[p] == value) {
                return o;
            }
        }
      }
};

window.getCookie = function(CookieName) {
    var Cookies = document.cookie;
    var CookieValue = null;
    var Offset = -1;
    var End = -1;
    CookieName += "=";
    Offset = Cookies.indexOf(CookieName);
    if (Offset >= 0) {
        End = Cookies.indexOf(";", Offset);
        if (End < 0) {
            End = Cookies.length;
        }
        CookieValue = Cookies.substring(Offset + CookieName.length, End);
    }
    return (CookieValue);
};

window.SetCookie = function(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays === null || nDays === 0) nDays = 1;
    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString() + ";path=/;";
};

/*
     * function for hiding the error message notification of the
     * field
 */

window.hide_error_message = function(fieldObj) {
    fieldObj.parents('.wcs-row').find('.wcs-error-message').removeClass('wcs-show');
};

/*function to show error message on drop down*/
window.show_dropDown_error_message = function(fieldObj) {
    var fieldObjParents = fieldObj.parents('.wcs-row');
    fieldObj.parents('.wcs-custom-dropdown-container').addClass('ui-state-error');
    fieldObjParents.find('.wcs-error-message').addClass('wcs-show');
    fieldObjParents.css('color', '#EC1E24');
};
/*function to hide error message on drop down*/
window.hide_dropDown_error_message = function(fieldObj) {
    var fieldObjParents = fieldObj.parents('.wcs-row');
    fieldObj.parents('.wcs-custom-dropdown-container').removeClass('ui-state-error');
    fieldObjParents.find('.wcs-error-message').removeClass('wcs-show');
    fieldObjParents.removeAttr('style');
};

//refresh content of Shop Runner
window.shoprunnerUpdateContent = function(){
    var $shoppingCartTitle = $('#shopping_cart_title');
    var $cartMessage = $('.sr_cartMessage');
    var $fullNonSR = $('#fullNonSR');
    var fullNonSRValue = $fullNonSR.val();
    var srMixValue = $('#srMix').val();
    var $srDualEligibilityDiv = $('div[name=sr_dualEligibilityDiv]');
    var $srHeaderDiv = $('div[name=sr_headerDiv]');
    if(getCookie('sr_token') !== null){
        $cartMessage.removeClass('wcs-hide');

        if($fullNonSR.length > 0){
            if($shoppingCartTitle.is(':visible')){
                if(fullNonSRValue == 'false' && srMixValue == 'false' && $shoppingCartTitle.is(':visible')){
                    $srDualEligibilityDiv.addClass('wcs-hide');
                    $srHeaderDiv.removeClass('wcs-hide').addClass('sr_headerDiv');
                }
                if(fullNonSRValue == 'true' || srMixValue == 'true' && $shoppingCartTitle.is(':visible')){
                    $srHeaderDiv.addClass('wcs-hide');
                    $srDualEligibilityDiv.removeClass('wcs-hide').addClass('sr_headerDiv');
                }
            }else{
                $srDualEligibilityDiv.removeClass('sr_headerDiv').addClass('wcs-hide');
                $srHeaderDiv.addClass('wcs-hide');
            }
            if(fullNonSRValue != 'true'){
                var checked = $('input[name=shipping]:checked').attr('id');
                if($('.wcs-shipping-mode').length > 0 && checked == 'wcs-shipping-selector-std'){
                    $cartMessage.prev().addClass('wcs-hide');
                    $cartMessage.removeClass('wcs-hide');
                }else{
                    $cartMessage.prev().removeClass('wcs-hide');
                    $cartMessage.addClass('wcs-hide');
                }
                $('.wcs-shipping-shoprunner').removeClass('wcs-hide');
                $('.wcs-shipping-standard').addClass('wcs-hide');
                if(!$('.wcs-delivery-total-cost .wcs-delivery-subtotal-price .wcs-delivery-cost').hasClass('express')){
                    $('.wcs-delivery-subtotal .wcs-delivery-cost').text('Shoprunner Shipping');
                }
                if(!$('.wcs-product-confirm-div .shipping-cost').hasClass('express')){
                    $('.sr_cartMessage_Confirmation').text('Shoprunner Shipping');
                }
                if($('.sr_headerDiv').length === 0){
                    var $srCartMessage = $('.wcs-cost-innerContainer .sr_cartMessage');
                    $srCartMessage.prev().addClass('wcs-hide');
                    $srCartMessage.removeClass('wcs-hide');
                }

            }else{
                $cartMessage.addClass('wcs-hide');
            }

        }


    }else{
        $srDualEligibilityDiv.removeClass('sr_headerDiv').addClass('wcs-hide');
        $('.sr_cartMessage,.wcs-shipping-shoprunner').addClass('wcs-hide');
    }
    if($shoppingCartTitle.is(':hidden')){
        $srDualEligibilityDiv.removeClass('sr_headerDiv').addClass('wcs-hide');
        $srHeaderDiv.addClass('wcs-hide');
    }
    if($('.wcs-content-bag').is(':visible') || $('.sr_pdp').length > 0){
        if(typeof sr_updateMessages == 'function'){
            sr_updateMessages();
        }
    }
};

$(function() {
  if ($body.hasClass('wcs-en_US')) {
    var isShopRunnerEnabled = $('#shopRunnerEnabled').attr('value');
    if(isShopRunnerEnabled && isShopRunnerEnabled === "true") {
        var $wcsShippingStandard = $('.wcs-shipping-standard');
        var $wcsShippingShoprunner = $('.wcs-shipping-shoprunner');
      _shoprunner_com.calls = {
        on_sign_out: function () {
          $wcsShippingStandard.removeClass('wcs-hide');
          $('.sr_cartMessage').prev().removeClass('wcs-hide');
          $wcsShippingShoprunner.addClass('wcs-hide');
          $('div[name=sr_headerDiv]').removeClass('wcs-hide').addClass('sr_headerDiv');
          $('div[name=sr_dualEligibilityDiv],.sr_cartMessage').addClass('wcs-hide');
        },
        on_sign_in: function () {
          $wcsShippingStandard.addClass('wcs-hide');
          $wcsShippingShoprunner.removeClass('wcs-hide');
          //$('.sr_cartMessage').prev().addClass('wcs-hide');
          shoprunnerUpdateContent();  // Refresh ShopRunner divs
        }
      };
    }
    if (getCookie('sr_token') !== null) {
      $('.sr_shippingSummaryDiv').removeClass('wcs-hide');
    }
  }
});

/*
 * function for hiding the error message notification of the
 * field
 */

window.hide_error_message = function(fieldObj) {
    fieldObj.parents('.wcs-row').find('.wcs-error-message').removeClass('wcs-show');
};

/*function to show error message on drop down*/
window.show_dropDown_error_message = function(fieldObj) {
    var fieldObjParents = fieldObj.parents('.wcs-row');
    fieldObj.parents('.wcs-custom-dropdown-container').addClass('ui-state-error');
    fieldObjParents.find('.wcs-error-message').addClass('wcs-show');
    fieldObjParents.css('color', '#EC1E24');
};
/*function to hide error message on drop down*/
window.hide_dropDown_error_message = function(fieldObj) {
    var fieldObjParents = fieldObj.parents('.wcs-row');
    fieldObj.parents('.wcs-custom-dropdown-container').removeClass('ui-state-error');
    fieldObjParents.find('.wcs-error-message').removeClass('wcs-show');
    fieldObjParents.removeAttr('style');
};

function manageInputStateClass(inputElement, successFlag, parentEl) {
    const uiErrorClass = 'ui-state-error';
    const uiValidClass = 'ui-state-valid';
    const validRowClass = 'rb-validrow';
    const invalidRowClass = 'rb-invalidrow';
    const inputRowElem = parentEl? parentEl : inputElement.closest('.rb-fieldrow');

    if(successFlag) {
        inputElement.removeClass(uiErrorClass).addClass(uiValidClass);
        inputRowElem.removeClass(invalidRowClass).addClass(validRowClass);
    } else {
        inputElement.removeClass(uiValidClass).addClass(uiErrorClass);
        inputRowElem.removeClass(validRowClass).addClass(invalidRowClass);
    }

}

function getAddressInfo($zipCode, $zipCodeRow, $currForm, requiredFieldLength, $wcsRecalculateTax, callback) {
    const address = $zipCode.val();
    const geocoder = new google.maps.Geocoder();
    const countryAbbr = $('input#country_value').val();
    //geocoder function
    geocoder.geocode({ 'address': address,'componentRestrictions':{'country': countryAbbr}}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            //set error class if the user has added a non-existent zip code
            if(results[0].address_components.length === 1) {
                manageInputStateClass($zipCode, false, $zipCodeRow);
            } else {
                const callbackResult = callback(results);
                if (callbackResult && !$currForm.find('.wcs-dropdown-validation:visible').length && getValid_fieldLength($currForm.attr('id')) == requiredFieldLength || $wcsRecalculateTax.is(':visible')) {
                    //remove error classes
                    manageInputStateClass($zipCode, true, $zipCodeRow);
                    //go to the next step
                    tax_button_fn(true);
                }else {
                    manageInputStateClass($zipCode, false, $zipCodeRow);
                }
            }
        }else {
            //set error class if geocoder result is 'KO'
            manageInputStateClass($zipCode, false, $zipCodeRow);
        }
    });
}

window.tax_submit_fn = function() {
    const countryValue = $('#country_value').val();
    var $wcsTaxButton = $("#wcs-tax-button");
    var $wcsTaxCalForm = $('#wcs-taxCal-form');
    const zipCodeElement = $wcsTaxCalForm.find('#zip_code');

    zipCodeElement.focusout(function() {
    	if ($(this).val() != '' && $(this).attr('placeholder')!= '') {
    	    $(this).parent().addClass('rb-floating');
	    } else {
	    	$(this).parent().removeClass('rb-floating');
	    }

    	if ($(this).parent().hasClass('rb-invalidrow')) {
    		$(this).parent().children('.wcs-error-message').addClass('wcs-inline-block');
    	}
    });
    window.zipcode_pattern(zipCodeElement, countryValue);
    $wcsTaxCalForm.h5Validate({
        invalidCallback: function() {
            window.show_error(zipCodeElement);
        },
        validCallback: function() {
            window.hide_error(zipCodeElement);
        },
    });

    $wcsTaxButton.off('click').on('click', function(e) {
        e.preventDefault();

        var $zipCode = $wcsTaxCalForm.find('#zip_code');
        var $currForm = $wcsTaxButton.closest('form');
        var $state = $wcsTaxCalForm.find("#state");
        var $newCity = $wcsTaxCalForm.find('#new_city');
        var requiredFieldLength = $currForm.find('input:text.required:visible,textarea.required:visible').length;
        var dropDownVal = $wcsTaxCalForm.find('.wcs-dropdown-text').val();
        var storeValue = $("#store").val();
        var $wcsRecalculateTax = $('#wcs-recalculate-tax');
        var $uiErrorState = $currForm.find('.ui-state-error');

        var $zipCodeRow;
        if($body.hasClass('wcs-fr_CA') || $body.hasClass('wcs-en_CA')){
            $zipCodeRow = $zipCode.parent();
        } else {
            $zipCodeRow = $wcsTaxCalForm.find('.rb-fieldrow');
        }

        var zip_code = $zipCode.val();

        if($body.hasClass('wcs-en_US')){
            if (zip_code.length != 5) {
                manageInputStateClass($zipCode, false, $zipCodeRow);
            }
        } else {
            if (zip_code === '') {
                manageInputStateClass($zipCode, false, $zipCodeRow);
            }
        }

        if ($body.hasClass('wcs-fr_CA') || $body.hasClass('wcs-en_CA')) zipCodeCAValidation();

        if (dropDownVal == "Select State") {
            $wcsTaxCalForm.find(".wcs-custom-dropdown-container.wcs-basket-state").removeClass("ui-state-valid").addClass("ui-state-error");
        }
        const countryNameVal = $wcsTaxCalForm.find('#country_value').val();
        //for us locale
        if(countryNameVal === 'us'){
            if(zip_code.length === 5) {
                getAddressInfo($zipCode, $zipCodeRow, $currForm, requiredFieldLength, $wcsRecalculateTax, function(results) {
                    let stateName = null, city = null;
                    $.each(results[0].address_components, function (i, address_component) {

                        if (address_component.types[0] == 'administrative_area_level_1') {
                            stateName = address_component.short_name;
                        }

                        if (address_component.types[0] == 'locality'){
                            city = address_component.long_name;
                        }
                    });

                    $state.val(stateName);
                    $newCity.val(city);

                    sessionStorage['rayban.'+ storeValue +'.address.delivery.state'] = $state.val();
                    sessionStorage['rayban.' + storeValue + '.address.delivery.zipCode'] = $zipCode.val();
                    sessionStorage['rayban.'+ storeValue +'.address.delivery.city'] = $newCity.val();
                    return true;
                });
            }

        } else if(countryNameVal === 'ca') {
            getAddressInfo($zipCode, $zipCodeRow, $currForm, requiredFieldLength, $wcsRecalculateTax, function(results) {
                //checking that current zip code belong to chosen state
                const canadaStateSelectValue = $wcsTaxCalForm.find('#state').val().toUpperCase();
                let validationFlag = false;
                $.each(results[0].address_components, function (i, address_component) {

                    if (address_component.types[0] == 'administrative_area_level_1') {
                        validationFlag = address_component.short_name.toUpperCase() === canadaStateSelectValue;
                    }
                });

                sessionStorage['rayban.'+ storeValue +'.address.delivery.state'] = $state.val();
                sessionStorage['rayban.' + storeValue + '.address.delivery.zipCode'] = $zipCode.val();

                return validationFlag;
            });
        }
        else{
            if (!$uiErrorState.length) {
            sessionStorage["rayban."+ storeValue +".address.delivery.state"] = $state.val();
            sessionStorage["rayban." + storeValue + ".address.delivery.zipCode"] = $zipCode.val();
                if (!$currForm.find(".wcs-dropdown-validation:visible").length && getValid_fieldLength($currForm.attr('id')) == requiredFieldLength || $wcsRecalculateTax.is(':visible')) {
                    tax_button_fn(true);
                }
            }
        }

        SetCookie("TaxChange", "yes");
        // reset cookie
        $.removeCookie('ClearDeliveryFormData', {
          path: '/'
        });
        SetCookie("ClearDeliveryFormData", "yes");

        tealium_data2track.push({
            id: 'Click',
            data_element_id: 'X_CartPage_TaxCalc_Submit',
        });
    });
    $wcsTaxCalForm.submit(function(e){
      e.preventDefault();
      $wcsTaxButton.click();
   });
};

/* Textbox promocode enters */
window.promo_textbox_focusBlur = function() {
    var $DCartPagePromoCodeApply = $("#D_CartPage_PromoCode_Apply");
    var $wcsPromoApplyButton = $("#wcs-promo-apply-button");
    var $promocodeInput = $("#D_CartPage_PromoCode_Input");

    $promocodeInput.focus(function() {
        var $this = $(this);
        if ($this.val() == this.defaultValue) {
            $this.val('');
        }
    });

    $promocodeInput.blur(function() {
        var $this = $(this);
        if ($this.val() === '') {
            $this.val(this.defaultValue);
            $this.closest('.rb-fieldrow').addClass('rb-invalidrow');
        }
    });
    $promocodeInput.bind('input keyup', function(e) {
        var wcs_promo_code = $promocodeInput.val().length;
        if (wcs_promo_code === 0) {
            $promocodeInput.closest('.rb-fieldrow').addClass('rb-invalidrow');
        }
        if (wcs_promo_code > 0) {
            $promocodeInput.closest('.rb-fieldrow').removeClass('rb-invalidrow').addClass('rb-validrow');
        }
    });

    $promocodeInput.bind('keypress', function(e) {
        if (e.keyCode == 13) {
            $DCartPagePromoCodeApply.trigger('click');
            $wcsPromoApplyButton.trigger('click');
            e.preventDefault();
        }
    });

};

window.apply_promotion = function() {
    var invalid = false,
        getValue;

    $("#D_CartPage_PromoCode_Apply").click(function() {
        var $inValidPromotionCodes = $('#inValidPromotionCodes');
        var $DCartPagePromoCodeInput = $('#D_CartPage_PromoCode_Input');
        if($DCartPagePromoCodeInput.val().toLowerCase().includes('comppromo')){
            $DCartPagePromoCodeInput.val('');
        }
        if($('#wcsCoutryAndLangId').val() === 'en_US' && $inValidPromotionCodes.length){
            var values = $inValidPromotionCodes.val().toLowerCase().replace(/\s/g,'');
            var test = $DCartPagePromoCodeInput.val().toLowerCase();
            var promo = values.split(',');
            for (var i=0; i <  promo.length; i++){
                if(test.indexOf(promo[i]) !== -1){
                    invalid = true;
                    break;
                }else{
                    invalid = false;
                }
            }
        }else{
            invalid = false;
        }
        getValue = $DCartPagePromoCodeInput.val();
        if (getValue) {
            var params = {};
            params.promoCode = getValue;
            params.orderId = $('#orderId').val();
            params.taskType = 'A';
            params.URL = "ShopCartDisplayView";
            params.isCalculateViewRequired = "true";
            params.promoAjax = "true";
            params.storeId = $('#storeId').val();
            var fromPageName = $('input[name="fromPageName"]').val();
            var $wcsNoteGreen = $('.wcs-note-green');
            var errorBlock = $('.wcs-note-red');
            var $rbAddAnother = $('#rb-add-another11');
            if(undefined !== fromPageName){
                params.fromPageName = fromPageName;
            }
            if(!invalid){
                $.ajax({
                    type: "POST",
                    url: "AjaxPromotionCodeManage",
                    data: params,
                    dataType: 'html',
                    success: function(response) {

                        $('#mmWrapper').appendTo('.rb-footer')

                        // RB-41650 removing from storage auto applied promoCode
                        if (localStorage['promoCodeToApply']) {
                            localStorage.removeItem('promoCodeToApply');
                        }
                        $('#orderSummary').html(response);
                        ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                        if (window.wcs_config.klarnaExpress.enabled === 'true') {
                            ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                        }
                        if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                            if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                                ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                            }
                        }
                        if ($("#promoCodeErrorMessage").val() !== "") {
                            deleteCookieCart('promoCookie', '/');
                            var errorMessage = $('#ajaxErrorMessage').val();
                            errorBlock.parent('div').addClass('wcs-hide');
                            errorBlock.show().parent('div#promoerror').removeClass('wcs-hide');
                            //$('#promotionErrorMessage').text(errorMessage); Disable double message error
                            $rbAddAnother.addClass('rb-invalid-promo');

                            $wcsNoteGreen.parent('div#promoremove').addClass('wcs-hide');
                            $wcsNoteGreen.hide();
                            $('#promoremove').removeClass('wcs-hide');
                            calculate_tax_fn();
                            checkout_giftcard_validation();
                            giftcard_bindevents_fn();
                            dropscrollerFn();
                            select_dropbox_value();
                            expand_dropbox();
                            collapse_dropbox();
                            key_nav_dropdown();
                            tax_submit_fn();
                            apply_promo_link_click();
                            apply_promo_idme_link_click();
                            idme_links();
                            promo_textbox_focusBlur();
                            apply_promotion();
                            remove_promotion();
                            dropscroller_hover_fn();
                            validateGiftCard();
                            if (Rayban.AfterPay) {
                            	Rayban.AfterPay.initOverlay();
                            }
                            if ($window.scrollTop() > 160) {
                                $window.scrollTop(160);
                            }
                            Rayban.analytics.promoCodeApplyError(errorMessage, getValue);
                            setTimeout(function(){ $('#promoerror').show() }, 2000);

                        } else {

                            errorBlock.parent('div#promoerror').addClass('wcs-hide');
                            /*$("#wcs-apply-promo").addClass('wcs-promotion-added');*/
                            $wcsNoteGreen.hide();
                            $('#promosuccess').removeClass('wcs-hide').find('.wcs-note-green').show();

                            $("#subTotal").html($("#subTotalCalc").html());
                            calculate_tax_fn();
                            checkout_giftcard_validation();
                            giftcard_bindevents_fn();
                            dropscrollerFn();
                            select_dropbox_value();
                            expand_dropbox();
                            collapse_dropbox();
                            key_nav_dropdown();
                            tax_submit_fn();
                            apply_promo_link_click();
                            apply_promo_idme_link_click();
                            idme_links();
                            promo_textbox_focusBlur();
                            apply_promotion();
                            remove_promotion();
                            dropscroller_hover_fn();
                            validateGiftCard();
                            //price strike analytics
                            Rayban.analytics.promoCodeApplySuccess($('#pcode').val());
                            $('#wcs-cart-container').load("MiniCartView?storeId=" + params.storeId + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                                openLinksInNewTab();
                            });
                            if (Rayban.AfterPay) {
                            	Rayban.AfterPay.initOverlay();
                            }
                            clearSessionStorage();
                            document.cookie = 'promotionAppliedPageReload=promotionAppliedPageReload';
                            deleteCookieCart('promoCookie');
                            //for update cart data after promo apply
                            updatePromoCartData(true);
                        }
                        if($('#rb-add-another11').length > 0){
                            $('#mmWrapper').insertBefore('#rb-add-another11')
                        } else {
                            $('#mmWrapper').insertBefore('#D_CartPage_PromoCode_Apply')
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {}
                }).done(function(resp) {
                    $('body').trigger('changeItemsQuantity');
                });
            }else{
                errorBlock.parent('div').addClass('wcs-hide');
                errorBlock.show().parent('div#promoerror').removeClass('wcs-hide');

                $wcsNoteGreen.parent('div#promoremove').addClass('wcs-hide');
                $wcsNoteGreen.hide();

                $DCartPagePromoCodeInput.val('');
                $rbAddAnother.addClass('rb-invalid-promo');
                $('#wcs-apply-promo-code-div').addClass('wcs-shopping-hide');
                $('a[data-show=#wcs-apply-promo-code-div]').removeClass('wcs-shopping-hide');
                if ($window.scrollTop() > 160) {
                    $window.scrollTop(160);
                }
            }
            return;

        } else {
            $DCartPagePromoCodeInput.closest('.rb-fieldrow').addClass('rb-invalidrow');
        }
    });
};

window.tax_button_fn = function(submitvalue) {

    var locale = $("#localeId").val();
    var errorMessage = null;
    var countryCode = $("#countryCode").val() || $("#country").val();
    var genericErrorMsg = $("#generic_errorMsg").val();
    var compareMsg = $("#compare_errorMsg").val();
    var zipCodeElement = $('#zip_code');
    var zipCode = zipCodeElement.val();
    var zipCodeLength = zipCode? zipCode.length : 0;
    var maxZipCodeLength = parseInt($("#zip_code").attr('maxlength'));
    if($('#pageNameValue').val() === 'Delivery' && $('#control-tower-enabled').val() === 'true' && countryCode !== "BR") {
        if(zipCode) {
            window.checkDeliveryDateFromZip(zipCode);
        }
    }
    if (countryCode !== "CA" && countryCode !== "US") {
        return false;
    }
    if (countryCode == "CA") {
        var caMinZipCodeLength = parseInt($("#zipCode_min_length").val());
    }
    $.trim(zipCode);

    var $invalidZipCode = $("#invalidZipCode");
    var isDeliveryAddressAdded = $("#isDeliveryAddressAdded").val();
    // start---Checking the country & zipCode length
    function markInvalidZipCode($invalidZipCode) {
        $invalidZipCode
            .empty()
            .addClass("wcs-note-red")
            .text(errorMessage)
            .css("color", "#F00000 ")
            .show();
        //mark fields like invalid
        manageInputStateClass(zipCodeElement, false, null);
    }
    if (zipCode !== null && zipCode !== "") {
        if (countryCode == "US" && $.isNumeric(zipCode)) {
            if (zipCodeLength != maxZipCodeLength) {
                errorMessage = $("#usa_zipCode_errorMsg").val();
                markInvalidZipCode($invalidZipCode);
                zipCode = null;
                return false;
            }
        } else if (countryCode == "CA") {
            if (maxZipCodeLength < zipCodeLength) {
                errorMessage = $("#ca_zipCode_errorMsg").val();
                markInvalidZipCode($invalidZipCode);
                zipCode = null;
                return false;
            }
        } else {
            errorMessage = $("#zipCode_numeric_errorMsg").val();
            markInvalidZipCode($invalidZipCode);
            zipCode = null;
            return false;
        }
    } // End
    var orderItemId = null;
    var orderItemIdVal = null;
    var memberId = $("#memberId").val() || $("#shp_userId").val();
    var productType = null;
    var productTypeVal = null;

    var city=$('#new_city').val() || $("#city").val();
    var state = $("#state").val() || $("#WC_State_DropDown").val();
    var orderId = $("#orderId").val() || $("#shp_orderId").val();
    var catalogId = $("#catalogId").val();
    var storeId = $("#storeId").val() || $("#shp_storeId").val();
    var langId = $("#langId").val();
    var fromPageName = $('input[name="fromPageName"]').val();
    if(undefined === fromPageName){
        fromPageName = "";
    }
    var ajaxUrl = "AjaxOrderCalculate?orderId=" + orderId + "&calculationUsageId=-3&calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-4&catalogId=" + catalogId + "&langId=" + langId + "&storeId=" + storeId + "&zipCode=" + zipCode + "&city=" + city + "&state=" + state + "&memberId=" + memberId + "&isDeliveryAddressAdded=" + isDeliveryAddressAdded + "&fromPageName=" + fromPageName + "&updatePrices=0&addressFlag=" + true;

    if (zipCode !== null && state !== null) {
        $.ajax({
            type: "POST",
            url: ajaxUrl,
            async: false,
            success: function(successResponse) {
                if (submitvalue) {
                    $invalidZipCode.empty().removeClass("wcs-note-red");
                    var countryValue = $('#country_value').val();
                    var $wcsShoppingTotalContainer = $('.wcs-shopping-total-container .odr-body');
                    var q = new Date().getTime();
                    $('#orderSummary').load("CalculateView?storeId=" + storeId + "&catalogId=" + catalogId + "&langId=" + langId + "&_=" + q , function() {
                        const selectedShippingMethodElement = $('.rb-shipping-method-container--selected');
                        const selectedShippingMethod = selectedShippingMethodElement.attr('for');
                        const selectedShippingMethodIsPickUpInStore = selectedShippingMethod === 'wcs-shipping-selector-puis';
                        const selectedShippingMethodIsShipFromStore = selectedShippingMethod === 'wcs-shipping-selector-sfs';
                        const canShowExpressPaymentMethodsButtons = !selectedShippingMethodIsPickUpInStore && !selectedShippingMethodIsShipFromStore && !!selectedShippingMethod;
                        ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                        if (window.wcs_config.klarnaExpress.enabled === 'true') {
                            ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');

                            if (canShowExpressPaymentMethodsButtons) {
                                $('#klarna-express-container').show();
                            }
                        }
                        if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                            if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                                ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                            }
                        }
                        $("#subTotal").html($("#subTotalCalc").html());
                        calculate_tax_fn();
                        checkout_giftcard_validation();
                        giftcard_bindevents_fn();
                        dropscrollerFn();
                        select_dropbox_value();
                        expand_dropbox();
                        collapse_dropbox();
                        key_nav_dropdown();
                        tax_submit_fn();
                        apply_promo_link_click();
                        apply_promo_idme_link_click();
                        idme_links();
                        promo_textbox_focusBlur();
                        apply_promotion();
                        remove_promotion();
                        dropscroller_hover_fn();
                        zipcode_pattern($('#zip_code'), countryValue);


                         if (countryCode == "US"){
                            var link='&city='+city,
                            $checkoutnow = $('#checkoutnow'),
                            x=$checkoutnow.attr('href'),
                            y=x.search('&city');
                            if(y!=-1){
                                $checkoutnow.attr('href',x.slice(0,y));
                                var z=$checkoutnow.attr('href');
                                $checkoutnow.attr('href',z.concat(link));
                            }
                            else{
                                $checkoutnow.attr('href',x+link);
                            }
                            if($('#colorado-tax-flag').val()) {
                                $('.colorado-tax-row').removeClass('wcs-hide');
                            }
                        }
                        var olm = new Rayban.OverlayManager({triggerCssClass: 'afterpay-overlay-link'});
                        olm.initAll();
                        console.log("Initialized modal")
                        window.AfrePayExpressInitialization();
                        $('#DCartPageCheckoutExpPaypal').show();
                        $('#afterpayExpress').show();
                    });
                    /* WCS CODE STARTS: MINI CART IN SHOP CART */
                    $('#wcs-cart-container').load("MiniCartView?storeId=" + storeId + "&catalogId=" + catalogId + "&langId=" + langId, function() {
                        add_to_bag_onload();
                        openLinksInNewTab();
                    });
                    //rb-9422
                    if(countryValue== 'US'){
                        $wcsShoppingTotalContainer.overlay();
                        $('#jqueryOverlayLoad').css({'top':'45%','left':'45%'});
                    }
                    $wcsShoppingTotalContainer.load("CalculateDeliveryView?storeId=" + storeId + "&catalogId=" + catalogId + "&langId=" + langId,null,function() {
                        const isChecked = $('#sameAsDeliveryAddress').attr('checked') === 'checked';
                        ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
                        if (window.wcs_config.klarnaExpress.enabled === 'true') {
                            ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
                        }
                        if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
                            if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                                ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
                            }
                        }
                        add_to_bag_onload();
                        openLinksInNewTab();

                        if (countryValue === 'US') {
                            if($('#colorado-tax-flag').val()) {
                                $('.colorado-tax-row').removeClass('wcs-hide');
                            }
                            $wcsShoppingTotalContainer.overlayout();
                            shoprunnerUpdateContent();
                        }


                        // commenting out for RB-22559
                        /* if($(".promo-label").length){
                             $(".promo-val").css("height",$(".promo-label").height());
                        } */
                    });
                    //endof rb-9422

                    var json = $.parseJSON(successResponse);
                    $(json).each(function(i, val) {
                        $.each(val, function(k, v) {
                            if (k == "errorMessage") {
                                errorMessage = v;
                                if (errorMessage !== null && errorMessage !== "") {
                                    $invalidZipCode
                                        .empty()
                                        .addClass("wcs-note-red")
                                        .css("color", "#F00000 ");
                                    if (errorMessage == compareMsg) {
                                        $invalidZipCode.text(errorMessage);
                                    } else {
                                        $invalidZipCode.text(genericErrorMsg);
                                    }
                                }
                            }
                        });
                    });
                }
                giftcard_bindevents_fn();
            },
            error: function(errorResponse) {
                $invalidZipCode.show();
            },
            complete: function(xhr, status) {

            }
        });
    }
    if (zipCode !== "" && zipCode !== "Enter zip code") {

        $(".wcs-shopping-total-tax").removeClass("wcs-shopping-hide");
        $(this).parent().addClass("wcs-shopping-hide");

    }

};

window.calculateAgeUsingDate = function(birth_month,birth_day,birth_year){
    today_date = new Date();
    today_year = today_date.getFullYear();
    today_month = today_date.getMonth();
    today_day = today_date.getDate();
    age = today_year - birth_year;

    if ( today_month < (birth_month - 1))
    {
        age--;
    }
    if (((birth_month - 1) == today_month) && (today_day < birth_day))
    {
        age--;
    }
    return age;
};

window.showHideTooltipTablet = function(){
    var $roxPrescriptionTooltip = $(".rox-prescription-tooltip-wcs");
    if($roxPrescriptionTooltip.is(":visible")) $roxPrescriptionTooltip.hide();
    else $roxPrescriptionTooltip.show();
};

showTooltip = function() {
    const $roxPrescriptionTooltip = $(".rox-prescription-tooltip-wcs");

    if ($roxPrescriptionTooltip.is(":hidden")) {
        $roxPrescriptionTooltip.show();
    }
};

hideTooltip = function() {
    const $roxPrescriptionTooltip = $(".rox-prescription-tooltip-wcs");

    if ($roxPrescriptionTooltip.is(":visible")) {
        $roxPrescriptionTooltip.hide();
    }
};

window.californiaWarning=function(){
    //rb-11432
     var ca_warn_msg_1=$('#ca_warn_msg_1').val(),
        ca_warn_msg_2=$('#ca_warn_msg_2').val(),
        ca_warn_msg_3=$('#ca_warn_msg_3').val(),
        ca_warn_msg_4=$('#ca_warn_msg_4').val();

    $body.append('<div id="ca-advice-overlay" class="wcs-quick-buy-lightbox wcs-hidden" style="width:400px;padding:40px;left: 511.5px; top: 230px;">' +
        '<span class="wcs-close-btn close-ca-advice-overlay"></span>' +
                     '<p><strong style="color:#666">'+ca_warn_msg_3+'</strong> '+ ca_warn_msg_4 +'</p>' +'</div>');

    var $wcsStateDropdownValidation = $('.wcs-state-dropdown-validation');
    var $wcsStateDropdownValidationPraPra = $wcsStateDropdownValidation.parent().parent('.wcs-four.wcs-columns.wcs-alpha');
    if($wcsStateDropdownValidation.val() == 'CA') {
            $('.ca-advice').remove();
            $wcsStateDropdownValidationPraPra.after('<p style="position:absolute;left: 375px;top: 7px;font-size:13px;min-width: 280px;" class="ca-advice">'+ ca_warn_msg_1 +' <a style="text-decoration:underline;" href="#">'+ ca_warn_msg_2 +'</a></p>');

        } else {
            $('.ca-advice').remove();
    }

    // desktop select change check
    $body.on('change', '#WC_State_DropDown', function() {


        if($wcsStateDropdownValidation.val() == 'CA') {
            $('.ca-advice').remove();
            $wcsStateDropdownValidationPraPra.after('<p style="position:absolute;left: 375px;top: 7px;font-size:13px;min-width: 280px;" class="ca-advice">'+ ca_warn_msg_1 +' <a style="text-decoration:underline;" href="#">'+ ca_warn_msg_2 +'</a></p>');

        } else {
            $('.ca-advice').remove();
        }

    });

    $body.on('click', '.ca-advice > a', function(event) {
        event.preventDefault();
        $('.wcs-fadeout-full').css('height', '1156px');
        $('#ca-advice-overlay').show(200);

    });

    $body.on('click', '.close-ca-advice-overlay', function(event) {
        event.preventDefault();
        $('.wcs-fadeout-full').css('height', '0');
        $('#ca-advice-overlay').hide(200);
    });

    //end of rb-11432
};

window.egiftcard=function(){
    var item=$(".wcsitems").text();
    var egift = $("input[name='egift']").val();
    var pgift = $("input[name='pgift']").val();
    var $wcsShippingMode = $('.wcs-shipping-mode');
    if(item.indexOf(egift) !== -1) {
        $wcsShippingMode.addClass('wcs-hide');
    } else {
        $wcsShippingMode.removeClass('wcs-hide');
    }
};

window.lifecodeIframeheight=function(){
    var x=$(".wcs-header").height();
    var y=$("#wcs_footer").height();
    var iframe=$window.height()-x-y;
    $("#lifeCodeApp").height(iframe);
};

window.updateOfferprice=function(){
      if($.cookie('EyeMedLogin') && $("#pageTypeIns") && $("#pageTypeIns").val() === "ShopCart" ){
      } else {
        $('.wcs-shopping-item-content').children().find('.wcs-itemPrice-bag').each(function() {
            var $this = $(this);
            var catId = $this.attr('catentryrel');
            var configurationId = $this.attr('configurationIdrel');
            var strikeVal = $("#wcs-itemPrice_" + catId + "_" + configurationId).val();
            var secodPriceBlock = $this.closest('.wcs-shopping-item-price ').find('.wcs-price-clearance');
            if(secodPriceBlock.length){
              secodPriceBlock.css('display', 'none');
            }
            $this.html(strikeVal);
            var price=$("#wcs-itemPrice_" + catId + "_" + configurationId).val();
            var listprice = $("#wcs-listPrice_" + catId + "_" + configurationId).val();
            var offerprice = $("#wcs-offerPrice_" + catId + "_" + configurationId).val();
            var onsal = $("#OnsaleValue").val();
            if(onsal=="PUBLIC"||onsal=="PRIVATE"){
                if(listprice!=="" && listprice !== undefined && listprice !== null && listprice!="NaN"){
                    $this.append('<div class="wcs-clear-strike-price"><strike>'+listprice+'</strike></div>');
                    $this.addClass("wcs-clear-sp-price");
                }
            }
            //ps changes
            if(offerprice!=="" && offerprice !== undefined && offerprice !== null && offerprice!="NaN" && offerprice!=price){
                $this.html(offerprice);
                $this.append('<div class="wcs-clear-strike-price"><strike>'+price+'</strike></div>');
                $this.addClass("wcs-clear-sp-price");
            }
            //end of ps changes

        });
      }
};

window.updateShippingMessages=function(){
    var flgOrderHasStandard = $('.flgOrderHasStandard').val();
    var flgOrderHasRemix = $('.flgOrderHasRemix').val();
    var flgOrderHasPrescription = $('.flgOrderHasPrescription').val();
    var $standardShippingRemixMsg = $('.standardShippingRemixMsg');
    var $expressShippingRemixMsg = $('.expressShippingRemixMsg');
    var $greenShippingRemixMsg = $('.greenShippingRemixMsg');
    var $expressShippingNotAvailableMsgTitle = $('.expressShippingNotAvailableMsgTitle');
    var $expressShippingNotAvailableMsgBody = $('.expressShippingNotAvailableMsgBody');
    if (flgOrderHasRemix=='false') {
        $standardShippingRemixMsg.html('');
        $expressShippingRemixMsg.html('');
        $greenShippingRemixMsg.html('');
    } else if (flgOrderHasStandard=='false'){
        $('.standardShippingStdMsg').html($('.tmpstandardShippingRemixForStdMsg').val());
        $('.expressShippingStdMsg').html($('.tmpexpressShippingRemixForStdMsg').val());
        $standardShippingRemixMsg.html('');
        $expressShippingRemixMsg.html('');
        $('.greenShippingStdMsg').html($('.tmpgreenShippingRemixForStdMsg').val());
        $greenShippingRemixMsg.html('');

    }

    if (flgOrderHasPrescription=='false' && flgOrderHasRemix=='false') {
        $expressShippingNotAvailableMsgTitle.html('');
        $expressShippingNotAvailableMsgBody.html('');
    } else if (flgOrderHasPrescription=='false' && flgOrderHasRemix=='true') {
        var $expressShippingNotAvailableMsgBodyRemix = $('.expressShippingNotAvailableMsgBodyRemix');
        if ($expressShippingNotAvailableMsgBodyRemix.length) {
            $expressShippingNotAvailableMsgBody.html($expressShippingNotAvailableMsgBodyRemix.val());
        } else {
            $expressShippingNotAvailableMsgTitle.html('');
            $expressShippingNotAvailableMsgBody.html('');
        }
    } else if (flgOrderHasPrescription=='true' && flgOrderHasRemix=='false') {
        var $expressShippingNotAvailableMsgBodyRox = $('.expressShippingNotAvailableMsgBodyRox');
        if ($expressShippingNotAvailableMsgBodyRox.length) {
            $expressShippingNotAvailableMsgBody.html($expressShippingNotAvailableMsgBodyRox.val());
        } else {
            $expressShippingNotAvailableMsgTitle.html('');
            $expressShippingNotAvailableMsgBody.html('');
        }
    }
};

$.fn.wrapInTag = function(opts) {
      var tag = opts.tag || 'strong',
          words = opts.words || [],
          regex = RegExp(words.join('|'), 'gi'),
          replacement = '<'+ tag +'>$&</'+ tag +'>';

      return this.html(function() {
        return $(this).text().replace(regex, replacement);
      });
    };


//hp redesign
window.newsletterRedesign = function(){

    if($('#wcs-newsletter-footer-signup').length > 0) {
      $('#wcs-newsletter-footer-signup').removeAttr('style');
      validateForms($('#wcs-newsletter-footer-signup-form'));
    }

    var currentdate=$.datepicker.formatDate('yy/mm/dd', new Date());
    var storeIdentifierValue = $("#storeIdentifier").val();

    if(storeIdentifierValue!=="USA" || storeIdentifierValue!=="CA"){

        if($('#wcs-newsletter-footer-signup-privacy').length){

            $body.on("click", '.wcs-label-check[for=Confirm]', function(e) {

                if($(this).hasClass("wcs-label-check")) {
                    // Fix to stop click event triggering twice
                    e.preventDefault();
                    var ele = $(this).find('input');
                    if(document.getElementById('wcs-newsletter-footer-signup-privacy').checked){
                      ele.prop('checked', false);
                      ele.parent().removeClass('wcs-c-on');
                    }else{
                      ele.parent().addClass('wcs-c-on');
                      if(ele.parent().hasClass("wcs-privacy-error")){
                        ele.parent().removeClass("wcs-privacy-error");
                        ele.parent().next().hide();
                      }
                      ele.prop('checked', true);
                    }
                }
            });

        }
    }

    $document.on("click",'#wcs-newsletter-footer-signup-submit',function(e){
        e.preventDefault();
        var privacyConfirm;
        var storeIdentifier = $('#storeIdentifier').val();
        var $wcsNewsletterFooterSignupPrivacy = $('#wcs-newsletter-footer-signup-privacy');
        if($wcsNewsletterFooterSignupPrivacy.length){

            if(storeIdentifier === 'USA' || storeIdentifier === 'CA'){
                privacyConfirm = true;
            }else if($wcsNewsletterFooterSignupPrivacy.is(':checked')){
                privacyConfirm = true;
                $wcsNewsletterFooterSignupPrivacy.parent().removeClass('wcs-privacy-error');
            }else{
                privacyConfirm = false;
                $wcsNewsletterFooterSignupPrivacy.parent().addClass('wcs-privacy-error');
            }

        }else{
            privacyConfirm = true;
        }
        $('#wcs-newsletter-footer-signup > .exclamatory').remove();

        if($newsletterEmailField.hasClass("ui-state-valid") && privacyConfirm ){
            var signUpEmail = $newsletterEmailField.val().trim();
            var campaignName = $("#campaignName").val().trim();
            var storeId = $("#storeId").val().trim();
            var langId = $("#langId").val().trim();
            var Confirm = privacyConfirm;
            var pageIdentifier = $("#pageIdentifier").val().trim();

            var $wcsNewsletterFooterSignupForm = $('#wcs-newsletter-footer-signup-form');
            var $columns = $wcsNewsletterFooterSignupForm.find('.wcs-columns');
            var $labelCheck = $wcsNewsletterFooterSignupForm.find('.wcs-label-check');
            var $submit = $('#wcs-newsletter-footer-signup-submit');
            $.ajax({
                type: "POST",
                url: "/SignUpOverlayCmd",
                data: {
                    signUpEmail : signUpEmail,
                    campaignName : campaignName,
                    storeId : storeId,
                    langId : langId,
                    Confirm : Confirm,
                    pageIdentifier : pageIdentifier
                },
                beforeSend : function(){
                    $columns.addClass('is-loading');
                    $wcsNewsletterFooterSignupForm.find('.wcs-loading-input-container, .wcs-loading-text-container').removeClass('wcs-hide');

                    if($html.hasClass('csstransforms')){
                        $submit.addClass('progress-bar');
                    }else{
                        $submit.hide();
                    }
                    $labelCheck.addClass('loaded');

                },
                success: function(result){
                    var isEmailExist = false;
                    if(result != null && result.includes("isEmailExistForPromo")){
                        var obj = JSON.parse(result);
                        isEmailExist = obj.isEmailExistForPromo;
                    }
                    if(isEmailExist){
                        $('.welcome_promo_error').removeClass('permanently-hide');
                        $newsletterEmailField.removeClass('ui-state-valid').addClass('ui-state-error');

                        $columns.removeClass('is-loading');
                        $wcsNewsletterFooterSignupForm.find('.wcs-loading-input-container, .wcs-loading-text-container').addClass('wcs-hide');

                        if($html.hasClass('csstransforms')){
                            $submit.removeClass('progress-bar');
                        }else{
                            $submit.show();
                        }
                        $labelCheck.removeClass('loaded');
                    }
                    else{
                        $wcsNewsletterFooterSignupForm.find('.wcs-loading-text-container').hide();
                        $wcsNewsletterFooterSignupForm.find('.wcs-columns, .wcs-label-check').addClass('loaded');
                        var $signupResponse = $('#wcs-newsletter-footer-signup-response');
                        if($html.hasClass('csstransforms')){
                            $signupResponse.html(result).show().addClass('loaded');
                        }else{
                            $signupResponse.html(result).show().addClass('loadedIE');
                            $newsletterEmailField.hide();
                        }
                        $wcsNewsletterFooterSignupForm.removeAttr('style');
                        $.cookie("already_signed", currentdate, { expires: 90,path: '/' });
                        utagtrackSignupForm();
                    }
                }
            });
            return false;
        }

    });
};

function registerLogin(storeId,evt) {

    var parameters = {};
    parameters.storeId = storeId;
    parameters.logonId = document.getElementById("loginEmail").value;
    parameters.logonPassword = document.getElementById("wcs_logon_password").value;
    if(undefined !== document.user_login_form && null !== document.user_login_form.elements.URL){
        parameters.URL = document.user_login_form.elements.URL.value;
    }
    if(undefined !== document.user_login_form && null !== document.user_login_form.elements.errorViewName){
        parameters.errorViewName = document.user_login_form.elements.errorViewName.value;
    }
    else{
    parameters.errorViewName = "LogonForm";
    }
    if(undefined !== document.user_login_form && null !== document.user_login_form.elements.pageName){
    parameters.pageName = document.user_login_form.elements.pageName.value;
    }
    $.ajax({
        url: "/webapp/wcs/stores/servlet/CSRCustomerLogonCmd",
        type: "POST",
        traditional: true,
        data: parameters,
        dataType: "json",
        async: false,
        success: function(data){
         if (data !== null && data !== "" && data != "undefined") {
            var response = data;
            impersonaterLogin(response);
            evt.preventDefault();
         }
        }
    });

}

function impersonaterLogin(response) {
    var parameters = {};
    parameters.langId = response.langId;
    parameters.orderId = "";
    if(undefined !== document.user_login_form && null !== document.user_login_form.elements.orderId && undefined !== document.user_login_form.elements.orderId){
        parameters.orderId = document.user_login_form.elements.orderId.value;
        }
    parameters.storeId = response.storeId;
    parameters.userId = response.userId;
    parameters.shipModeId = response.shipModeId;
    parameters.onBehalfOfUserId = response.customerId;
    parameters.pageName = response.pageName;
    parameters.errorViewName = response.errorViewName;
    parameters.URL = response.URL;
    var urll=window.location.protocol+"//"+window.location.hostname+"/CSRUserImpersonateCmd?onBehalfOfUserId="+response.customerId+"&pageName="+response.pageName+"&errorViewName="+response.errorViewName+"&orderId="+parameters.orderId+"&URL="+parameters.URL;
    window.location = urll.split("amp;").join("");
}

// TODO: move anywhere but not here!!!
//RB-13457 Analytics changes in new format.
if (!!$('input#orderCancel').length && $('input#orderCancel').val() === "true") {
    tealium_data2track = tealium_data2track || [];

    if (typeof window.analyticsData !== "undefined") window.analyticsData = analyticsData; else window.analyticsData = {};

    // XXX: RB-23528 - Really weird condition... trying to fix almost the syntax.
    if (typeof window.analyticsData === "object") {
        var $userType = $('#userType');
        var $wcsUserId = $('#wcsUserId');

        window.analyticsData.userType = (!!$userType.length) ? $userType.val() : window.analyticsData.userType = "";
        window.analyticsData.userId = (!!$wcsUserId.length) ? $wcsUserId.val() : window.analyticsData.userId = "";

        tealium_data2track.push({
            id: "WCS-D-OrderHistory-OrderCancellation-Submitted",
            data: window.analyticsData,
        });

    } else {
        tealium_data2track.push({
            id: "WCS-D-OrderHistory-OrderCancellation-Error",
            data: window.analyticsData,
        });
    }
}


window.remixLC = function(){
    var urlParameter = window.location.search.match(/CL-XTB/i);
    var remixLCUrlParam = urlParameter ? urlParameter[0].toLowerCase() : '';
    var remixPCPUrl = window.location.search.match(/token/i) ? window.location.href : '';

    if(remixLCUrlParam){
        $('#D_Cart_Top_ShopRunner,#footerWrapper .wcs-primary,#footerWrapper .wcs-socialIconsWrapper,#header_virtualmodel').remove();
        $('#selenium-star,#selenium-glass').parent().remove();
        $.cookie("lc-remix", remixPCPUrl, { path: '/' });
    }
    if(getCookie("lc-remix") !== null){
        $('#glass').parent().remove();
        $('#star').parent().remove();
        $('#support').parent().remove();
        $('#selenium-star,#selenium-glass').parent().remove();
        $('.wcs-title_logo a').attr('href','javascript:void(0);');
        $('#D_Cart_Top_ShopRunner,#footerWrapper .wcs-primary,#footerWrapper .wcs-socialIconsWrapper,#D_CheckoutThankYou_NewAccount_Open,#header_virtualmodel').remove();
        $('.wcs-icon-track-order').parent().remove();
    }
};

//Issue: RB-24879 This logic is implemented to display stock available item at PDP always.
$document.ready(function () {
	var pdpURL = window.location.href.toString();
	var customDefaultPartNumber = $("#customDefaulItemtPartNumberTOSet").val();
	var itemPartnumberPDP = $("#itemPartnumberPDP").val();

	if(itemPartnumberPDP!='' && window.location.href.indexOf(itemPartnumberPDP) > -1) {
	    if(customDefaultPartNumber != null){
	       pdpURL.replace(itemPartnumberPDP, customDefaultPartNumber);
	    }
    }

    setTimeout(function() {
        var $explicit_consent = $('.explicit_consent');
        var $topMessageContainer = $('.wcs-top-message-container');
        var $topShippingBar = $('.wcs-shipping-bar');
        if ($explicit_consent.length) {
            var $targetBlock = $topMessageContainer.length ? $topMessageContainer : $topShippingBar.length ? $topShippingBar : $('#rb-header');
            $targetBlock.before($('#__tealiumGDPRecModal'));
            $explicit_consent.addClass('moved');
        }
    }, 1000);

  // code to send data to visenze
  if ('ProductPage' == $('input[id="pageName"]').val()) {
    if (document.referrer.indexOf('ImageSearchDisplay') !== -1) {
      var appKey = '5c925796ea86eb84bdeb7067672aa63c';
      visearch.set('app_key', appKey);
      $document.on('click', '#D_PDP_Prod_AddToCart', function () {
        var pdp_href = window.location.href;
        if (pdp_href.indexOf('searchId') !== -1 && pdp_href.indexOf('imName') !== -1) {
          var product_id = pdp_href.split('?')[1].split('=')[1];
          var imName = pdp_href.split('?')[2].split('=')[1];
          // send data to visenze
          visearch.send({
            reqid: product_id,
            im_name: imName,
            action: 'add_to_cart',
          });
        }
      });
    }
  }

      // RB-41650 promoCode auto insertion if present in storage
      if (localStorage['promoCodeToApply']) {
        $('#D_CartPage_PromoCode_Input').val(localStorage['promoCodeToApply']);
        $('#D_CartPage_PromoCode_Apply').click();
    }
});

remixLC();

/**
 * countryListView used to fetch all country data html.
 * Using HBS template.
 * window.countriesListData Json data coming from espot.
 */
window.countryListView = function(data){
    $.extend(Handlebars.partials,Rayban.templates);
    this.countryListTemplate = Rayban.templates["country"];
    var extendedData = $.extend({protocol: location.protocol},{hostname: location.host},{ basePath: location.host.indexOf('localhost') >= 0 ? '/webapp/wcs/stores/servlet' : ''}, data);
    $('.countryList').append(this.countryListTemplate(extendedData));
};
/**
 * countriesListData Json data
 * From DESK_FOOTER_CHANGE_COUNTRY
 */
if(window.countriesListData){
    countryListView(window.countriesListData);
}

/**
 * Function used for multiple position in a single or in different page.
 * Main Params
 * @author kkumarmondal
 * @mainClassDiv, @draggableContentBox
 */
window.customMoreOrLess = function(mainClassDiv, draggableContentBox) {

    var adjustheight = 90;
    var moreText = $(".more-text").val();
    var lessText = $(".less-text").val();

    $( "."+mainClassDiv).append('<a href="#" class="dg-adjust">'+lessText+'</a>');
    var $adjustLink = $("a.dg-adjust");
    $adjustLink.html(moreText);
    $adjustLink.attr("aria-label", moreText + " info");

    $("."+mainClassDiv).addClass('with-more');

    $adjustLink.toggle(function() {
        var $this = $(this);
        $this.parents("."+mainClassDiv).removeClass('with-more').addClass('with-less');
        // Hide the [...] when expanded
        $this.parents("div:first").find("span.continued").css('display', 'none');
        $this.addClass("adjust-readless").html(lessText);
    }, function() {
        var $this = $(this);
        $this.parents("."+mainClassDiv).removeClass('with-less').addClass('with-more');
        $this.html(moreText);
        $this.removeClass("adjust-readless");
    });
};

window.customMoreLessInitialize = function () {
    //initialize
    var $descriptionMoreLess = $('.description-more-less');
    var $benefitMoreLess = $('.benefit-more-less');
    var draggableDescHeight = $descriptionMoreLess.outerHeight() || 0;
    var draggableBenefitHeight = $benefitMoreLess.outerHeight() || 0;

    /**
     * call the function by checking the height
     * @author kkumarmondal
     * @mainClassDiv(descriptionContentBox), @draggableContentBox(draggableContentBox)
     */
    if (draggableDescHeight > 30) {
        window.customMoreOrLess('description-more-less', 'draggable-content-box');
    }
    if (draggableBenefitHeight > 30) {
        window.customMoreOrLess('benefit-more-less', 'draggable-content-box');
    }
    if($.trim( $descriptionMoreLess.find('.draggable-content-box').html() ).length == 0 ) {
        $descriptionMoreLess.find('.dg-adjust').hide();
        $descriptionMoreLess.parent().hide();
    }
    if($.trim( $benefitMoreLess.find('.draggable-content-box').html() ).length == 0 ) {
        $benefitMoreLess.find('.dg-adjust').hide();
        $benefitMoreLess.parent().hide();
    }
}

window.sfsMessageChecking = function(flag) {
    const selectedShipping = $('.rb-shipping-method-container--selected');
    const sfsMessageItem = $('#sfs-warnig-message');
    const showCondition = selectedShipping.attr('for') === 'wcs-shipping-selector-sfs' && $('#rb-ship-from-store-autocomplete').val();

    if(flag || !showCondition) {
        sfsMessageItem.addClass('wcs-hide');
    }else {
        sfsMessageItem.removeClass('wcs-hide');
    }
}

window.checkDeliveryDateFromZip = function(zipCode) {
    const firstCallUrl = '/AjaxResolveFFMCenter';
    const eddCallURL = '/wcs/resources/store/'+ $('#storeId').val() +'/promisedLeadTime/edd';

    const crypto = getCrypto(eddCallURL,zipCode);

    const eddCallPayload = {
        zipCode: zipCode.toUpperCase(),
        orderId: $('input[name="orderId"]').eq(0).val(),
        crypto: crypto,
    }

    const payload = {
        zipCode: zipCode.toUpperCase(),
        orderId: $('input[name="orderId"]').eq(0).val(),
    }

    //second call
    function updateEDD() {
        //add additional parameter for second call
        payload.langId = $('#langId').eq(0).val();

        $.ajax({
            type: 'GET',
            url: eddCallURL,
            data: eddCallPayload,
            async: true,
            success: function(data) {
                const itemsArray = data.orderLeadTimeJSON.orderItems;
                const hiddenClass = 'wcs-hide';
                const messageHideClass = 'wcs-hidden';
                $.each(itemsArray, function(i, currItem) {
                    const dateHolderItem = $('[data-order-id="'+ currItem.orderItemId +'"]');
                    const dateWrapper = dateHolderItem.find('.date-wrapper');
                    const currDateAttr = dateWrapper.attr('data-current-edd');
                    const errorMessage = dateHolderItem.find('.error-date-message');
                    const inputParent = $('#address_line_one').parent();
                    const errorTextBlock = inputParent.find('.rb-fieldrow__helper--error');
                    const inputErrorText = $('#date-error-text').val();
                    const inputSuccessText = $('#date-success-text').val();
                    const nextStepBtn = $('.ct-button');
                    if(currItem.status === 'available') {
                        errorMessage.addClass(messageHideClass);
                        if(currDateAttr !== currItem.deliveryPromiseDate_raw) {
                            dateWrapper.html(currItem.deliveryPromiseDate);
                            dateWrapper.removeClass(hiddenClass);
                            errorTextBlock.addClass(hiddenClass);
                            inputParent.removeClass('rb-invalidrow');
                            nextStepBtn.prop('disabled', false);
                            dateWrapper.attr('data-current-edd', currItem.deliveryPromiseDate_raw);
                            if(!inputParent.attr('data-message-updated')) {
                                const helperItem = inputParent.find('.rb-fieldrow__helper').not('.rb-fieldrow__helper--error');
                                if(helperItem.length) {
                                    helperItem.text(inputSuccessText);
                                }else {
                                    inputParent.append($('<span class="rb-fieldrow__helper">'+ inputSuccessText +'</span>'));
                                }
                                inputParent.attr('data-message-updated', true);
                            }
                        }
                    } else {
                        if(currItem.errorMessage) {
                            nextStepBtn.prop('disabled', true);
                            dateWrapper.addClass(hiddenClass);
                            errorMessage.find('span').text(currItem.errorMessage);
                            errorMessage.removeClass(messageHideClass);
                            errorTextBlock.removeClass(hiddenClass);
                            errorTextBlock.text(inputErrorText);
                            inputParent.addClass('rb-invalidrow');
                            dateWrapper.attr('data-current-edd', ' ');
                        }
                    }
                });
            },
            error: function(e) {
                console.log(e);
            }
        });
    }

    //first call
    $.ajax({
        type: 'GET',
        url: firstCallUrl,
        data: payload,
        async: true,
        success: function() {
            if($('#control-tower-enabled').val() === 'true') {
                updateEDD();
            }
        },
        error: function(e) {
            console.log(e);
        }
    });

    function getCrypto(eddCallURL, zipCode) {
        const isGetCryptoDefined = !!ExposedRayBanApi && !!ExposedRayBanApi.getCrypto;

        const orderId = $('input[name="orderId"]').eq(0).val();
        const storeId = $('#storeId').val();
        const uppercaseZipCode = zipCode.toUpperCase();

        const salt = 'wcsCTEddServ | ' + location.origin + eddCallURL + '?zipCode=' + uppercaseZipCode + '&orderId=' + orderId;
        const pattern = storeId + ' ' + uppercaseZipCode + ' ' + orderId + ' ' + uppercaseZipCode + ' ' + storeId;

        const params = {
            pattern: pattern,
            salt: salt,
        }
        const crypto = isGetCryptoDefined ? ExposedRayBanApi.getCrypto(params) : '';

        return crypto;
    }
}



window.checkQuebecStatusForEyewearProtection = function(id) {
    const canShowQuebecErrorForEyewearProtection = window.canShowQuebecErrorForEyewearProtection(id);

    if (canShowQuebecErrorForEyewearProtection) {
        if(id === 'PU_State_DropDown-bill') {
            window.showQuebecErrorForEyewearProtectionPickupInStore();
        } else {
            window.showQuebecErrorForEyewearProtection(id);
        }
    }
}

window.canShowQuebecErrorForEyewearProtection = function(id) {
    const storeIdentifierValue = $("#storeIdentifier").val();
    const stateDropdowValue = $('#' + id).val()
    const quebecValue = 'QC';

    const isInDeliveryPage = wcs_config && wcs_config.viewTaskName === 'DeliveryDetailsView';
    const isCanada = storeIdentifierValue === 'CA';
    const isQuebec = stateDropdowValue === quebecValue;
    const isEyewearProtectionInOrder = $('#isCartWithEpp').val() === 'true';
    const isPickUpDisabledInQuebecForEyewearProtection = $('#isEppQuebecDeliveryEnabled').val() !== 'true';

    const canShowQuebecErrorForEyewearProtection = isInDeliveryPage && isCanada && isQuebec && isEyewearProtectionInOrder && isPickUpDisabledInQuebecForEyewearProtection;
    return canShowQuebecErrorForEyewearProtection;
}

window.showQuebecErrorForEyewearProtection = function(id) {
    const isBilling = id === 'WC_State_DropDown-bill';
    const addressId = isBilling ? 'delivery_information #WC_PaymentInfoForm_address1_1' : 'address_line_one';

    const address = $('#' + addressId);
    const zipCode = isBilling ? $('#zip_code-bill') : $('#zip_code');
    const city = isBilling ? $('#WC_PaymentInfoForm_city_1') : $('#city');
    const state = $('#' + id);

    manageInputStateClass(address, false, null);
    manageInputStateClass(zipCode, false, null);
    manageInputStateClass(city, false, null);
    manageInputStateClass(state, false, null);

    showQuebecAddressErrorForEyewearProtection(addressId);
}

showQuebecAddressErrorForEyewearProtection = function(addressId) {
    const address = $('#' + addressId);
    const parent = address.parent();
    const errorElement = parent.find('.utagpiimask.rb-fieldrow__helper.rb-fieldrow__helper--error');
    errorElement.removeClass('wcs-hide');
}


window.showQuebecErrorForEyewearProtectionPickupInStore = function() {
    const address =  $('#WC_PaymentInfoForm_address1_1');
    const zipCode = $('#pickup-zip_code-bill');
    const city =  $('#WC_PaymentInfoForm_city_1');
    const state = $('#PU_State_DropDown-bill');

    manageInputStateClass(address, false, null);
    manageInputStateClass(zipCode, false, null);
    manageInputStateClass(city, false, null);
    manageInputStateClass(state, false, null);
}



if(window.customMoreLessInitialize){
    window.customMoreLessInitialize();
}

$window.on('load', function(){
    $('#address_line_one').attr('autocomplete','street-address');
    if(!$.cookie('already_signed')){
        window.newsletterRedesign();
    }
    $("#rb-nw-bredcum .rb-nw-back").click(function() {
    	window.history.back();
    });
    if ( $('.rb-nw-cart-container').length ) {
    $("body").on('DOMSubtreeModified', ".wcs-shopping-item-qtyCount", function() {
        var cartItemsQty = 0;
        $('.wcs-shopping-item-qtyCount').each(function(index, item) {
            cartItemsQty += parseInt($(item).text(), 10) || 0;
        });
        $('.rb-header__action--cart .rb-badge').html(cartItemsQty);
    });
    }
    $(function(){
    	$("#modal-launcher, #modal-background, #modal-close").click(function () {
    		$("#modal-content,#modal-background").toggleClass("active");
    	});
    });
    $(".rb-fieldrow input" ).focusout(function() {
    	if($(this).val() != '' && $(this).attr('placeholder')!= ''){
    		$(this).parent().addClass('rb-floating');
	    }else{
	    	$(this).parent().removeClass('rb-floating');
	    }
    	if($(this).parent().hasClass('rb-invalidrow')){
    		$(this).parent().children('.wcs-error-message').addClass('wcs-inline-block')
    	}
    })
    $('.wcs-fadeout-full, .wcs-close-btn').click(function(){
        $('html').css('overflow','');
    });

    $('.rb-create-modal-body .wcs-close-btn').click(function(){
        $('.wcs-register-with-us').hide();
    });

    $('#wcs-account-edit-form .wcs-modal-box ').click(function(){
        $('html').css('overflow','hidden');
    });
    window.updateOfferprice();
});


$('.qty-stock-msg').click(function(){
    $('.qty-stock-msg').addClass("wcs-hide");
    $('.selenium-shopping-item-qtyPlus').removeClass('disable');
});

function validateGiftCard() {
  $('.gift_card_form input').off('change keyup paste blur').on('change keyup paste blur', function(e) {
    var $target = $(e.currentTarget);
    var pattRegX = new RegExp($target.attr('pattern'));
    var testVal = pattRegX.test($target.val());
    if(testVal) {
      $target.closest('.rb-fieldrow').removeClass('rb-invalidrow').addClass('rb-validrow');
      hide_error($target);
    } else {
      $target.closest('.rb-fieldrow').removeClass('rb-validrow').addClass('rb-invalidrow');
      show_error($target);
    };
  });
}

if (wcs_config.pageName === 'TrackOrder') {
    $('#wcs-track-order').submit(function () {
        tealium_data2track.push({
            id: 'Click',
            Tracking_Type: 'hiddenaction',
            Click_FocusElement: this,
            data_element_id: 'X_MyAccount_CheckOrderStatus_Apply',
        });
    });
}

if (wcs_config.viewTaskName === 'DeliveryDetailsView') {
    $('#ajax_login_submit').click(function () {
        tealium_data2track.push({
            id: 'Click',
            Tracking_Type: 'hiddenaction',
            data_element_id: 'X_X_Login_Login',
            Click_FocusElement: $(this).closest('form'),
        });
    });
}

if (wcs_config.viewTaskName === 'PrescriptionMethodView') {
    $(".prescription-method-container form").each(function () {
        $(this).submit(function () {
            tealium_data2track.push({
                id: 'Click',
                Tracking_Type: 'hiddenaction',
                Click_FocusElement: $(this).closest('form'),
                data_element_id: document.referrer.indexOf('Guest') >= 0 ? 'X_OrderStatus_UploadPrescription_Confirm' : 'X_Account_MyOrders_UploadPrescription_Confirm',
            });
        });
    });
}

if (wcs_config.viewTaskName === 'MyOrdersView' || wcs_config.viewTaskName === 'MyOrderDetailsView') {
    var forms=document.querySelectorAll("form[id='wcs-track-returnOrder']");
    for (const form of forms) {
        $(form).submit(function () {
            tealium_data2track.push({
                id: 'Click',
                Tracking_Type: 'hiddenaction',
                Click_FocusElement: this,
                data_element_id: 'X_X_OrderHystory_ReturnDetails',
            });
        });
    }
}


function klarnaModalFocus(modal, source) {
    const closeButton = modal.find('.wcs-close-btn');
    const focusableElements = modal.find('input:visible, select:visible, textarea:visible, button:visible');
    const firstFocusable = focusableElements.first(); 
    const lastFocusable = focusableElements.last(); 

    if (closeButton.length) {
        closeButton.focus();
    }

    modal.off('keydown').on('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            closeButton.trigger('click');
            source.focus();
        }

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === firstFocusable[0]) {
                    event.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable[0]) {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            }
        }
    });

    closeButton.off('keydown').on('keydown', function(event) {
        if (event.key === 'Enter') {
            setTimeout(function() {
                source.focus();
            }, 0);
        }
    });
}

$('#wcs-klarna-popup-link').on('click', function() {
    setTimeout(() => {
        const modal = $('#wcs-klarna-popup-div');
        if (modal) {
            klarnaModalFocus(modal, this);
        }
    }, 10);
});

$('.wcs-modal-box').on('click', function() {
    setTimeout(() => {
        const modal = getVisibleModal();
        if (modal) {
            setupModalFocus(modal, this);
        }
    }, 10);
});

function setupModalFocus(modal, source) {
	const focusableElements = modal.find('input:visible, select, textarea, button');
	const firstFocusable = focusableElements.eq(1);
	const lastFocusable = focusableElements.last();
	const closeButton = focusableElements.eq(0);
	closeButton.focus();

	modal.off('keydown').on('keydown', function(event) {
		if(event.key === 'Escape' || event.key === 'Esc') {
			$('.wcs-close-btn').trigger('click');
			source.focus();
		}
		if (event.key === 'Tab') {
			if (event.shiftKey) {
				if (document.activeElement === firstFocusable[0] || document.activeElement === closeButton[0]) {
					event.preventDefault();
					lastFocusable.focus();
				}
			} else {
				if (document.activeElement === lastFocusable[0]) {
					event.preventDefault();
					closeButton.focus();
				}
			}
		}
	});

    modal.find('.wcs-close-btn').off('keydown').on('keydown', function(event) {
        if(event.key === 'Enter') {
             setTimeout(function() {
                 source.focus();
             }, 0);
        }
	});

}

function getVisibleModal() {
    if ($('#wcs_myDetails_changeEmail').is(':visible')) {
        return $('#wcs_myDetails_changeEmail');
    }
    if ($('#wcs_myDetails_changePass').is(':visible')) {
        return $('#wcs_myDetails_changePass');
    }
    if ($('#add-address-modal').is(':visible')) {
        return $('#add-address-modal');
    }
    if ($('#wcs_myDetails_editHomeAddress').is(':visible')) {
        return $('#wcs_myDetails_editHomeAddress');
    }
    return null;
}
